var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704, _path1705, _path1706, _path1707, _path1708, _path1709, _path1710, _path1711, _path1712, _path1713, _path1714, _path1715, _path1716, _path1717, _path1718, _path1719, _path1720, _path1721, _path1722, _path1723, _path1724, _path1725, _path1726, _path1727, _path1728, _path1729, _path1730, _path1731, _path1732, _path1733, _path1734, _path1735, _path1736, _path1737, _path1738, _path1739, _path1740, _path1741, _path1742, _path1743, _path1744, _path1745, _path1746, _path1747, _path1748, _path1749, _path1750, _path1751, _path1752, _path1753, _path1754, _path1755, _path1756, _path1757, _path1758, _path1759, _path1760, _path1761, _path1762, _path1763, _path1764, _path1765, _path1766, _path1767, _path1768, _path1769, _path1770, _path1771, _path1772, _path1773, _path1774, _path1775, _path1776, _path1777, _path1778, _path1779, _path1780, _path1781, _path1782, _path1783, _path1784, _path1785, _path1786, _path1787, _path1788, _path1789, _path1790, _path1791, _path1792, _path1793, _path1794, _path1795, _path1796, _path1797, _path1798, _path1799, _path1800, _path1801, _path1802, _path1803, _path1804, _path1805, _path1806, _path1807, _path1808, _path1809, _path1810, _path1811, _path1812, _path1813, _path1814, _path1815, _path1816, _path1817, _path1818, _path1819, _path1820, _path1821, _path1822, _path1823, _path1824, _path1825, _path1826, _path1827, _path1828, _path1829, _path1830, _path1831, _path1832, _path1833, _path1834, _path1835, _path1836, _path1837, _path1838, _path1839, _path1840, _path1841, _path1842, _path1843, _path1844, _path1845, _path1846, _path1847, _path1848, _path1849, _path1850, _path1851, _path1852, _path1853, _path1854, _path1855, _path1856, _path1857, _path1858, _path1859, _path1860, _path1861, _path1862, _path1863, _path1864, _path1865, _path1866, _path1867, _path1868, _path1869, _path1870, _path1871, _path1872, _path1873, _path1874, _path1875, _path1876, _path1877, _path1878, _path1879, _path1880, _path1881, _path1882, _path1883, _path1884, _path1885, _path1886, _path1887, _path1888, _path1889, _path1890, _path1891, _path1892, _path1893, _path1894, _path1895, _path1896, _path1897, _path1898, _path1899, _path1900, _path1901, _path1902, _path1903, _path1904, _path1905, _path1906, _path1907, _path1908, _path1909, _path1910, _path1911, _path1912, _path1913, _path1914, _path1915, _path1916, _path1917, _path1918, _path1919, _path1920, _path1921, _path1922, _path1923, _path1924, _path1925, _path1926, _path1927, _path1928, _path1929, _path1930, _path1931, _path1932, _path1933, _path1934, _path1935, _path1936, _path1937, _path1938, _path1939, _path1940, _path1941, _path1942, _path1943, _path1944, _path1945, _path1946, _path1947, _path1948, _path1949, _path1950, _path1951, _path1952, _path1953, _path1954, _path1955, _path1956, _path1957, _path1958, _path1959, _path1960, _path1961, _path1962, _path1963, _path1964, _path1965, _path1966, _path1967, _path1968, _path1969, _path1970, _path1971, _path1972, _path1973, _path1974, _path1975, _path1976, _path1977, _path1978, _path1979, _path1980, _path1981, _path1982, _path1983, _path1984, _path1985, _path1986, _path1987, _path1988, _path1989, _path1990, _path1991, _path1992, _path1993, _path1994, _path1995, _path1996, _path1997, _path1998, _path1999, _path2000, _path2001, _path2002, _path2003, _path2004, _path2005, _path2006, _path2007, _path2008, _path2009, _path2010, _path2011, _path2012, _path2013, _path2014, _path2015, _path2016, _path2017, _path2018, _path2019, _path2020, _path2021, _path2022, _path2023, _path2024, _path2025, _path2026, _path2027, _path2028, _path2029, _path2030, _path2031, _path2032, _path2033, _path2034, _path2035, _path2036, _path2037, _path2038, _path2039, _path2040, _path2041, _path2042, _path2043, _path2044, _path2045, _path2046, _path2047, _path2048, _path2049, _path2050, _path2051, _path2052, _path2053, _path2054, _path2055, _path2056, _path2057, _path2058, _path2059, _path2060, _path2061, _path2062, _path2063, _path2064, _path2065, _path2066, _path2067, _path2068, _path2069, _path2070, _path2071, _path2072, _path2073, _path2074, _path2075, _path2076, _path2077, _path2078, _path2079, _path2080, _path2081, _path2082, _path2083, _path2084, _path2085, _path2086, _path2087, _path2088, _path2089, _path2090, _path2091, _path2092, _path2093, _path2094, _path2095, _path2096, _path2097, _path2098, _path2099, _path2100, _path2101, _path2102, _path2103, _path2104, _path2105, _path2106, _path2107, _path2108, _path2109, _path2110, _path2111, _path2112, _path2113, _path2114, _path2115, _path2116, _path2117, _path2118, _path2119, _path2120, _path2121, _path2122, _path2123, _path2124, _path2125, _path2126, _path2127, _path2128, _path2129, _path2130, _path2131, _path2132, _path2133, _path2134, _path2135, _path2136, _path2137, _path2138, _path2139, _path2140, _path2141, _path2142, _path2143, _path2144, _path2145, _path2146, _path2147, _path2148, _path2149, _path2150, _path2151, _path2152, _path2153, _path2154, _path2155, _path2156, _path2157, _path2158, _path2159, _path2160, _path2161, _path2162, _path2163, _path2164, _path2165, _path2166, _path2167, _path2168, _path2169, _path2170, _path2171, _path2172, _path2173, _path2174, _path2175, _path2176, _path2177, _path2178, _path2179, _path2180, _path2181, _path2182, _path2183, _path2184, _path2185, _path2186, _path2187, _path2188, _path2189, _path2190, _path2191, _path2192, _path2193, _path2194, _path2195, _path2196, _path2197, _path2198, _path2199, _path2200, _path2201, _path2202, _path2203, _path2204, _path2205, _path2206, _path2207, _path2208, _path2209, _path2210, _path2211, _path2212, _path2213, _path2214, _path2215, _path2216, _path2217, _path2218, _path2219, _path2220, _path2221, _path2222, _path2223, _path2224, _path2225, _path2226, _path2227, _path2228, _path2229, _path2230, _path2231, _path2232, _path2233, _path2234, _path2235, _path2236, _path2237, _path2238, _path2239, _path2240, _path2241, _path2242, _path2243, _path2244, _path2245, _path2246, _path2247, _path2248, _path2249, _path2250, _path2251, _path2252, _path2253, _path2254, _path2255, _path2256, _path2257, _path2258, _path2259, _path2260, _path2261, _path2262, _path2263, _path2264, _path2265, _path2266, _path2267, _path2268, _path2269, _path2270, _path2271, _path2272, _path2273, _path2274, _path2275, _path2276, _path2277, _path2278, _path2279, _path2280, _path2281, _path2282, _path2283, _path2284, _path2285, _path2286, _path2287, _path2288, _path2289, _path2290, _path2291, _path2292, _path2293, _path2294, _path2295, _path2296, _path2297, _path2298, _path2299, _path2300, _path2301, _path2302, _path2303, _path2304, _path2305, _path2306, _path2307, _path2308, _path2309, _path2310, _path2311, _path2312, _path2313, _path2314, _path2315, _path2316, _path2317, _path2318, _path2319, _path2320, _path2321, _path2322, _path2323, _path2324, _path2325, _path2326, _path2327, _path2328, _path2329, _path2330, _path2331, _path2332, _path2333, _path2334, _path2335, _path2336, _path2337, _path2338, _path2339, _path2340, _path2341, _path2342, _path2343, _path2344, _path2345, _path2346, _path2347, _path2348, _path2349, _path2350, _path2351, _path2352, _path2353, _path2354, _path2355, _path2356, _path2357, _path2358, _path2359, _path2360, _path2361, _path2362, _path2363, _path2364, _path2365, _path2366, _path2367, _path2368, _path2369, _path2370, _path2371, _path2372, _path2373, _path2374, _path2375, _path2376, _path2377, _path2378, _path2379, _path2380, _path2381, _path2382, _path2383, _path2384, _path2385, _path2386, _path2387, _path2388, _path2389, _path2390, _path2391, _path2392, _path2393, _path2394, _path2395, _path2396, _path2397, _path2398, _path2399, _path2400, _path2401, _path2402, _path2403, _path2404, _path2405, _path2406, _path2407, _path2408, _path2409, _path2410, _path2411, _path2412, _path2413, _path2414, _path2415, _path2416, _path2417, _path2418, _path2419, _path2420, _path2421, _path2422, _path2423, _path2424, _path2425, _path2426, _path2427, _path2428, _path2429, _path2430, _path2431, _path2432, _path2433, _path2434, _path2435, _path2436, _path2437, _path2438, _path2439, _path2440, _path2441, _path2442, _path2443, _path2444, _path2445, _path2446, _path2447, _path2448, _path2449, _path2450, _path2451, _path2452, _path2453, _path2454, _path2455, _path2456, _path2457, _path2458, _path2459, _path2460, _path2461, _path2462, _path2463, _path2464, _path2465, _path2466, _path2467, _path2468, _path2469, _path2470, _path2471, _path2472, _path2473, _path2474, _path2475, _path2476, _path2477, _path2478, _path2479, _path2480, _path2481, _path2482, _path2483, _path2484, _path2485, _path2486, _path2487, _path2488, _path2489, _path2490, _path2491, _path2492, _path2493, _path2494, _path2495, _path2496, _path2497, _path2498, _path2499, _path2500, _path2501, _path2502, _path2503, _path2504, _path2505, _path2506, _path2507, _path2508, _path2509, _path2510, _path2511, _path2512, _path2513, _path2514, _path2515, _path2516, _path2517, _path2518, _path2519, _path2520, _path2521, _path2522, _path2523, _path2524, _path2525, _path2526, _path2527, _path2528, _path2529, _path2530, _path2531, _path2532, _path2533, _path2534, _path2535, _path2536, _path2537, _path2538, _path2539, _path2540, _path2541, _path2542, _path2543, _path2544, _path2545, _path2546, _path2547, _path2548, _path2549, _path2550, _path2551, _path2552, _path2553, _path2554, _path2555, _path2556, _path2557, _path2558, _path2559, _path2560, _path2561, _path2562, _path2563, _path2564, _path2565, _path2566, _path2567, _path2568, _path2569, _path2570, _path2571, _path2572, _path2573, _path2574, _path2575, _path2576, _path2577, _path2578, _path2579, _path2580, _path2581, _path2582, _path2583, _path2584, _path2585, _path2586, _path2587, _path2588, _path2589, _path2590, _path2591, _path2592, _path2593, _path2594, _path2595, _path2596, _path2597, _path2598, _path2599, _path2600, _path2601, _path2602, _path2603, _path2604, _path2605, _path2606, _path2607, _path2608, _path2609, _path2610, _path2611, _path2612, _path2613, _path2614, _path2615, _path2616, _path2617, _path2618, _path2619, _path2620, _path2621, _path2622, _path2623, _path2624, _path2625, _path2626, _path2627, _path2628, _path2629, _path2630, _path2631, _path2632, _path2633, _path2634, _path2635, _path2636, _path2637, _path2638, _path2639, _path2640, _path2641, _path2642, _path2643, _path2644, _path2645, _path2646, _path2647, _path2648, _path2649, _path2650, _path2651, _path2652, _path2653, _path2654, _path2655, _path2656, _path2657, _path2658, _path2659, _path2660, _path2661, _path2662, _path2663, _path2664, _path2665, _path2666, _path2667, _path2668, _path2669, _path2670, _path2671, _path2672, _path2673, _path2674, _path2675, _path2676, _path2677, _path2678, _path2679, _path2680, _path2681, _path2682, _path2683, _path2684, _path2685, _path2686, _path2687, _path2688, _path2689, _path2690, _path2691, _path2692, _path2693, _path2694, _path2695, _path2696, _path2697, _path2698, _path2699, _path2700, _path2701, _path2702, _path2703, _path2704, _path2705, _path2706, _path2707, _path2708, _path2709, _path2710, _path2711, _path2712, _path2713, _path2714, _path2715, _path2716, _path2717, _path2718, _path2719, _path2720, _path2721, _path2722, _path2723, _path2724, _path2725, _path2726, _path2727, _path2728, _path2729, _path2730, _path2731, _path2732, _path2733, _path2734, _path2735, _path2736, _path2737, _path2738, _path2739, _path2740, _path2741, _path2742, _path2743, _path2744, _path2745, _path2746, _path2747, _path2748, _path2749, _path2750, _path2751, _path2752, _path2753, _path2754, _path2755, _path2756, _path2757, _path2758, _path2759, _path2760, _path2761, _path2762, _path2763, _path2764, _path2765, _path2766, _path2767, _path2768, _path2769, _path2770, _path2771, _path2772, _path2773, _path2774, _path2775, _path2776, _path2777, _path2778, _path2779, _path2780, _path2781, _path2782, _path2783, _path2784, _path2785, _path2786, _path2787, _path2788, _path2789, _path2790, _path2791, _path2792, _path2793, _path2794, _path2795, _path2796, _path2797, _path2798, _path2799, _path2800, _path2801, _path2802, _path2803, _path2804, _path2805, _path2806, _path2807, _path2808, _path2809, _path2810, _path2811, _path2812, _path2813, _path2814, _path2815, _path2816, _path2817, _path2818, _path2819, _path2820, _path2821, _path2822, _path2823, _path2824, _path2825, _path2826, _path2827, _path2828, _path2829, _path2830, _path2831, _path2832, _path2833, _path2834, _path2835, _path2836, _path2837, _path2838, _path2839, _path2840, _path2841, _path2842, _path2843, _path2844, _path2845, _path2846, _path2847, _path2848, _path2849, _path2850, _path2851, _path2852, _path2853, _path2854, _path2855, _path2856, _path2857, _path2858, _path2859, _path2860, _path2861, _path2862, _path2863, _path2864, _path2865, _path2866, _path2867, _path2868, _path2869, _path2870, _path2871, _path2872, _path2873, _path2874, _path2875, _path2876, _path2877, _path2878, _path2879, _path2880, _path2881, _path2882, _path2883, _path2884, _path2885, _path2886, _path2887, _path2888, _path2889, _path2890, _path2891, _path2892, _path2893, _path2894, _path2895, _path2896, _path2897, _path2898, _path2899, _path2900, _path2901, _path2902, _path2903, _path2904, _path2905, _path2906, _path2907, _path2908, _path2909, _path2910, _path2911, _path2912, _path2913, _path2914, _path2915, _path2916, _path2917, _path2918, _path2919, _path2920, _path2921, _path2922, _path2923, _path2924, _path2925, _path2926, _path2927, _path2928, _path2929, _path2930, _path2931, _path2932, _path2933, _path2934, _path2935, _path2936, _path2937, _path2938, _path2939, _path2940, _path2941, _path2942, _path2943, _path2944, _path2945, _path2946, _path2947, _path2948, _path2949, _path2950, _path2951, _path2952, _path2953, _path2954, _path2955, _path2956, _path2957, _path2958, _path2959, _path2960, _path2961, _path2962, _path2963, _path2964, _path2965, _path2966, _path2967, _path2968, _path2969, _path2970, _path2971, _path2972, _path2973, _path2974, _path2975, _path2976, _path2977, _path2978, _path2979, _path2980, _path2981, _path2982, _path2983, _path2984, _path2985, _path2986, _path2987, _path2988, _path2989, _path2990, _path2991, _path2992, _path2993, _path2994, _path2995, _path2996, _path2997, _path2998, _path2999, _path3000, _path3001, _path3002, _path3003, _path3004, _path3005, _path3006, _path3007, _path3008, _path3009, _path3010, _path3011, _path3012, _path3013, _path3014, _path3015, _path3016, _path3017, _path3018, _path3019, _path3020, _path3021, _path3022, _path3023, _path3024, _path3025, _path3026, _path3027, _path3028, _path3029, _path3030, _path3031, _path3032, _path3033, _path3034, _path3035, _path3036, _path3037, _path3038, _path3039, _path3040, _path3041, _path3042, _path3043, _path3044, _path3045, _path3046, _path3047, _path3048, _path3049, _path3050, _path3051, _path3052, _path3053, _path3054, _path3055, _path3056, _path3057, _path3058, _path3059, _path3060, _path3061, _path3062, _path3063, _path3064, _path3065, _path3066, _path3067, _path3068, _path3069, _path3070, _path3071, _path3072, _path3073, _path3074, _path3075, _path3076, _path3077, _path3078, _path3079, _path3080, _path3081, _path3082, _path3083, _path3084, _path3085, _path3086, _path3087, _path3088, _path3089, _path3090, _path3091, _path3092, _path3093, _path3094, _path3095, _path3096, _path3097, _path3098, _path3099, _path3100, _path3101, _path3102, _path3103, _path3104, _path3105, _path3106, _path3107, _path3108, _path3109, _path3110, _path3111, _path3112, _path3113, _path3114, _path3115, _path3116, _path3117, _path3118, _path3119, _path3120, _path3121, _path3122, _path3123, _path3124, _path3125, _path3126, _path3127, _path3128, _path3129, _path3130, _path3131, _path3132, _path3133, _path3134, _path3135, _path3136, _path3137, _path3138, _path3139, _path3140, _path3141, _path3142, _path3143, _path3144, _path3145, _path3146, _path3147, _path3148, _path3149, _path3150, _path3151, _path3152, _path3153, _path3154, _path3155, _path3156, _path3157, _path3158, _path3159, _path3160, _path3161, _path3162, _path3163, _path3164, _path3165, _path3166, _path3167, _path3168, _path3169, _path3170, _path3171, _path3172, _path3173, _path3174, _path3175, _path3176, _path3177, _path3178, _path3179, _path3180, _path3181, _path3182, _path3183, _path3184, _path3185, _path3186, _path3187, _path3188, _path3189, _path3190, _path3191, _path3192, _path3193, _path3194, _path3195, _path3196, _path3197, _path3198, _path3199, _path3200, _path3201, _path3202, _path3203, _path3204, _path3205, _path3206, _path3207, _path3208, _path3209, _path3210, _path3211, _path3212, _path3213, _path3214, _path3215, _path3216, _path3217, _path3218, _path3219, _path3220, _path3221, _path3222, _path3223, _path3224, _path3225, _path3226, _path3227, _path3228, _path3229, _path3230, _path3231, _path3232, _path3233, _path3234, _path3235, _path3236, _path3237, _path3238, _path3239, _path3240, _path3241, _path3242, _path3243, _path3244, _path3245, _path3246, _path3247, _path3248, _path3249, _path3250, _path3251, _path3252, _path3253, _path3254, _path3255, _path3256, _path3257, _path3258, _path3259, _path3260, _path3261, _path3262, _path3263, _path3264, _path3265, _path3266, _path3267, _path3268, _path3269, _path3270, _path3271, _path3272, _path3273, _path3274, _path3275, _path3276, _path3277, _path3278, _path3279, _path3280, _path3281, _path3282, _path3283, _path3284, _path3285, _path3286, _path3287, _path3288, _path3289, _path3290, _path3291, _path3292, _path3293, _path3294, _path3295, _path3296, _path3297, _path3298, _path3299, _path3300, _path3301, _path3302, _path3303, _path3304, _path3305, _path3306, _path3307, _path3308, _path3309, _path3310, _path3311, _path3312, _path3313, _path3314, _path3315, _path3316, _path3317, _path3318, _path3319, _path3320, _path3321, _path3322, _path3323, _path3324, _path3325, _path3326, _path3327, _path3328, _path3329, _path3330, _path3331, _path3332, _path3333, _path3334, _path3335, _path3336, _path3337, _path3338, _path3339, _path3340, _path3341, _path3342, _path3343, _path3344, _path3345, _path3346, _path3347, _path3348, _path3349, _path3350, _path3351, _path3352, _path3353, _path3354, _path3355, _path3356, _path3357, _path3358, _path3359, _path3360;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIceCreamContainers(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    baseProfile: "full",
    height: 73,
    width: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 9h1v1h-1zm57 8h1v1h-1z",
    fill: "#c6c6c6",
    fillOpacity: 0.035
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 15v1h-1v-1zM18 37v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.012
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v-1h1v1zM71 44v1h-1v-1z",
    fill: "#dfdfdf",
    fillOpacity: 0.031
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 16h-1v-1h1zm13 36v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.031
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M90 15h1v1h-1zm15 29h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.016
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97 20v-1h1v1zM78 52h1v1h-1z",
    fill: "#786863"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M93 22v1h-1v-1zM81 50h1v1h-1z",
    fill: "#b69799"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106 23v-1h1v1zm-15 9h-1v-1h1z",
    fill: "#161412"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24h1v1h-1zm0 2h-1v-1h1z",
    fill: "#9e1320"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M75 25v1h-1v-1zm11 3h-1v-1h1z",
    fill: "#1a1919"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M45 26v1h-1v-1zm4 7v1h-1v-1z",
    fill: "#860e14"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h-1v-1h1zm-17 3h-1v-1h1z",
    fill: "#414140"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26h1v1h-1zm2 5v-1h1v1z",
    fill: "#171516"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99 26h1v1h-2v-1z",
    fill: "#171313"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28v-1h1v1zm2 4h1v1h-1z",
    fill: "#dedddb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M80 27h1v1h-1zm-28 2h1v1h-1z",
    fill: "#403f3e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27v1h-1v-1zm11 2v1h-1v-1z",
    fill: "#1a1a18"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91 27v1h-1v-1zm1 1v-1h1v1z",
    fill: "#1c1b19"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29h-2v-1h2z",
    fill: "#181611"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h-1v-1h1zm11 4h-1v-1h1z",
    fill: "#c9cbc3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77 30v1h-1v-1zm10 11v-1h1v1z",
    fill: "#4c372d"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M38 42h1v1h-1zm0 15h-1v-1h1z",
    fill: "#4e0609"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82 44v1h-1v-1zm-1 4h-1v-1h1z",
    fill: "#ba9998"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48v1h-1v-1zm53 9v1h-1v-1z",
    fill: "#fff",
    fillOpacity: 0.004
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M28 51v-1h2v1h-1z",
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h1v1h-1zm0 2h1v1h-1z",
    fill: "#2e1010"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M47 9v1h-1V9z",
    fill: "#c5c5b4",
    fillOpacity: 0.122
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10V9h1v1z",
    fill: "#bcb88d",
    fillOpacity: 0.212
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48 10V9h1v1z",
    fill: "#bea884",
    fillOpacity: 0.325
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50 10h-1V9h1z",
    fill: "#b29b70",
    fillOpacity: 0.392
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51 9v1h-1V9z",
    fill: "#ac8c62",
    fillOpacity: 0.447
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9v1h-1V9z",
    fill: "#a6845c",
    fillOpacity: 0.522
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10V9h1v1z",
    fill: "#a37f57",
    fillOpacity: 0.549
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M54 10h-1V9h1z",
    fill: "#a47d55",
    fillOpacity: 0.565
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M55 10h-1V9h1z",
    fill: "#a57f57",
    fillOpacity: 0.573
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M56 10h-1V9h1z",
    fill: "#af875f",
    fillOpacity: 0.576
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9v1h-1V9z",
    fill: "#b9926c",
    fillOpacity: 0.573
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M57 9h1v1h-1z",
    fill: "#c4a179",
    fillOpacity: 0.569
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10h-1V9h1z",
    fill: "#c8a87e",
    fillOpacity: 0.569
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10V9h1v1z",
    fill: "#dabb90",
    fillOpacity: 0.545
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M61 9v1h-1V9z",
    fill: "#e8caa3",
    fillOpacity: 0.478
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61 10V9h1v1z",
    fill: "#ebd4ad",
    fillOpacity: 0.404
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M62 10V9h1v1z",
    fill: "#f0dbb8",
    fillOpacity: 0.341
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M63 9h1v1h-1z",
    fill: "#eadabe",
    fillOpacity: 0.247
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M64 9h1v1h-1z",
    fill: "#e3dcc7",
    fillOpacity: 0.145
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M66 9v1h-1V9z",
    fill: "#d4e2d4",
    fillOpacity: 0.071
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10v1h-1v-1z",
    fill: "#b4b4a4",
    fillOpacity: 0.122
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M43 10h1v1h-1z",
    fill: "#c2bfa8",
    fillOpacity: 0.38
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M45 11h-1v-1h1z",
    fill: "#dbd6c6",
    fillOpacity: 0.639
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M46 10v1h-1v-1z",
    fill: "#ded1b7",
    fillOpacity: 0.827
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M46 11v-1h1v1z",
    fill: "#dcc79e",
    fillOpacity: 0.937
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M47 10h1v1h-1z",
    fill: "#d2b382",
    fillOpacity: 0.988
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M48 11v-1h1v1z",
    fill: "#cb9e70"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M50 11h-1v-1h1z",
    fill: "#b98f60"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h-1v-1h1z",
    fill: "#b58559"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11v-1h1v1z",
    fill: "#b5805c"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M52 10h1v1h-1z",
    fill: "#b88865"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11v-1h1v1z",
    fill: "#bc8c6a"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M54 11v-1h1v1z",
    fill: "#c1906e"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M55 11v-1h1v1z",
    fill: "#c59471"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M57 11h-1v-1h1z",
    fill: "#c4976e"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M57 10h1v1h-1z",
    fill: "#cb9f75"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M59 10v1h-1v-1z",
    fill: "#c99b72"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10v1h-1v-1z",
    fill: "#d3a77d"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M60 10h1v1h-1z",
    fill: "#dcb381"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11h-1v-1h1z",
    fill: "#e2b987"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M63 11h-1v-1h1z",
    fill: "#e4bb8d"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M63 10h1v1h-1z",
    fill: "#e1ba8d"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v-1h1v1z",
    fill: "#e3bf8e",
    fillOpacity: 0.949
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M65 10h1v1h-1z",
    fill: "#e1c291",
    fillOpacity: 0.882
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M66 10h1v1h-1z",
    fill: "#d8bc90",
    fillOpacity: 0.753
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M67 11v-1h1v1z",
    fill: "#d3b48c",
    fillOpacity: 0.549
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M68 11v-1h1v1z",
    fill: "#ccb38a",
    fillOpacity: 0.318
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v-1h1v1z",
    fill: "#d0d0ad",
    fillOpacity: 0.086
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12v-1h1v1z",
    fill: "#c8b9a2",
    fillOpacity: 0.129
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M41 11h1v1h-1z",
    fill: "#cdb389",
    fillOpacity: 0.58
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M42 11h1v1h-1z",
    fill: "#d3c099",
    fillOpacity: 0.922
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M44 12h-1v-1h1z",
    fill: "#e2d5b5"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M44 11h1v1h-1z",
    fill: "#e7d7ad"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12h-1v-1h1z",
    fill: "#e3c895"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M47 11v1h-1v-1z",
    fill: "#d4a97c"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12v-1h1v1z",
    fill: "#b16146"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h-1v-1h1z",
    fill: "#ae614a"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12h-1v-1h1z",
    fill: "#c8a693"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M50 12v-1h1v1z",
    fill: "#b8a79e"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M51 11h1v1h-1z",
    fill: "#b8aead"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M52 12v-1h1v1z",
    fill: "#bbb3b3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M53 11h1v1h-1z",
    fill: "#c9c6c2"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12h-1v-1h1z",
    fill: "#c5c3be"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v-1h1v1z",
    fill: "#bdbcb6"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M56 12v-1h1v1z",
    fill: "#c8c6c0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M58 12h-1v-1h1z",
    fill: "#cbc8c3"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M58 11h1v1h-1z",
    fill: "#dbd7d2"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M60 12h-1v-1h1z",
    fill: "#c8c3bf"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M60 11h1v1h-1z",
    fill: "#c8bfb8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M62 11v1h-1v-1z",
    fill: "#d2c3b8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M62 12v-1h1v1z",
    fill: "#d1c3b0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M64 11v1h-1v-1z",
    fill: "#ceb79d"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M64 12v-1h1v1z",
    fill: "#d1a57e"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12h-1v-1h1z",
    fill: "#c68258"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M66 11h1v1h-1z",
    fill: "#d0885b"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12h-1v-1h1z",
    fill: "#d49361"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11v1h-1v-1z",
    fill: "#c8935d"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M69 11h1v1h-1z",
    fill: "#bb8f5d",
    fillOpacity: 0.89
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M71 12h-1v-1h1z",
    fill: "#b49366",
    fillOpacity: 0.604
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M71 11h1v1h-1z",
    fill: "#ba9a76",
    fillOpacity: 0.22
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M39 13v-1h1v1z",
    fill: "#e2d6bf",
    fillOpacity: 0.173
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M40 12h1v1h-1z",
    fill: "#c0a178",
    fillOpacity: 0.878
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v-1h1v1z",
    fill: "#cca471"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M42 12h1v1h-1z",
    fill: "#dbbc87"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h-1v-1h1z",
    fill: "#e2c28c"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13v-1h1v1z",
    fill: "#e1c082"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M46 12v1h-1v-1z",
    fill: "#eac488"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v-1h1v1z",
    fill: "#934e2f"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13h-1v-1h1z",
    fill: "#83010b"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M49 13h-1v-1h1z",
    fill: "#9a1018"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12h1v1h-1z",
    fill: "#9b2e33"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h-1v-1h1z",
    fill: "#a34c4f"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M51 12h1v1h-1z",
    fill: "#a76467"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M53 12v1h-1v-1z",
    fill: "#a76d6c"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v-1h1v1z",
    fill: "#af797a"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M55 12v1h-1v-1z",
    fill: "#b28380"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v-1h1v1z",
    fill: "#a87a78"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13h-1v-1h1z",
    fill: "#b7918e"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M57 12h1v1h-1z",
    fill: "#ad8484"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13v-1h1v1z",
    fill: "#b99896"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13v-1h1v1z",
    fill: "#b59592"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60 13v-1h1v1z",
    fill: "#b48e8d"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13h-1v-1h1z",
    fill: "#ae8582"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13h-1v-1h1z",
    fill: "#a97c7a"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M63 12h1v1h-1z",
    fill: "#a06a69"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13h-1v-1h1z",
    fill: "#9b4e4e"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M66 12v1h-1v-1z",
    fill: "#89191a"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13h-1v-1h1z",
    fill: "#911513"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M68 12v1h-1v-1z",
    fill: "#93241c"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13h-1v-1h1z",
    fill: "#943927"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12v1h-1v-1z",
    fill: "#a85637"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M70 12h1v1h-1z",
    fill: "#b57245"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13v-1h1v1z",
    fill: "#ac7949",
    fillOpacity: 0.969
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M72 13v-1h1v1z",
    fill: "#a47e56",
    fillOpacity: 0.506
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M73 13v-1h1v1z",
    fill: "#aaf",
    fillOpacity: 0.012
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M38 14v-1h1v1z",
    fill: "#bfffff",
    fillOpacity: 0.016
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M40 13v1h-1v-1z",
    fill: "#ad8c66",
    fillOpacity: 0.725
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13v1h-1v-1z",
    fill: "#c29968"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M41 13h1v1h-1z",
    fill: "#decba0"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h-1v-1h1z",
    fill: "#d4bb86"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14v-1h1v1z",
    fill: "#ceb07c"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M44 13h1v1h-1z",
    fill: "#daba85"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13v1h-1v-1z",
    fill: "#dfc58b"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M46 13h1v1h-1z",
    fill: "#dcba86"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M47 14v-1h1v1z",
    fill: "#a24d2b"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M48 14v-1h1v1z",
    fill: "#91191f"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14h-1v-1h1z",
    fill: "#ae3c47"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M51 14h-1v-1h1z",
    fill: "#b13f45"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M51 13h1v1h-1z",
    fill: "#ab474b"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M53 13v1h-1v-1z",
    fill: "#b24c4f"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h-1v-1h1z",
    fill: "#a5383f"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M55 13v1h-1v-1z",
    fill: "#ac4a4d"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14v-1h1v1z",
    fill: "#a8343d"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M57 13v1h-1v-1z",
    fill: "#a63f45"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v-1h1v1z",
    fill: "#9a373d"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M58 13h1v1h-1z",
    fill: "#ad575a"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M59 13h1v1h-1z",
    fill: "#a64a4e"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14v-1h1v1z",
    fill: "#a0424c"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M62 13v1h-1v-1z",
    fill: "#a24b4d"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M63 13v1h-1v-1z",
    fill: "#9f4343"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M64 13v1h-1v-1z",
    fill: "#9c2d31"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M65 13v1h-1v-1z",
    fill: "#88050f"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M65 14v-1h1v1z",
    fill: "#8f0a12"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M67 13v1h-1v-1z",
    fill: "#89090f"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M67 14v-1h1v1z",
    fill: "#840910"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M69 13v1h-1v-1z",
    fill: "#800810"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v-1h1v1z",
    fill: "#7a0c0f"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14h-1v-1h1z",
    fill: "#841b16"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M71 13h1v1h-1z",
    fill: "#9e492e"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M72 14v-1h1v1z",
    fill: "#ac7444"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M74 13v1h-1v-1z",
    fill: "#b08f6a",
    fillOpacity: 0.459
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M39 14v1h-1v-1z",
    fill: "#b09c89",
    fillOpacity: 0.102
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M40 14v1h-1v-1z",
    fill: "#9e6f3f",
    fillOpacity: 0.933
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h-1v-1h1z",
    fill: "#b68551"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14v1h-1v-1z",
    fill: "#e2ceab"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M42 15v-1h1v1z",
    fill: "#e2d0a4"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M43 14h1v1h-1z",
    fill: "#cfb992"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15h-1v-1h1z",
    fill: "#ceb68e"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15h-1v-1h1z",
    fill: "#c2ae86"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M47 15h-1v-1h1z",
    fill: "#d3bc94"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15h-1v-1h1z",
    fill: "#e5c588"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15h-1v-1h1z",
    fill: "#c7803e"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M50 14v1h-1v-1z",
    fill: "#8c2519"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15v-1h1v1z",
    fill: "#9e101c"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15v-1h1v1z",
    fill: "#a3111a"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15v-1h1v1z",
    fill: "#a6111d"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14v1h-1v-1z",
    fill: "#a91422"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M54 14h1v1h-1z",
    fill: "#a91c29"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M55 14h1v1h-1z",
    fill: "#b01d2e"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M57 14v1h-1v-1z",
    fill: "#ad2633"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h-1v-1h1z",
    fill: "#ac2d39"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14v1h-1v-1z",
    fill: "#a32c35"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M59 15v-1h1v1z",
    fill: "#ab313a"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14h1v1h-1z",
    fill: "#ad2c3b"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M62 15h-1v-1h1z",
    fill: "#a82936"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M62 14h1v1h-1z",
    fill: "#a82c35"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M63 14h1v1h-1z",
    fill: "#af2432"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M64 14h1v1h-1z",
    fill: "#a91825"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M65 15v-1h1v1z",
    fill: "#a91924"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M66 15v-1h1v1z",
    fill: "#b01b2a"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M68 15h-1v-1h1z",
    fill: "#af1a27"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M69 14v1h-1v-1z",
    fill: "#a6151e"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M70 15h-1v-1h1z",
    fill: "#a60e1a"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M71 14v1h-1v-1z",
    fill: "#990918"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15v-1h1v1z",
    fill: "#8b0c12"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h-1v-1h1z",
    fill: "#b6714a"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v-1h1v1z",
    fill: "#a17b4e",
    fillOpacity: 0.843
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M75 15h-1v-1h1z",
    fill: "#919191",
    fillOpacity: 0.027
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M39 16h-1v-1h1z",
    fill: "#a39176",
    fillOpacity: 0.11
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M40 15v1h-1v-1z",
    fill: "#9e6e42",
    fillOpacity: 0.933
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15v1h-1v-1z",
    fill: "#ad7640"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M41 15h1v1h-1z",
    fill: "#b68253"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h-1v-1h1z",
    fill: "#d2af7e"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16v-1h1v1z",
    fill: "#e1c798"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16h-1v-1h1z",
    fill: "#e1ceae"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M46 15v1h-1v-1z",
    fill: "#d8cab6"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M47 16h-1v-1h1z",
    fill: "#e0d1bf"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M48 16h-1v-1h1z",
    fill: "#dac7a8"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M49 15v1h-1v-1z",
    fill: "#c19053"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16h-1v-1h1z",
    fill: "#ab7357"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M50 15h1v1h-1z",
    fill: "#914848"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M51 15h1v1h-1z",
    fill: "#913b38"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M52 15h1v1h-1z",
    fill: "#903435"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M53 16v-1h1v1z",
    fill: "#9f3b3e"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M55 15v1h-1v-1z",
    fill: "#ab5253"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15v1h-1v-1z",
    fill: "#8b3937"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M56 15h1v1h-1z",
    fill: "#732e2c"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15v1h-1v-1z",
    fill: "#70302c"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M58 15h1v1h-1z",
    fill: "#70322d"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M60 15v1h-1v-1z",
    fill: "#7e3a37"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M60 16v-1h1v1z",
    fill: "#995955"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M62 16h-1v-1h1z",
    fill: "#cea6a5"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M63 16h-1v-1h1z",
    fill: "#cf9d9d"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M63 15h1v1h-1z",
    fill: "#a15652"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16h-1v-1h1z",
    fill: "#954742"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M65 16v-1h1v1z",
    fill: "#833e3b"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M66 16v-1h1v1z",
    fill: "#a95559"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v-1h1v1z",
    fill: "#bc6265"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h-1v-1h1z",
    fill: "#bb5b5c"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16h-1v-1h1z",
    fill: "#ba4b4c"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M70 16v-1h1v1z",
    fill: "#b85349"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M71 15h1v1h-1z",
    fill: "#c78367"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15v1h-1v-1z",
    fill: "#cb9d6a"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M73 15h1v1h-1z",
    fill: "#b2865d",
    fillOpacity: 0.847
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M75 16h-1v-1h1z",
    fill: "#b2b2b2",
    fillOpacity: 0.039
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M85 15h1v1h-1z",
    fill: "#99b2b2",
    fillOpacity: 0.039
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M86 16v-1h1v1z",
    fill: "#a2a2a2",
    fillOpacity: 0.043
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16v-1h1v1z",
    fill: "#a2b9b9",
    fillOpacity: 0.043
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M88 15h1v1h-1z",
    fill: "#d0d0d0",
    fillOpacity: 0.043
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M38 16h1v1h-1z",
    fill: "#908579",
    fillOpacity: 0.09
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17v-1h1v1z",
    fill: "#885e35",
    fillOpacity: 0.914
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M40 17v-1h1v1z",
    fill: "#b07d4a"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17h-1v-1h1z",
    fill: "#b98448"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M42 16h1v1h-1z",
    fill: "#ba884a"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16h1v1h-1z",
    fill: "#c5995e"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M45 16v1h-1v-1z",
    fill: "#d7b27d"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17v-1h1v1z",
    fill: "#d9be7e"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h-1v-1h1z",
    fill: "#ead29f"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M48 17h-1v-1h1z",
    fill: "#dfc290"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M49 17h-1v-1h1z",
    fill: "#834e31"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M50 16v1h-1v-1z",
    fill: "#723b2c"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17v-1h1v1z",
    fill: "#7b3f2e"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M52 16v1h-1v-1z",
    fill: "#753e2f"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M52 17v-1h1v1z",
    fill: "#5c2b1f"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17h-1v-1h1z",
    fill: "#562922"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M54 17v-1h1v1z",
    fill: "#4b221c"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M55 16h1v1h-1z",
    fill: "#512920"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M57 16v1h-1v-1z",
    fill: "#694a42"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M57 17v-1h1v1z",
    fill: "#987772"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v-1h1v1z",
    fill: "#99675d"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M60 17h-1v-1h1z",
    fill: "#9a736c"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17h-1v-1h1z",
    fill: "#a99390"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M61 17v-1h1v1z",
    fill: "#dbdad8"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M62 17v-1h1v1z",
    fill: "#bbada7"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M64 16v1h-1v-1z",
    fill: "#632e25"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17v-1h1v1z",
    fill: "#633426"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M66 17h-1v-1h1z",
    fill: "#643929"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16v1h-1v-1z",
    fill: "#6b4434"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M67 16h1v1h-1z",
    fill: "#836553"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M68 16h1v1h-1z",
    fill: "#bba78e"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M69 16h1v1h-1z",
    fill: "#e4d3bb"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M71 17h-1v-1h1z",
    fill: "#eadab8"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M72 17h-1v-1h1z",
    fill: "#d8bf8e"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M72 16h1v1h-1z",
    fill: "#d3ae73"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M74 16v1h-1v-1z",
    fill: "#be9b6f",
    fillOpacity: 0.824
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17h-1v-1h1z",
    fill: "#191919",
    fillOpacity: 0.078
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M77 16h1v1h-1z",
    fill: "#262626",
    fillOpacity: 0.208
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16v1h-1v-1z",
    fill: "#212626",
    fillOpacity: 0.361
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M79 16h1v1h-1z",
    fill: "#1e1e20",
    fillOpacity: 0.459
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M80 16h1v1h-1z",
    fill: "#1a1c1f",
    fillOpacity: 0.565
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M82 16v1h-1v-1z",
    fill: "#19191f",
    fillOpacity: 0.639
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M83 16v1h-1v-1z",
    fill: "#17161b",
    fillOpacity: 0.722
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M84 16v1h-1v-1z",
    fill: "#131315",
    fillOpacity: 0.784
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17h-1v-1h1z",
    fill: "#141415",
    fillOpacity: 0.831
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v-1h1v1z",
    fill: "#101011",
    fillOpacity: 0.843
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M86 17v-1h1v1z",
    fill: "#111011",
    fillOpacity: 0.847
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M87 16h1v1h-1z",
    fill: "#1d1c1c",
    fillOpacity: 0.851
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M89 17h-1v-1h1z",
    fill: "#232223",
    fillOpacity: 0.847
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17h-1v-1h1z",
    fill: "#272626",
    fillOpacity: 0.831
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M90 17v-1h1v1z",
    fill: "#323031",
    fillOpacity: 0.808
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M91 17v-1h1v1z",
    fill: "#403e3e",
    fillOpacity: 0.749
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M92 16h1v1h-1z",
    fill: "#464446",
    fillOpacity: 0.671
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M93 16h1v1h-1z",
    fill: "#4e4d4b",
    fillOpacity: 0.596
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M94 16h1v1h-1z",
    fill: "#636363",
    fillOpacity: 0.533
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M96 16v1h-1v-1z",
    fill: "#737070",
    fillOpacity: 0.408
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h-1v-1h1z",
    fill: "#737073",
    fillOpacity: 0.294
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17v-1h1v1z",
    fill: "#938c93",
    fillOpacity: 0.149
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M99 16v1h-1v-1z",
    fill: "#bbb",
    fillOpacity: 0.059
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M39 18h-1v-1h1z",
    fill: "#8c8c7f",
    fillOpacity: 0.078
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17h1v1h-1z",
    fill: "#7e562f",
    fillOpacity: 0.902
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M41 17v1h-1v-1z",
    fill: "#9f6e3a"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M42 17v1h-1v-1z",
    fill: "#b07f43"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M43 18h-1v-1h1z",
    fill: "#bf8d4f"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17v1h-1v-1z",
    fill: "#cf9e5c"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M44 17h1v1h-1z",
    fill: "#d6ab66"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M45 17h1v1h-1z",
    fill: "#d9b671"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M46 18v-1h1v1z",
    fill: "#dbba7d"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M47 17h1v1h-1z",
    fill: "#e1bd7b"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h-1v-1h1z",
    fill: "#e1bc81"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M50 18h-1v-1h1z",
    fill: "#dcb27c"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17v1h-1v-1z",
    fill: "#d6a472"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M51 17h1v1h-1z",
    fill: "#c89c6d"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17v1h-1v-1z",
    fill: "#b48c5e"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M53 17h1v1h-1z",
    fill: "#a77e57"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h-1v-1h1z",
    fill: "#9b704e"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18v-1h1v1z",
    fill: "#966e4a"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18v-1h1v1z",
    fill: "#c5a887"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M58 17v1h-1v-1z",
    fill: "#b79378"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v-1h1v1z",
    fill: "#9c684a"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M59 17h1v1h-1z",
    fill: "#926448"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v-1h1v1z",
    fill: "#99765e"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M62 18h-1v-1h1z",
    fill: "#b6987e"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M63 17v1h-1v-1z",
    fill: "#b58f72"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18v-1h1v1z",
    fill: "#99653e"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M64 17h1v1h-1z",
    fill: "#a27443"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M65 18v-1h1v1z",
    fill: "#b98858"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h-1v-1h1z",
    fill: "#d0a475"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M68 17v1h-1v-1z",
    fill: "#e0c294"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h-1v-1h1z",
    fill: "#e5d1a7"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M70 17v1h-1v-1z",
    fill: "#e3d6b4"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18v-1h1v1z",
    fill: "#e8d4ad"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M71 18v-1h1v1z",
    fill: "#e8c691"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M72 18v-1h1v1z",
    fill: "#dbb080"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18h-1v-1h1z",
    fill: "#94785a",
    fillOpacity: 0.867
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18h-1v-1h1z",
    fill: "#2d2b2f",
    fillOpacity: 0.459
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M75 18v-1h1v1z",
    fill: "#3b383e",
    fillOpacity: 0.702
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M77 17v1h-1v-1z",
    fill: "#3e3d40",
    fillOpacity: 0.89
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M78 17v1h-1v-1z",
    fill: "#373737",
    fillOpacity: 0.984
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M78 18v-1h1v1z",
    fill: "#1b1718"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v-1h1v1z",
    fill: "#161010"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M81 18h-1v-1h1z",
    fill: "#0a0403"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M82 18h-1v-1h1z",
    fill: "#160607"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M83 17v1h-1v-1z",
    fill: "#1d0908"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18h-1v-1h1z",
    fill: "#352523"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M85 17v1h-1v-1z",
    fill: "#4d4340"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h-1v-1h1z",
    fill: "#504a47"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18h-1v-1h1z",
    fill: "#554c4c"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M87 18v-1h1v1z",
    fill: "#635a59"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M88 17h1v1h-1z",
    fill: "#605755"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M90 18h-1v-1h1z",
    fill: "#5d5452"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18h-1v-1h1z",
    fill: "#5c5551"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18h-1v-1h1z",
    fill: "#554f4b"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M92 18v-1h1v1z",
    fill: "#46403c"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M94 17v1h-1v-1z",
    fill: "#4d4643"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M95 18h-1v-1h1z",
    fill: "#5b5351"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h-1v-1h1z",
    fill: "#574f4e"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M96 17h1v1h-1z",
    fill: "#575051"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M97 17h1v1h-1z",
    fill: "#534e4e",
    fillOpacity: 0.957
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M99 17v1h-1v-1z",
    fill: "#4e4b4a",
    fillOpacity: 0.863
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M99 18v-1h1v1z",
    fill: "#524f4f",
    fillOpacity: 0.678
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M100 17h1v1h-1z",
    fill: "#545454",
    fillOpacity: 0.439
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v-1h1v1z",
    fill: "#5b5b5b",
    fillOpacity: 0.22
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M38 19v-1h1v1z",
    fill: "#898989",
    fillOpacity: 0.051
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M40 18v1h-1v-1z",
    fill: "#7d5836",
    fillOpacity: 0.875
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v-1h1v1z",
    fill: "#9c6734"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M41 19v-1h1v1z",
    fill: "#a6743f"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M43 19h-1v-1h1z",
    fill: "#b1834d"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18v1h-1v-1z",
    fill: "#bf9053"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19h-1v-1h1z",
    fill: "#cba05d"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M45 19v-1h1v1z",
    fill: "#d5ab6c"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M47 18v1h-1v-1z",
    fill: "#dab676"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v-1h1v1z",
    fill: "#e1bd7f"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M48 19v-1h1v1z",
    fill: "#e3c27e"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M49 18h1v1h-1z",
    fill: "#e6c282"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M51 19h-1v-1h1z",
    fill: "#e7c285"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19h-1v-1h1z",
    fill: "#e0bd7b"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M52 19v-1h1v1z",
    fill: "#deb773"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M53 18h1v1h-1z",
    fill: "#d8ac6a"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M54 18h1v1h-1z",
    fill: "#cfa061"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M55 18h1v1h-1z",
    fill: "#c49456"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M56 18h1v1h-1z",
    fill: "#b6874c"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M58 18v1h-1v-1z",
    fill: "#af7c45"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M59 19h-1v-1h1z",
    fill: "#a87541"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M60 18v1h-1v-1z",
    fill: "#9e703c"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M60 19v-1h1v1z",
    fill: "#9b6e3a"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M61 18h1v1h-1z",
    fill: "#9b6937"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M63 19h-1v-1h1z",
    fill: "#a06a3a"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M63 18h1v1h-1z",
    fill: "#a3763f"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v-1h1v1z",
    fill: "#a87a46"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M66 18v1h-1v-1z",
    fill: "#b68552"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18v1h-1v-1z",
    fill: "#c2935e"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M67 18h1v1h-1z",
    fill: "#d1a678"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18v1h-1v-1z",
    fill: "#ddc093"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M69 18h1v1h-1z",
    fill: "#edcfa2"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M70 18h1v1h-1z",
    fill: "#f8d5aa"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M72 19h-1v-1h1z",
    fill: "#bda37f"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M73 19h-1v-1h1z",
    fill: "#564336"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M74 18v1h-1v-1z",
    fill: "#3a3736"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M74 19v-1h1v1z",
    fill: "#59565d"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M75 19v-1h1v1z",
    fill: "#585258"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M76 19v-1h1v1z",
    fill: "#5d4e4f"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M78 19h-1v-1h1z",
    fill: "#4a3d36"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M79 18v1h-1v-1z",
    fill: "#523e36"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M79 19v-1h1v1z",
    fill: "#5d3433"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M80 18h1v1h-1z",
    fill: "#6f4141"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M81 19v-1h1v1z",
    fill: "#774b47"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M83 19h-1v-1h1z",
    fill: "#7e5954"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M84 18v1h-1v-1z",
    fill: "#a08781"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18v1h-1v-1z",
    fill: "#7b6b65"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18v1h-1v-1z",
    fill: "#a49790"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M86 18h1v1h-1z",
    fill: "#a79893"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M88 19h-1v-1h1z",
    fill: "#7f6f6b"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M88 18h1v1h-1z",
    fill: "#ae9f9b"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M89 18h1v1h-1z",
    fill: "#9c8f8a"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M91 18v1h-1v-1z",
    fill: "#b3a5a0"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19v-1h1v1z",
    fill: "#9c8d89"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M93 18v1h-1v-1z",
    fill: "#b7a9a5"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M93 19v-1h1v1z",
    fill: "#988b86"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M94 18h1v1h-1z",
    fill: "#a49691"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18v1h-1v-1z",
    fill: "#a29491"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M96 18h1v1h-1z",
    fill: "#9b8f8c"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M98 18v1h-1v-1z",
    fill: "#7c706b"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M98 19v-1h1v1z",
    fill: "#453c35"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19h-1v-1h1z",
    fill: "#3a342f"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18v1h-1v-1z",
    fill: "#34322d"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M101 18h1v1h-1z",
    fill: "#262622",
    fillOpacity: 0.988
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18v1h-1v-1z",
    fill: "#2b2b2b",
    fillOpacity: 0.824
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M103 18h1v1h-1z",
    fill: "#363234",
    fillOpacity: 0.533
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19h-1v-1h1z",
    fill: "#363030",
    fillOpacity: 0.165
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19v1h-1v-1z",
    fill: "#795d46",
    fillOpacity: 0.451
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M40 19h1v1h-1z",
    fill: "#916539",
    fillOpacity: 0.984
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v-1h1v1z",
    fill: "#a26e3c"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20h-1v-1h1z",
    fill: "#a77a44"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19v1h-1v-1z",
    fill: "#b5864c"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M44 19h1v1h-1z",
    fill: "#bf9557"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M45 20v-1h1v1z",
    fill: "#cb9f60"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M47 19v1h-1v-1z",
    fill: "#d1a869"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M48 20h-1v-1h1z",
    fill: "#d5ad70"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M49 19v1h-1v-1z",
    fill: "#d7af72"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v-1h1v1z",
    fill: "#d6ae72"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20v-1h1v1z",
    fill: "#d2ac6e"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20v-1h1v1z",
    fill: "#cea865"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M52 20v-1h1v1z",
    fill: "#c99e5c"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19v1h-1v-1z",
    fill: "#c3924f"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M54 19h1v1h-1z",
    fill: "#b88746"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M56 19v1h-1v-1z",
    fill: "#ae7f42"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M57 20h-1v-1h1z",
    fill: "#a97841"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M58 20h-1v-1h1z",
    fill: "#9e6c38"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M59 20h-1v-1h1z",
    fill: "#986535"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h-1v-1h1z",
    fill: "#936334"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19v1h-1v-1z",
    fill: "#926434"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M61 19h1v1h-1z",
    fill: "#976435"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M62 19h1v1h-1z",
    fill: "#9a6335"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19v1h-1v-1z",
    fill: "#976734"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M64 19h1v1h-1z",
    fill: "#9f6d3c"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M66 20h-1v-1h1z",
    fill: "#a97842"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20h-1v-1h1z",
    fill: "#b88a51"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M67 19h1v1h-1z",
    fill: "#cca372"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20v-1h1v1z",
    fill: "#ddbc91"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M70 19v1h-1v-1z",
    fill: "#f0d3a7"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M71 19v1h-1v-1z",
    fill: "#ac9c80"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h-1v-1h1z",
    fill: "#201e1d"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h-1v-1h1z",
    fill: "#29292e"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20v-1h1v1z",
    fill: "#554346"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M75 20h-1v-1h1z",
    fill: "#552728"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M76 20h-1v-1h1z",
    fill: "#65312c"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M77 20h-1v-1h1z",
    fill: "#712c26"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20h-1v-1h1z",
    fill: "#662b21"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M78 20v-1h1v1z",
    fill: "#99685f"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19v1h-1v-1z",
    fill: "#b8938e"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M80 19h1v1h-1z",
    fill: "#b7aaa2"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h-1v-1h1z",
    fill: "#b19c98"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20v-1h1v1z",
    fill: "#b19895"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M84 20h-1v-1h1z",
    fill: "#a9948f"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M85 19v1h-1v-1z",
    fill: "#a08c87"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M86 20h-1v-1h1z",
    fill: "#b19f98"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M86 19h1v1h-1z",
    fill: "#b5a59f"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h-1v-1h1z",
    fill: "#a1938d"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M89 20h-1v-1h1z",
    fill: "#ada09a"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M90 19v1h-1v-1z",
    fill: "#a39590"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20v-1h1v1z",
    fill: "#baada6"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M91 19h1v1h-1z",
    fill: "#a69691"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M92 19h1v1h-1z",
    fill: "#b2a6a0"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M94 19v1h-1v-1z",
    fill: "#9a8e85"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M95 19v1h-1v-1z",
    fill: "#ac9d96"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h-1v-1h1z",
    fill: "#9f8e88"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M96 19h1v1h-1z",
    fill: "#a2928c"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20h-1v-1h1z",
    fill: "#a08f89"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M100 19v1h-1v-1z",
    fill: "#9f8b81"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20h-1v-1h1z",
    fill: "#6b524a"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M101 19h1v1h-1z",
    fill: "#7f6e6b"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20h-1v-1h1z",
    fill: "#514a4a"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M104 20h-1v-1h1z",
    fill: "#232120"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M104 19h1v1h-1z",
    fill: "#181616",
    fillOpacity: 0.941
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M105 19h1v1h-1z",
    fill: "#242326",
    fillOpacity: 0.514
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M106 19h1v1h-1z",
    fill: "#3a3a3a",
    fillOpacity: 0.051
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M41 20v1h-1v-1z",
    fill: "#a48968",
    fillOpacity: 0.486
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M42 20v1h-1v-1z",
    fill: "#a68058"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M43 20v1h-1v-1z",
    fill: "#a67a44"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M44 20v1h-1v-1z",
    fill: "#b4854e"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M45 21h-1v-1h1z",
    fill: "#ba915b"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20v1h-1v-1z",
    fill: "#c69a60"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M46 20h1v1h-1z",
    fill: "#cba264"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M47 20h1v1h-1z",
    fill: "#cea468"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20v1h-1v-1z",
    fill: "#cea469"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M49 20h1v1h-1z",
    fill: "#cda368"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M50 20h1v1h-1z",
    fill: "#caa264"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h-1v-1h1z",
    fill: "#c59d5c"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M53 20v1h-1v-1z",
    fill: "#c09455"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M53 21v-1h1v1z",
    fill: "#b9884b"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20v1h-1v-1z",
    fill: "#ac7b45"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20h1v1h-1z",
    fill: "#9d713d"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21h-1v-1h1z",
    fill: "#986a39"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M57 21v-1h1v1z",
    fill: "#8e5f33"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M59 21h-1v-1h1z",
    fill: "#85572e"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20v1h-1v-1z",
    fill: "#84552e"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M60 20h1v1h-1z",
    fill: "#875830"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M62 21h-1v-1h1z",
    fill: "#8b5a31"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M63 20v1h-1v-1z",
    fill: "#8d5b35"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21v-1h1v1z",
    fill: "#8f5e38"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h-1v-1h1z",
    fill: "#95643b"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21v-1h1v1z",
    fill: "#a06f3f"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M67 20v1h-1v-1z",
    fill: "#b0834e"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v-1h1v1z",
    fill: "#c6a170"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M68 20h1v1h-1z",
    fill: "#e0c197"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h-1v-1h1z",
    fill: "#ebd4ae"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21v-1h1v1z",
    fill: "#40362c"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M71 20h1v1h-1z",
    fill: "#1c1820"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M72 20h1v1h-1z",
    fill: "#411a18"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M73 20h1v1h-1z",
    fill: "#9b2725"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M75 21h-1v-1h1z",
    fill: "#ad2928"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21h-1v-1h1z",
    fill: "#a02526"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M77 21h-1v-1h1z",
    fill: "#811b1b"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h-1v-1h1z",
    fill: "#701816"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20v1h-1v-1z",
    fill: "#963438"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M79 20h1v1h-1z",
    fill: "#e2b9b4"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M81 20v1h-1v-1z",
    fill: "#a28e89"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v-1h1v1z",
    fill: "#a27f7e"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M82 20h1v1h-1z",
    fill: "#8b5e5c"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M83 20h1v1h-1z",
    fill: "#896765"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21h-1v-1h1z",
    fill: "#aa928c"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M85 20h1v1h-1z",
    fill: "#9f7e78"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21v-1h1v1z",
    fill: "#bb9e9c"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M88 21h-1v-1h1z",
    fill: "#bea8a3"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M88 20h1v1h-1z",
    fill: "#b6a09c"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21h-1v-1h1z",
    fill: "#b39998"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M90 20h1v1h-1z",
    fill: "#aa8c8a"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h-1v-1h1z",
    fill: "#b9a0a2"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21v-1h1v1z",
    fill: "#b99e9e"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M94 20v1h-1v-1z",
    fill: "#b79593"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M95 21h-1v-1h1z",
    fill: "#b39c9d"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M95 20h1v1h-1z",
    fill: "#c4adad"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M96 20h1v1h-1z",
    fill: "#b19795"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M98 20v1h-1v-1z",
    fill: "#c8b7b0"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M99 20v1h-1v-1z",
    fill: "#afa38b"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21v-1h1v1z",
    fill: "#aa9983"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M101 20v1h-1v-1z",
    fill: "#d5bfbb"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21v-1h1v1z",
    fill: "#b9a5a4"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20v1h-1v-1z",
    fill: "#705c57"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M103 20h1v1h-1z",
    fill: "#3a2826"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M105 21h-1v-1h1z",
    fill: "#1e1515"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M106 20v1h-1v-1z",
    fill: "#1b1818"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M107 21h-1v-1h1z",
    fill: "#111310",
    fillOpacity: 0.725
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M107 20h1v1h-1z",
    fill: "#222",
    fillOpacity: 0.059
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M40 22v-1h1v1z",
    fill: "#d5d1c9",
    fillOpacity: 0.243
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M41 21h1v1h-1z",
    fill: "#dec9b1"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M42 21h1v1h-1z",
    fill: "#c29c67"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M43 22v-1h1v1z",
    fill: "#b6884a"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M44 21h1v1h-1z",
    fill: "#be9660"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22v-1h1v1z",
    fill: "#c59d68"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M47 21v1h-1v-1z",
    fill: "#cba56a"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M47 22v-1h1v1z",
    fill: "#d3aa70"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M49 21v1h-1v-1z",
    fill: "#d2ab6f"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M50 21v1h-1v-1z",
    fill: "#cfa86c"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M51 21v1h-1v-1z",
    fill: "#c8a162"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21v1h-1v-1z",
    fill: "#bf9859"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M52 21h1v1h-1z",
    fill: "#b78f54"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M54 22h-1v-1h1z",
    fill: "#b1814c"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21v1h-1v-1z",
    fill: "#a37242"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M55 21h1v1h-1z",
    fill: "#9c6b3c"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M57 22h-1v-1h1z",
    fill: "#996b3b"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22h-1v-1h1z",
    fill: "#875d30"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M58 21h1v1h-1z",
    fill: "#7c512a"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M59 22v-1h1v1z",
    fill: "#7a4a27"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M61 22h-1v-1h1z",
    fill: "#7d4d2a"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22h-1v-1h1z",
    fill: "#83532e"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M62 22v-1h1v1z",
    fill: "#8a5832"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M63 21h1v1h-1z",
    fill: "#8f5d37"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22h-1v-1h1z",
    fill: "#99683e"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M65 21h1v1h-1z",
    fill: "#a67849"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M67 21v1h-1v-1z",
    fill: "#b88f5c"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M67 22v-1h1v1z",
    fill: "#cba877"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M69 21v1h-1v-1z",
    fill: "#e0bc98"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M69 22v-1h1v1z",
    fill: "#d2af9a"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M70 21h1v1h-1z",
    fill: "#322722"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M71 21h1v1h-1z",
    fill: "#201412"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21v1h-1v-1z",
    fill: "#8d2425"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M73 21h1v1h-1z",
    fill: "#ba2d2c"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v-1h1v1z",
    fill: "#ab2829"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M76 21v1h-1v-1z",
    fill: "#922426"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22h-1v-1h1z",
    fill: "#712222"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M78 22h-1v-1h1z",
    fill: "#712a28"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M78 21h1v1h-1z",
    fill: "#66312c"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M79 21h1v1h-1z",
    fill: "#8b6b63"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21v1h-1v-1z",
    fill: "#9f827d"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M81 21h1v1h-1z",
    fill: "#946e6e"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M82 21h1v1h-1z",
    fill: "#ad7d80"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M84 21v1h-1v-1z",
    fill: "#bd9ea0"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M85 21v1h-1v-1z",
    fill: "#936c6e"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22v-1h1v1z",
    fill: "#aa8380"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M86 21h1v1h-1z",
    fill: "#a38080"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h-1v-1h1z",
    fill: "#905b5d"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M89 22h-1v-1h1z",
    fill: "#945b5f"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M90 21v1h-1v-1z",
    fill: "#966166"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M91 22h-1v-1h1z",
    fill: "#773e3f"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M91 21h1v1h-1z",
    fill: "#a1787b"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M92 21h1v1h-1z",
    fill: "#875b5d"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M94 22h-1v-1h1z",
    fill: "#935f5f"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M94 21h1v1h-1z",
    fill: "#ac8a8b"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M96 22h-1v-1h1z",
    fill: "#886b6c"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M97 21v1h-1v-1z",
    fill: "#c2adaa"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22v-1h1v1z",
    fill: "#f0dedd"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22h-1v-1h1z",
    fill: "#e6cfc6"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M99 21h1v1h-1z",
    fill: "#c9a593"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22h-1v-1h1z",
    fill: "#cca998"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M101 21h1v1h-1z",
    fill: "#af8780"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M102 22v-1h1v1z",
    fill: "#662022"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M104 21v1h-1v-1z",
    fill: "#651618"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M104 22v-1h1v1z",
    fill: "#571f1d"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M105 22v-1h1v1z",
    fill: "#2a1f1a"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M106 21h1v1h-1z",
    fill: "#171813"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M108 21v1h-1v-1z",
    fill: "#181616",
    fillOpacity: 0.361
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h-1v-1h1z",
    fill: "#d4d4c9",
    fillOpacity: 0.188
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M42 22v1h-1v-1z",
    fill: "#ddccb5",
    fillOpacity: 0.98
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23v-1h1v1z",
    fill: "#e2c6a0"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M43 23v-1h1v1z",
    fill: "#dac08e"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23h-1v-1h1z",
    fill: "#c29d86"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M45 22h1v1h-1z",
    fill: "#793b33"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M46 22h1v1h-1z",
    fill: "#9a5345"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23h-1v-1h1z",
    fill: "#a85f4a"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v-1h1v1z",
    fill: "#b1704e"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M50 23h-1v-1h1z",
    fill: "#bb825a"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M50 22h1v1h-1z",
    fill: "#c08f5f"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22v1h-1v-1z",
    fill: "#bf915d"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M52 22h1v1h-1z",
    fill: "#b88c58"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M53 23v-1h1v1z",
    fill: "#b38253"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h-1v-1h1z",
    fill: "#ab784a"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M56 22v1h-1v-1z",
    fill: "#9e683d"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M57 23h-1v-1h1z",
    fill: "#a06941"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M58 22v1h-1v-1z",
    fill: "#906039"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v-1h1v1z",
    fill: "#895a38"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23v-1h1v1z",
    fill: "#895735"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M60 22h1v1h-1z",
    fill: "#875735"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v-1h1v1z",
    fill: "#8b5839"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23h-1v-1h1z",
    fill: "#91583b"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M63 23v-1h1v1z",
    fill: "#915539"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M65 22v1h-1v-1z",
    fill: "#93553a"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23v-1h1v1z",
    fill: "#994f39"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23h-1v-1h1z",
    fill: "#9a4738"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M68 22v1h-1v-1z",
    fill: "#bb7a70"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M69 23h-1v-1h1z",
    fill: "#b96061"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M70 22v1h-1v-1z",
    fill: "#942b2f"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M71 22v1h-1v-1z",
    fill: "#441e1c"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h-1v-1h1z",
    fill: "#1e1618"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23v-1h1v1z",
    fill: "#60393d"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M74 22v1h-1v-1z",
    fill: "#482220"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23h-1v-1h1z",
    fill: "#220a07"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M75 23v-1h1v1z",
    fill: "#1d0805"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M77 22v1h-1v-1z",
    fill: "#220d0a"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M77 23v-1h1v1z",
    fill: "#2b110e"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M79 23h-1v-1h1z",
    fill: "#422a28"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M80 22v1h-1v-1z",
    fill: "#8d736e"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M81 23h-1v-1h1z",
    fill: "#b8a39a"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h-1v-1h1z",
    fill: "#a58180"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23v-1h1v1z",
    fill: "#b08081"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M83 23v-1h1v1z",
    fill: "#b99590"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v-1h1v1z",
    fill: "#b19086"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M85 22h1v1h-1z",
    fill: "#bfa2a3"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h-1v-1h1z",
    fill: "#b1928e"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M88 23h-1v-1h1z",
    fill: "#a87b79"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M88 22h1v1h-1z",
    fill: "#9b6e6f"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M90 22v1h-1v-1z",
    fill: "#a9807f"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23h-1v-1h1z",
    fill: "#ab7c7d"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v-1h1v1z",
    fill: "#956d6b"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v-1h1v1z",
    fill: "#a98888"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23v-1h1v1z",
    fill: "#bea3a5"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23h-1v-1h1z",
    fill: "#92676b"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M96 23v-1h1v1z",
    fill: "#cbb3b2"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M97 22h1v1h-1z",
    fill: "#bc7179"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M99 22v1h-1v-1z",
    fill: "#83252b"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M100 23h-1v-1h1z",
    fill: "#7d1d21"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M101 22v1h-1v-1z",
    fill: "#771814"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M101 23v-1h1v1z",
    fill: "#751c14"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M102 22h1v1h-1z",
    fill: "#941a1e"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M104 22v1h-1v-1z",
    fill: "#a71b1d"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M104 23v-1h1v1z",
    fill: "#b73231"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M106 22v1h-1v-1z",
    fill: "#5e2f2f"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M107 23v-1h1v1z",
    fill: "#1c1e1c",
    fillOpacity: 0.455
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23v1h-1v-1z",
    fill: "#bdb6ae",
    fillOpacity: 0.137
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M41 23h1v1h-1z",
    fill: "#d7c2a8",
    fillOpacity: 0.953
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M42 23h1v1h-1z",
    fill: "#e3c8a0"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24h-1v-1h1z",
    fill: "#d6bd91"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M45 23v1h-1v-1z",
    fill: "#7d3533"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24v-1h1v1z",
    fill: "#851520"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M46 23h1v1h-1z",
    fill: "#9c212b"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M48 23v1h-1v-1z",
    fill: "#91161b"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24v-1h1v1z",
    fill: "#881415"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M49 23h1v1h-1z",
    fill: "#811413"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M50 24v-1h1v1z",
    fill: "#821716"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h-1v-1h1z",
    fill: "#872626"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24v-1h1v1z",
    fill: "#872f2c"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M53 24v-1h1v1z",
    fill: "#75261f"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M54 23h1v1h-1z",
    fill: "#731f1b"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M55 23h1v1h-1z",
    fill: "#6e211b"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M56 23h1v1h-1z",
    fill: "#712c23"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M58 23v1h-1v-1z",
    fill: "#631a14"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M59 24h-1v-1h1z",
    fill: "#611813"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M59 23h1v1h-1z",
    fill: "#5c1613"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M61 23v1h-1v-1z",
    fill: "#621916"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M62 23v1h-1v-1z",
    fill: "#661714"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v-1h1v1z",
    fill: "#691214"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v-1h1v1z",
    fill: "#6e1115"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M64 23h1v1h-1z",
    fill: "#6f0d13"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M65 23h1v1h-1z",
    fill: "#750813"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M67 23v1h-1v-1z",
    fill: "#7e0713"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M67 24v-1h1v1z",
    fill: "#b25e5e"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h-1v-1h1z",
    fill: "#b3555b"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M70 23v1h-1v-1z",
    fill: "#912530"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24h-1v-1h1z",
    fill: "#43221f"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v-1h1v1z",
    fill: "#241d1d"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M72 23h1v1h-1z",
    fill: "#262521"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h-1v-1h1z",
    fill: "#433f38"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24v-1h1v1z",
    fill: "#554e4a"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M76 23v1h-1v-1z",
    fill: "#5d4c46"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24h-1v-1h1z",
    fill: "#483229"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v-1h1v1z",
    fill: "#48342f"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M78 23h1v1h-1z",
    fill: "#574c46"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M79 24v-1h1v1z",
    fill: "#6d665c"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24h-1v-1h1z",
    fill: "#b3a894"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M81 24v-1h1v1z",
    fill: "#887767"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M82 23h1v1h-1z",
    fill: "#947e68"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M84 23v1h-1v-1z",
    fill: "#a59177"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M84 24v-1h1v1z",
    fill: "#88755c"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M85 23h1v1h-1z",
    fill: "#4d4444"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M86 24v-1h1v1z",
    fill: "#988a78"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M87 23h1v1h-1z",
    fill: "#a18773"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M89 23v1h-1v-1z",
    fill: "#968371"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24h-1v-1h1z",
    fill: "#b09882"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M91 23v1h-1v-1z",
    fill: "#938071"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M91 24v-1h1v1z",
    fill: "#a28c73"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23v1h-1v-1z",
    fill: "#8e756b"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M93 23h1v1h-1z",
    fill: "#a78d7f"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M94 23h1v1h-1z",
    fill: "#95857e"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h-1v-1h1z",
    fill: "#b09a89"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24h-1v-1h1z",
    fill: "#b1a095"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M98 23v1h-1v-1z",
    fill: "#a97974"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M99 24h-1v-1h1z",
    fill: "#812a2b"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M99 23h1v1h-1z",
    fill: "#70181e"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M101 23v1h-1v-1z",
    fill: "#84181d"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M102 23v1h-1v-1z",
    fill: "#9f1b1e"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M103 23v1h-1v-1z",
    fill: "#a81d20"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M103 23h1v1h-1z",
    fill: "#a52225"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M104 23h1v1h-1z",
    fill: "#721e1b"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M106 24h-1v-1h1z",
    fill: "#341c1d"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M106 23h1v1h-1z",
    fill: "#252222"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24h-1v-1h1z",
    fill: "#232623",
    fillOpacity: 0.447
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M41 25h-1v-1h1z",
    fill: "#b1b1b1",
    fillOpacity: 0.09
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M41 24h1v1h-1z",
    fill: "#d1c6ab",
    fillOpacity: 0.918
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h-1v-1h1z",
    fill: "#e5cd97"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M44 24v1h-1v-1z",
    fill: "#b7896b"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25v-1h1v1z",
    fill: "#7b0d15"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M45 24h1v1h-1z",
    fill: "#a11f27"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M47 24v1h-1v-1z",
    fill: "#a21c27"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h-1v-1h1z",
    fill: "#98111a"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25h-1v-1h1z",
    fill: "#972223"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M51 25h-1v-1h1z",
    fill: "#9b3531"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M51 24h1v1h-1z",
    fill: "#a6524a"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M52 24h1v1h-1z",
    fill: "#a75f53"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M54 24v1h-1v-1z",
    fill: "#a86659"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25v-1h1v1z",
    fill: "#843933"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M55 25v-1h1v1z",
    fill: "#8b493f"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M56 25v-1h1v1z",
    fill: "#a57760"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M58 25h-1v-1h1z",
    fill: "#672c24"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h-1v-1h1z",
    fill: "#803f38"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25v-1h1v1z",
    fill: "#864c3c"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24v1h-1v-1z",
    fill: "#793f32"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M62 24v1h-1v-1z",
    fill: "#7a3932"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M63 24v1h-1v-1z",
    fill: "#752423"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25h-1v-1h1z",
    fill: "#711016"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M64 24h1v1h-1z",
    fill: "#770910"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v-1h1v1z",
    fill: "#810c13"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25v-1h1v1z",
    fill: "#891318"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h-1v-1h1z",
    fill: "#b55f5b"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24v1h-1v-1z",
    fill: "#b15456"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M69 24h1v1h-1z",
    fill: "#902730"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M71 24v1h-1v-1z",
    fill: "#4a312b"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h-1v-1h1z",
    fill: "#1d1e19"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h-1v-1h1z",
    fill: "#0e0b0a"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M74 25h-1v-1h1z",
    fill: "#151410"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M74 24h1v1h-1z",
    fill: "#282726"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M76 25h-1v-1h1z",
    fill: "#4c4744"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M77 24v1h-1v-1z",
    fill: "#665d5a"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v-1h1v1z",
    fill: "#605c5c"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v-1h1v1z",
    fill: "#57524f"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M80 24v1h-1v-1z",
    fill: "#5d4a48"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M81 25h-1v-1h1z",
    fill: "#865e55"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M82 24v1h-1v-1z",
    fill: "#7c4946"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M83 25h-1v-1h1z",
    fill: "#8b5149"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25h-1v-1h1z",
    fill: "#9c6359"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M85 24v1h-1v-1z",
    fill: "#874e44"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h-1v-1h1z",
    fill: "#58272a"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25h-1v-1h1z",
    fill: "#8f5a4f"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M87 25v-1h1v1z",
    fill: "#8f584b"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25h-1v-1h1z",
    fill: "#8f594f"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M90 24v1h-1v-1z",
    fill: "#9f6959"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M91 25h-1v-1h1z",
    fill: "#8a564a"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M92 25h-1v-1h1z",
    fill: "#9b6556"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M92 24h1v1h-1z",
    fill: "#85544a"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M94 24v1h-1v-1z",
    fill: "#a67563"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M95 24v1h-1v-1z",
    fill: "#7f5047"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M95 25v-1h1v1z",
    fill: "#aa816b"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M96 24h1v1h-1z",
    fill: "#785449"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25v-1h1v1z",
    fill: "#2d1312"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M98 24h1v1h-1z",
    fill: "#34181a"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M100 24v1h-1v-1z",
    fill: "#3f191e"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M100 24h1v1h-1z",
    fill: "#561a1a"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M102 24v1h-1v-1z",
    fill: "#65191b"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M103 25h-1v-1h1z",
    fill: "#571c1f"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M104 24v1h-1v-1z",
    fill: "#604447"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M105 24v1h-1v-1z",
    fill: "#7c7476"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M105 24h1v1h-1z",
    fill: "#555557"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M107 24v1h-1v-1z",
    fill: "#1f2021"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M108 24v1h-1v-1z",
    fill: "#1f1d1d",
    fillOpacity: 0.439
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M40 25h1v1h-1z",
    fill: "#aabfbf",
    fillOpacity: 0.047
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26v-1h1v1z",
    fill: "#c1b28f",
    fillOpacity: 0.859
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25v1h-1v-1z",
    fill: "#dcbb84"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25h1v1h-1z",
    fill: "#ad7969"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M44 25h1v1h-1z",
    fill: "#870c12"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M45 25h1v1h-1z",
    fill: "#a31b21"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M48 26h-1v-1h1z",
    fill: "#a53b42"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M48 25h1v1h-1z",
    fill: "#c68a84"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M49 25h1v1h-1z",
    fill: "#ddbdaf"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M51 26h-1v-1h1z",
    fill: "#e7d1bb"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26h-1v-1h1z",
    fill: "#e9dec9"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25v1h-1v-1z",
    fill: "#e5e0d0"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M53 25h1v1h-1z",
    fill: "#ebe6d8"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M54 25h1v1h-1z",
    fill: "#d1c2b1"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M56 26h-1v-1h1z",
    fill: "#ad957a"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M57 25v1h-1v-1z",
    fill: "#a48a70"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v-1h1v1z",
    fill: "#a69183"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M59 26h-1v-1h1z",
    fill: "#cfc2b8"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M59 25h1v1h-1z",
    fill: "#d6cabf"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M60 26v-1h1v1z",
    fill: "#cfc5b7"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M62 25v1h-1v-1z",
    fill: "#cbbfaf"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M62 26v-1h1v1z",
    fill: "#ceb4a6"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M64 25v1h-1v-1z",
    fill: "#ba8f87"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M65 25v1h-1v-1z",
    fill: "#9b5650"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M65 26v-1h1v1z",
    fill: "#791412"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M66 25h1v1h-1z",
    fill: "#8f1520"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M67 25h1v1h-1z",
    fill: "#ba6065"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M68 25h1v1h-1z",
    fill: "#ac5256"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h-1v-1h1z",
    fill: "#8a2832"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h-1v-1h1z",
    fill: "#5d4542"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M72 26h-1v-1h1z",
    fill: "#25211f"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M72 25h1v1h-1z",
    fill: "#0f0c0b"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M73 25h1v1h-1z",
    fill: "#141313"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M75 26v-1h1v1z",
    fill: "#212020"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M77 25v1h-1v-1z",
    fill: "#33302e"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25v1h-1v-1z",
    fill: "#474340"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M78 25h1v1h-1z",
    fill: "#53554f"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25v1h-1v-1z",
    fill: "#605f5a"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M80 25h1v1h-1z",
    fill: "#6a5c5c"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M82 25v1h-1v-1z",
    fill: "#735d5d"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26v-1h1v1z",
    fill: "#866d67"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M84 25v1h-1v-1z",
    fill: "#8b6d67"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26v-1h1v1z",
    fill: "#967267"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M85 25h1v1h-1z",
    fill: "#92675d"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M86 25h1v1h-1z",
    fill: "#986960"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M88 26h-1v-1h1z",
    fill: "#976a5f"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M89 25v1h-1v-1z",
    fill: "#84574c"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M89 26v-1h1v1z",
    fill: "#96685e"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M90 25h1v1h-1z",
    fill: "#9d7464"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26v-1h1v1z",
    fill: "#7f5445"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M93 25v1h-1v-1z",
    fill: "#9b6e5f"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M94 26h-1v-1h1z",
    fill: "#8b6051"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26h-1v-1h1z",
    fill: "#8b5b53"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M96 25v1h-1v-1z",
    fill: "#783f42"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26v-1h1v1z",
    fill: "#571f26"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M97 25h1v1h-1z",
    fill: "#491d23"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M99 26h-1v-1h1z",
    fill: "#361c1f"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M100 26h-1v-1h1z",
    fill: "#1a1514"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M101 25v1h-1v-1z",
    fill: "#0b110f"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26v-1h1v1z",
    fill: "#242527"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M102 25h1v1h-1z",
    fill: "#4c4f51"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M103 26v-1h1v1z",
    fill: "#807f83"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26h-1v-1h1z",
    fill: "#777378"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26v-1h1v1z",
    fill: "#363437"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M107 26h-1v-1h1z",
    fill: "#1f1f21"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M108 26h-1v-1h1z",
    fill: "#1c1c1c",
    fillOpacity: 0.416
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M41 27h-1v-1h1z",
    fill: "#7fffff",
    fillOpacity: 0.008
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M41 26h1v1h-1z",
    fill: "#c3af8d",
    fillOpacity: 0.796
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M42 26h1v1h-1z",
    fill: "#e3c08c"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27h-1v-1h1z",
    fill: "#b38270"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27v-1h1v1z",
    fill: "#9f101a"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M46 26h1v1h-1z",
    fill: "#a3423d"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27h-1v-1h1z",
    fill: "#e3ccb8"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M49 27h-1v-1h1z",
    fill: "#f7faeb"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M49 26h1v1h-1z",
    fill: "#fafaf8"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M50 27v-1h1v1z",
    fill: "#f7f8f7"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M52 26v1h-1v-1z",
    fill: "#f4f2f1"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27h-1v-1h1z",
    fill: "#f1f1f0"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M54 27h-1v-1h1z",
    fill: "#ebefeb"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M54 26h1v1h-1z",
    fill: "#ecebe9"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M55 26h1v1h-1z",
    fill: "#ebe7e5"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26v1h-1v-1z",
    fill: "#e6e4e1"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27h-1v-1h1z",
    fill: "#e1dfdb"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M59 27h-1v-1h1z",
    fill: "#dddcdb"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27h-1v-1h1z",
    fill: "#dddcde"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M61 27h-1v-1h1z",
    fill: "#e1dfe1"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h-1v-1h1z",
    fill: "#e0e0df"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27v-1h1v1z",
    fill: "#e1e2e0"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M64 26v1h-1v-1z",
    fill: "#e6e5de"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h-1v-1h1z",
    fill: "#e8d9ca"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M66 26v1h-1v-1z",
    fill: "#bd8976"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M66 27v-1h1v1z",
    fill: "#872026"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M68 27h-1v-1h1z",
    fill: "#b76065"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M69 26v1h-1v-1z",
    fill: "#a75053"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M70 27h-1v-1h1z",
    fill: "#842d36"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M70 26h1v1h-1z",
    fill: "#5d4b48"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M71 26h1v1h-1z",
    fill: "#222120"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h-1v-1h1z",
    fill: "#140f0e"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27v-1h1v1z",
    fill: "#141213"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M74 27v-1h1v1z",
    fill: "#1a191a"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M76 26v1h-1v-1z",
    fill: "#262325"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27h-1v-1h1z",
    fill: "#353433"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M78 26v1h-1v-1z",
    fill: "#3f3e3d"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27v-1h1v1z",
    fill: "#3f3e3e"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26v1h-1v-1z",
    fill: "#434344"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M81 26h1v1h-1z",
    fill: "#3f4042"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M82 26h1v1h-1z",
    fill: "#3c3b3d"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27v-1h1v1z",
    fill: "#3c3a3a"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M84 26h1v1h-1z",
    fill: "#363330"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26v1h-1v-1z",
    fill: "#2e2c2b"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M86 26h1v1h-1z",
    fill: "#212021"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M87 26h1v1h-1z",
    fill: "#181718"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M89 27h-1v-1h1z",
    fill: "#181618"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M90 27v-1h1v1z",
    fill: "#18130f"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M91 26h1v1h-1z",
    fill: "#18130e"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M92 26h1v1h-1z",
    fill: "#17110c"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M93 26h1v1h-1z",
    fill: "#17110f"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M95 26v1h-1v-1z",
    fill: "#12100d"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M96 27h-1v-1h1z",
    fill: "#161411"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M96 26h1v1h-1z",
    fill: "#171311"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M98 27h-1v-1h1z",
    fill: "#121310"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M100 27v-1h1v1z",
    fill: "#121613"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M101 26h1v1h-1z",
    fill: "#1c1a1d"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v-1h1v1z",
    fill: "#333235"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M103 27v-1h1v1z",
    fill: "#6e6a6e"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26v1h-1v-1z",
    fill: "#797478"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M105 26h1v1h-1z",
    fill: "#3a393c"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M106 26h1v1h-1z",
    fill: "#1e1e20"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M108 26v1h-1v-1z",
    fill: "#191919",
    fillOpacity: 0.388
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27v1h-1v-1z",
    fill: "#c0b499",
    fillOpacity: 0.722
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M42 27h1v1h-1z",
    fill: "#e8d6ab"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M44 27v1h-1v-1z",
    fill: "#c59479"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M45 28h-1v-1h1z",
    fill: "#871219"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M45 27h1v1h-1z",
    fill: "#9f141d"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28h-1v-1h1z",
    fill: "#d49f8d"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M48 27v1h-1v-1z",
    fill: "#c2beb3"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M48 28v-1h1v1z",
    fill: "#bdbcbe"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M49 28v-1h1v1z",
    fill: "#cbcacc"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M51 27v1h-1v-1z",
    fill: "#d6d3d4"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M51 28v-1h1v1z",
    fill: "#f6f3f1"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M53 27v1h-1v-1z",
    fill: "#f5f5f1"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M53 28v-1h1v1z",
    fill: "#f1f2ee"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27v1h-1v-1z",
    fill: "#edefec"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M55 27h1v1h-1z",
    fill: "#eaebe9"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M57 28h-1v-1h1z",
    fill: "#e6e5e2"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M58 27v1h-1v-1z",
    fill: "#e4e3e2"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M60 27v1h-1v-1z",
    fill: "#d2d0cd"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M60 28v-1h1v1z",
    fill: "#cecbca"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h-1v-1h1z",
    fill: "#e6e6e6"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M62 27h1v1h-1z",
    fill: "#e9e9e8"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M63 27h1v1h-1z",
    fill: "#ede9ea"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27v1h-1v-1z",
    fill: "#f1f0f1"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M65 27h1v1h-1z",
    fill: "#e8dece"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28h-1v-1h1z",
    fill: "#a6685f"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v-1h1v1z",
    fill: "#b36667"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27v1h-1v-1z",
    fill: "#aa5256"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M69 27h1v1h-1z",
    fill: "#8c212c"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M71 27v1h-1v-1z",
    fill: "#632d2d"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M72 27v1h-1v-1z",
    fill: "#191712"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v-1h1v1z",
    fill: "#0f0c0c"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M73 27h1v1h-1z",
    fill: "#141312"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M75 27v1h-1v-1z",
    fill: "#1c1c1d"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v-1h1v1z",
    fill: "#282727"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M77 27v1h-1v-1z",
    fill: "#333332"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M77 28v-1h1v1z",
    fill: "#3a3b3b"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M78 27h1v1h-1z",
    fill: "#3a3c3c"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M80 28h-1v-1h1z",
    fill: "#3d3b3d"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h-1v-1h1z",
    fill: "#3b3b38"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28v-1h1v1z",
    fill: "#302f2f"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M83 27h1v1h-1z",
    fill: "#282927"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M85 28h-1v-1h1z",
    fill: "#232221"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h-1v-1h1z",
    fill: "#151514"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M88 28h-1v-1h1z",
    fill: "#161614"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v-1h1v1z",
    fill: "#1c1c1a"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v-1h1v1z",
    fill: "#1c1a18"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28h-1v-1h1z",
    fill: "#201e1b"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M94 28v-1h1v1z",
    fill: "#1c1d19"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M95 27h1v1h-1z",
    fill: "#191916"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28v-1h1v1z",
    fill: "#1c1916"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M97 27h1v1h-1z",
    fill: "#1d1b17"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M99 27v1h-1v-1z",
    fill: "#1d1c18"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v-1h1v1z",
    fill: "#181613"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M101 28h-1v-1h1z",
    fill: "#131111"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27v1h-1v-1z",
    fill: "#1b1619"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M102 27h1v1h-1z",
    fill: "#353236"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M104 27v1h-1v-1z",
    fill: "#676266"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M105 28h-1v-1h1z",
    fill: "#605c60"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M106 27v1h-1v-1z",
    fill: "#3e3c40"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28h-1v-1h1z",
    fill: "#2a2a2c"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M107 27h1v1h-1z",
    fill: "#0f0f13",
    fillOpacity: 0.251
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M41 28h1v1h-1z",
    fill: "#c9bbab",
    fillOpacity: 0.596
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M43 28v1h-1v-1z",
    fill: "#dbc599"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M44 28v1h-1v-1z",
    fill: "#dab58f"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29h-1v-1h1z",
    fill: "#891f23"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M46 28v1h-1v-1z",
    fill: "#9d171b"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M47 28v1h-1v-1z",
    fill: "#e0bcab"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29v-1h1v1z",
    fill: "#a6a9a4"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M49 29h-1v-1h1z",
    fill: "#414242"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M50 28v1h-1v-1z",
    fill: "#6a6768"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v-1h1v1z",
    fill: "#767373"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M51 29v-1h1v1z",
    fill: "#b3b3b1"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v-1h1v1z",
    fill: "#c1c1be"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M53 29v-1h1v1z",
    fill: "#cac8c5"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M55 29h-1v-1h1z",
    fill: "#cfccc9"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M55 28h1v1h-1z",
    fill: "#c8c7c5"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M56 28h1v1h-1z",
    fill: "#cbcbca"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29v-1h1v1z",
    fill: "#b9b9b7"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M58 28h1v1h-1z",
    fill: "#dbdbd9"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M59 28h1v1h-1z",
    fill: "#72726f"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M61 29h-1v-1h1z",
    fill: "#595957"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M61 28h1v1h-1z",
    fill: "#939392"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M62 28h1v1h-1z",
    fill: "#8f908d"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M63 29v-1h1v1z",
    fill: "#7c7d7c"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29h-1v-1h1z",
    fill: "#636466"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M65 29v-1h1v1z",
    fill: "#a5a6a1"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M67 28v1h-1v-1z",
    fill: "#be958a"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29v-1h1v1z",
    fill: "#b67577"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M68 28h1v1h-1z",
    fill: "#a15154"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M70 28v1h-1v-1z",
    fill: "#8d1d27"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29v-1h1v1z",
    fill: "#88171e",
    fillOpacity: 0.976
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M72 28v1h-1v-1z",
    fill: "#5c3634",
    fillOpacity: 0.796
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M73 29h-1v-1h1z",
    fill: "#241c1d"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M74 28v1h-1v-1z",
    fill: "#080705"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M75 28v1h-1v-1z",
    fill: "#151216"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M76 28v1h-1v-1z",
    fill: "#242121"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M77 29h-1v-1h1z",
    fill: "#333133"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29h-1v-1h1z",
    fill: "#3c3b3a"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M79 28v1h-1v-1z",
    fill: "#41403f"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29v-1h1v1z",
    fill: "#414340"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28v1h-1v-1z",
    fill: "#3e403c"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M81 28h1v1h-1z",
    fill: "#3d3c38"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M82 28h1v1h-1z",
    fill: "#33322f"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M83 28h1v1h-1z",
    fill: "#262623"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v-1h1v1z",
    fill: "#1d1d19"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28v1h-1v-1z",
    fill: "#171717"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M86 28h1v1h-1z",
    fill: "#141412"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M87 28h1v1h-1z",
    fill: "#151511"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M89 28v1h-1v-1z",
    fill: "#1c1c19"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29h-1v-1h1z",
    fill: "#201f1d"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28v1h-1v-1z",
    fill: "#1f1c19"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M91 28h1v1h-1z",
    fill: "#1f1b18"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M92 29v-1h1v1z",
    fill: "#1b1714"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M95 28h1v1h-1z",
    fill: "#171511"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M96 28h1v1h-1z",
    fill: "#161612"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M98 28v1h-1v-1z",
    fill: "#171713"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M99 28v1h-1v-1z",
    fill: "#1a1917"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M99 29v-1h1v1z",
    fill: "#171615"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M100 29v-1h1v1z",
    fill: "#161417"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M102 29h-1v-1h1z",
    fill: "#222024"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M103 28v1h-1v-1z",
    fill: "#3e3c3e"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M103 28h1v1h-1z",
    fill: "#6d6b6c"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M105 29h-1v-1h1z",
    fill: "#949196"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M106 29h-1v-1h1z",
    fill: "#6d6a6b"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28v1h-1v-1z",
    fill: "#242425",
    fillOpacity: 0.58
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M107 29v-1h1v1z",
    fillOpacity: 0.012
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30h-1v-1h1z",
    fill: "#c2b4a0",
    fillOpacity: 0.498
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M42 30v-1h1v1z",
    fill: "#dec59c"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h-1v-1h1z",
    fill: "#e3c392"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M45 29v1h-1v-1z",
    fill: "#9d483e"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M45 30v-1h1v1z",
    fill: "#8e0f14"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M47 30h-1v-1h1z",
    fill: "#d1a091"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M48 29h1v1h-1z",
    fill: "#929191"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M50 29v1h-1v-1z",
    fill: "#575453"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M51 30h-1v-1h1z",
    fill: "#4f4c4b"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M52 29v1h-1v-1z",
    fill: "#41413f"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v-1h1v1z",
    fill: "#505050"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30v-1h1v1z",
    fill: "#3f3f3f"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M55 30v-1h1v1z",
    fill: "#2d2d2d"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M57 30h-1v-1h1z",
    fill: "#4f4f4d"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M57 29h1v1h-1z",
    fill: "#484846"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M58 30v-1h1v1z",
    fill: "#7e7e7c"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v-1h1v1z",
    fill: "#575755"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M60 30v-1h1v1z",
    fill: "#666664"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h-1v-1h1z",
    fill: "#40403e"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30v-1h1v1z",
    fill: "#4c4c4c"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h-1v-1h1z",
    fill: "#4e4e50"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M66 29v1h-1v-1z",
    fill: "#9c9992"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M67 30h-1v-1h1z",
    fill: "#b38680"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M67 29h1v1h-1z",
    fill: "#b27779"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v-1h1v1z",
    fill: "#9d4a53"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M69 29h1v1h-1z",
    fill: "#8f1d28"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M70 29h1v1h-1z",
    fill: "#91121c",
    fillOpacity: 0.953
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M71 30v-1h1v1z",
    fill: "#9b5c5c",
    fillOpacity: 0.475
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h-1v-1h1z",
    fill: "#c2b1ab",
    fillOpacity: 0.988
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30v-1h1v1z",
    fill: "#97908e"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29v1h-1v-1z",
    fill: "#453d3c"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M75 29h1v1h-1z",
    fill: "#342624"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M76 29h1v1h-1z",
    fill: "#302d2b"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M78 29v1h-1v-1z",
    fill: "#323231"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M79 30h-1v-1h1z",
    fill: "#3a3838"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M79 29h1v1h-1z",
    fill: "#3f3b37"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v-1h1v1z",
    fill: "#3e3e3f"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29v1h-1v-1z",
    fill: "#413e3b"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M82 29h1v1h-1z",
    fill: "#3f3c3c"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29v1h-1v-1z",
    fill: "#353133"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M85 29v1h-1v-1z",
    fill: "#2d2826"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30h-1v-1h1z",
    fill: "#201e20"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M86 29h1v1h-1z",
    fill: "#1a1a1c"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M88 29v1h-1v-1z",
    fill: "#1b1d1c"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M88 30v-1h1v1z",
    fill: "#202221"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M90 29v1h-1v-1z",
    fill: "#212322"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M91 30h-1v-1h1z",
    fill: "#221f1d"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30h-1v-1h1z",
    fill: "#221e1d"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M92 30v-1h1v1z",
    fill: "#201c1d"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M93 29h1v1h-1z",
    fill: "#1d1b1b"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M95 29v1h-1v-1z",
    fill: "#1e1c1b"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M96 30h-1v-1h1z",
    fill: "#201c1a"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M96 29h1v1h-1z",
    fill: "#1f1d1b"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h-1v-1h1z",
    fill: "#1e1d1b"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M99 30h-1v-1h1z",
    fill: "#1e1d1a"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30h-1v-1h1z",
    fill: "#171719"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M101 30v-1h1v1z",
    fill: "#18181a"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30v-1h1v1z",
    fill: "#252823"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h-1v-1h1z",
    fill: "#6b6969"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M105 30h-1v-1h1z",
    fill: "#90878a"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30h-1v-1h1z",
    fill: "#656156",
    fillOpacity: 0.604
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M107 30h-1v-1h1z",
    fill: "#555",
    fillOpacity: 0.012
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M41 31v-1h1v1z",
    fill: "#c4c2b5",
    fillOpacity: 0.396
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M43 30v1h-1v-1z",
    fill: "#e4ceb2"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M43 31v-1h1v1z",
    fill: "#dbbe85"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M44 30h1v1h-1z",
    fill: "#b67a5d"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31h-1v-1h1z",
    fill: "#870610"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31v-1h1v1z",
    fill: "#a44342"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30v1h-1v-1z",
    fill: "#f3e3d5"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M48 30h1v1h-1z",
    fill: "#f8f8f6"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31h-1v-1h1z",
    fill: "#e7e6e5"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M51 31h-1v-1h1z",
    fill: "#d0cecb"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M52 30v1h-1v-1z",
    fill: "#c7c7c5"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M53 30v1h-1v-1z",
    fill: "#b7b5b6"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v-1h1v1z",
    fill: "#797876"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M54 30h1v1h-1z",
    fill: "#636160"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M55 31v-1h1v1z",
    fill: "#a3a1a1"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31h-1v-1h1z",
    fill: "#a5a6a3"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M58 31h-1v-1h1z",
    fill: "#acacaa"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30v1h-1v-1z",
    fill: "#cbcbc9"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M59 30h1v1h-1z",
    fill: "#acaca9"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M61 31h-1v-1h1z",
    fill: "#aeaeab"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30v1h-1v-1z",
    fill: "#d0d0cf"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M62 30h1v1h-1z",
    fill: "#bfbfbd"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M64 30v1h-1v-1z",
    fill: "#d4d4d3"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31v-1h1v1z",
    fill: "#c9c9c7"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M65 30h1v1h-1z",
    fill: "#d4c0b8"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M67 31h-1v-1h1z",
    fill: "#824343"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M68 30v1h-1v-1z",
    fill: "#b67879"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30v1h-1v-1z",
    fill: "#9e444e"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M69 30h1v1h-1z",
    fill: "#9d1f2b"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31h-1v-1h1z",
    fill: "#951722",
    fillOpacity: 0.91
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M72 30v1h-1v-1z",
    fill: "#8a4c52",
    fillOpacity: 0.325
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M72 31v-1h1v1z",
    fill: "#dbc1bc",
    fillOpacity: 0.973
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M73 30h1v1h-1z",
    fill: "#fcf4ec"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31h-1v-1h1z",
    fill: "#a76162"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M75 31v-1h1v1z",
    fill: "#732e2b"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M78 31h-1v-1h1z",
    fill: "#605147"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h-1v-1h1z",
    fill: "#564440"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M80 30v1h-1v-1z",
    fill: "#46403f"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h-1v-1h1z",
    fill: "#373331"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M82 30v1h-1v-1z",
    fill: "#2c2b24"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31v-1h1v1z",
    fill: "#272624"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M84 30v1h-1v-1z",
    fill: "#20201f"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M84 31v-1h1v1z",
    fill: "#1c1e1a"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M86 30v1h-1v-1z",
    fill: "#131415"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M86 31v-1h1v1z",
    fill: "#101110"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M87 30h1v1h-1z",
    fill: "#131314"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31h-1v-1h1z",
    fill: "#151515"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M89 31v-1h1v1z",
    fill: "#151614"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M91 31h-1v-1h1z",
    fill: "#181516"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M93 30v1h-1v-1z",
    fill: "#161313"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30v1h-1v-1z",
    fill: "#171412"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M94 30h1v1h-1z",
    fill: "#131110"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M95 30h1v1h-1z",
    fill: "#100f0f"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M96 31v-1h1v1z",
    fill: "#0c0c0b"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30v1h-1v-1z",
    fill: "#0a0b08"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M98 30h1v1h-1z",
    fill: "#090b06"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31h-1v-1h1z",
    fill: "#0a0a06"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M101 31h-1v-1h1z",
    fill: "#131010"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31h-1v-1h1z",
    fill: "#33302c"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M102 30h1v1h-1z",
    fill: "#6c6965"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M104 31h-1v-1h1z",
    fill: "#b6a9a8"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M104 30h1v1h-1z",
    fill: "#dfcdc3"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M106 30v1h-1v-1z",
    fill: "#a79e85",
    fillOpacity: 0.353
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32h-1v-1h1z",
    fill: "#cec7c0",
    fillOpacity: 0.29
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M42 31h1v1h-1z",
    fill: "#dcc9ae"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M44 31v1h-1v-1z",
    fill: "#e0c69b"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M45 31v1h-1v-1z",
    fill: "#d1aa7c"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h-1v-1h1z",
    fill: "#861a18"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M47 31v1h-1v-1z",
    fill: "#8f0b14"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32h-1v-1h1z",
    fill: "#b88176"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M49 31v1h-1v-1z",
    fill: "#f5eae6"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M50 31v1h-1v-1z",
    fill: "#f5f2f1"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32h-1v-1h1z",
    fill: "#f7f2ef"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M51 32v-1h1v1z",
    fill: "#f5f3ef"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31v1h-1v-1z",
    fill: "#f8f5f2"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31h1v1h-1z",
    fill: "#d7d4d2"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M54 31h1v1h-1z",
    fill: "#dddad8"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M56 32h-1v-1h1z",
    fill: "#f1efee"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M57 31v1h-1v-1z",
    fill: "#e9eae8"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32h-1v-1h1z",
    fill: "#e4e5e4"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M59 32h-1v-1h1z",
    fill: "#dfdfdf"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M59 31h1v1h-1z",
    fill: "#e4e3e1"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M60 31h1v1h-1z",
    fill: "#e7e4e0"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31v1h-1v-1z",
    fill: "#e3e4e5"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M62 31h1v1h-1z",
    fill: "#e4e8ed"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v-1h1v1z",
    fill: "#e9eaea"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M64 31h1v1h-1z",
    fill: "#e8dcd6"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v-1h1v1z",
    fill: "#95605c"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M66 32v-1h1v1z",
    fill: "#79282e"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32h-1v-1h1z",
    fill: "#bc7a7c"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31v1h-1v-1z",
    fill: "#9b3f46"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M69 31h1v1h-1z",
    fill: "#a6212c"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M71 31v1h-1v-1z",
    fill: "#961923",
    fillOpacity: 0.839
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32v-1h1v1z",
    fill: "#672f38",
    fillOpacity: 0.212
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M73 31v1h-1v-1z",
    fill: "#cfb4b3",
    fillOpacity: 0.953
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v-1h1v1z",
    fill: "#e0cdc9"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M74 31h1v1h-1z",
    fill: "#8a2425"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M76 32h-1v-1h1z",
    fill: "#6b1813"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M77 32h-1v-1h1z",
    fill: "#602d27"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h-1v-1h1z",
    fill: "#9f7861"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31v1h-1v-1z",
    fill: "#ae6a62"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M79 31h1v1h-1z",
    fill: "#c29e99"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v-1h1v1z",
    fill: "#c4bcb4"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M81 31h1v1h-1z",
    fill: "#9e948c"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M82 31h1v1h-1z",
    fill: "#7f7771"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32v-1h1v1z",
    fill: "#59504e"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32h-1v-1h1z",
    fill: "#373028"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M86 32h-1v-1h1z",
    fill: "#2b2815"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M87 32h-1v-1h1z",
    fill: "#221f15"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M88 31v1h-1v-1z",
    fill: "#1a1212"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M88 32v-1h1v1z",
    fill: "#1b1315"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h-1v-1h1z",
    fill: "#1c1515"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31v1h-1v-1z",
    fill: "#11130e"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M92 31h1v1h-1z",
    fill: "#16150e"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32v-1h1v1z",
    fill: "#1d160e"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M95 31v1h-1v-1z",
    fill: "#1e160b"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32h-1v-1h1z",
    fill: "#242118"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32h-1v-1h1z",
    fill: "#36302e"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M97 32v-1h1v1z",
    fill: "#4c413e"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M99 31v1h-1v-1z",
    fill: "#6c5d58"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M100 31v1h-1v-1z",
    fill: "#8e7d78"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M100 32v-1h1v1z",
    fill: "#b39f9c"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M102 31v1h-1v-1z",
    fill: "#deccc8"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M102 32v-1h1v1z",
    fill: "#f9eeec"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M103 31h1v1h-1z",
    fill: "#eedcd9"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M105 31v1h-1v-1z",
    fill: "#ddc8b9",
    fillOpacity: 0.992
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M105 32v-1h1v1z",
    fill: "#b2a58a",
    fillOpacity: 0.224
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M42 32v1h-1v-1z",
    fill: "#d8d3d8",
    fillOpacity: 0.208
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M43 32v1h-1v-1z",
    fill: "#dacbb9",
    fillOpacity: 0.988
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M44 32v1h-1v-1z",
    fill: "#d6b98c"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33v-1h1v1z",
    fill: "#e1c18e"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32v1h-1v-1z",
    fill: "#9a4c38"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M46 32h1v1h-1z",
    fill: "#8d0613"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M48 32v1h-1v-1z",
    fill: "#830f13"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v-1h1v1z",
    fill: "#b9857d"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33h-1v-1h1z",
    fill: "#e9d7ca"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33h-1v-1h1z",
    fill: "#eee6e0"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M51 33v-1h1v1z",
    fill: "#ecebe8"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M53 32v1h-1v-1z",
    fill: "#eeefeb"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33v-1h1v1z",
    fill: "#eef0ec"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M55 32v1h-1v-1z",
    fill: "#ececec"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M56 33h-1v-1h1z",
    fill: "#e8e8e6"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33h-1v-1h1z",
    fill: "#e6e6e4"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M58 32v1h-1v-1z",
    fill: "#e1e1e0"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M58 33v-1h1v1z",
    fill: "#dadcdb"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M60 32v1h-1v-1z",
    fill: "#dadddd"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33h-1v-1h1z",
    fill: "#dddddb"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32v1h-1v-1z",
    fill: "#dcd8d1"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M63 32h1v1h-1z",
    fill: "#d6c6ba"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M65 32v1h-1v-1z",
    fill: "#865956"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M65 33v-1h1v1z",
    fill: "#681216"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v-1h1v1z",
    fill: "#8e363c"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M68 32v1h-1v-1z",
    fill: "#b97978"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h-1v-1h1z",
    fill: "#9e3b3f"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33h-1v-1h1z",
    fill: "#ae1f2a"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M70 33v-1h1v1z",
    fill: "#941722",
    fillOpacity: 0.78
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M71 32h1v1h-1z",
    fill: "#16000b",
    fillOpacity: 0.09
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M73 32v1h-1v-1z",
    fill: "#c4b2ac",
    fillOpacity: 0.89
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M74 32v1h-1v-1z",
    fill: "#d6afad"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M75 32v1h-1v-1z",
    fill: "#891717"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M75 33v-1h1v1z",
    fill: "#86251d"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33h-1v-1h1z",
    fill: "#7e312b"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M77 33v-1h1v1z",
    fill: "#a07354"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M78 32h1v1h-1z",
    fill: "#ba6756"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M80 32v1h-1v-1z",
    fill: "#ba7571"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h-1v-1h1z",
    fill: "#f6e6e1"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M81 32h1v1h-1z",
    fill: "#ecdcd1"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M82 33v-1h1v1z",
    fill: "#d1c2a2"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M83 32h1v1h-1z",
    fill: "#c0b17e"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M85 32v1h-1v-1z",
    fill: "#b5a570"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h-1v-1h1z",
    fill: "#aea070"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h-1v-1h1z",
    fill: "#a8997f"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33v-1h1v1z",
    fill: "#a79589"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33h-1v-1h1z",
    fill: "#ab9990"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v-1h1v1z",
    fill: "#a8968d"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M90 32h1v1h-1z",
    fill: "#9c8781"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M92 32v1h-1v-1z",
    fill: "#8c7870"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h-1v-1h1z",
    fill: "#715c50"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M93 32h1v1h-1z",
    fill: "#553629"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M94 33v-1h1v1z",
    fill: "#5e3d29"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M96 32v1h-1v-1z",
    fill: "#816655"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v-1h1v1z",
    fill: "#b9a19b"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33h-1v-1h1z",
    fill: "#bfa59e"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M98 32h1v1h-1z",
    fill: "#c8aca1"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33v-1h1v1z",
    fill: "#c1a79b"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M101 33h-1v-1h1z",
    fill: "#927267"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M102 33h-1v-1h1z",
    fill: "#d9c2c0"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32v1h-1v-1z",
    fill: "#efe2e1"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M103 32h1v1h-1z",
    fill: "#e7d6d1"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33h-1v-1h1z",
    fill: "#d7c4b4",
    fillOpacity: 0.961
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M106 32v1h-1v-1z",
    fill: "#aea182",
    fillOpacity: 0.161
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M25 33h1v1h-1z",
    fill: "#aa8d8d",
    fillOpacity: 0.071
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M26 33h1v1h-1z",
    fill: "#915353",
    fillOpacity: 0.192
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h-1v-1h1z",
    fill: "#97414a",
    fillOpacity: 0.337
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34v-1h1v1z",
    fill: "#94393e",
    fillOpacity: 0.451
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M29 33h1v1h-1z",
    fill: "#93383a",
    fillOpacity: 0.529
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M31 33v1h-1v-1z",
    fill: "#903434",
    fillOpacity: 0.588
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h-1v-1h1z",
    fill: "#8f3634",
    fillOpacity: 0.608
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M33 33v1h-1v-1z",
    fill: "#954142",
    fillOpacity: 0.627
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34v-1h1v1z",
    fill: "#9e4950",
    fillOpacity: 0.624
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M35 33v1h-1v-1z",
    fill: "#a14e55",
    fillOpacity: 0.608
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M35 34v-1h1v1z",
    fill: "#a15156",
    fillOpacity: 0.576
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M36 33h1v1h-1z",
    fill: "#a05056",
    fillOpacity: 0.51
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M37 33h1v1h-1z",
    fill: "#9d4e53",
    fillOpacity: 0.42
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M38 33h1v1h-1z",
    fill: "#93474e",
    fillOpacity: 0.306
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M39 33h1v1h-1z",
    fill: "#82474d",
    fillOpacity: 0.169
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M40 34v-1h1v1z",
    fill: "#977",
    fillOpacity: 0.059
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34h-1v-1h1z",
    fill: "#eaffff",
    fillOpacity: 0.098
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34h-1v-1h1z",
    fill: "#e0d7ca",
    fillOpacity: 0.922
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M43 33h1v1h-1z",
    fill: "#e3c6a3"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M44 33h1v1h-1z",
    fill: "#e3c4a2"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M45 33h1v1h-1z",
    fill: "#c49173"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M47 34h-1v-1h1z",
    fill: "#7f100f"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M48 33v1h-1v-1z",
    fill: "#960d15"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M50 33v1h-1v-1z",
    fill: "#954642"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34v-1h1v1z",
    fill: "#c49987"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M52 33v1h-1v-1z",
    fill: "#d6c1aa"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v-1h1v1z",
    fill: "#e0d9cb"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M53 33h1v1h-1z",
    fill: "#e5e2dc"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M54 33h1v1h-1z",
    fill: "#ded4cd"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34h-1v-1h1z",
    fill: "#c0b29f"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M57 33v1h-1v-1z",
    fill: "#b7a491"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M58 34h-1v-1h1z",
    fill: "#beb1a6"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M59 33h1v1h-1z",
    fill: "#cac6b9"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M60 33h1v1h-1z",
    fill: "#cabdb0"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M62 33v1h-1v-1z",
    fill: "#bea99b"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M62 34v-1h1v1z",
    fill: "#a27f73"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M64 33v1h-1v-1z",
    fill: "#6a2c2b"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M64 34v-1h1v1z",
    fill: "#600910"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M66 33v1h-1v-1z",
    fill: "#7d181c"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33v1h-1v-1z",
    fill: "#903a3f"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M67 33h1v1h-1z",
    fill: "#bd7776"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h-1v-1h1z",
    fill: "#a9343c"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M69 33h1v1h-1z",
    fill: "#b01f2b"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M71 34h-1v-1h1z",
    fill: "#8f1722",
    fillOpacity: 0.69
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h-1v-1h1z",
    fillOpacity: 0.008
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M73 34h-1v-1h1z",
    fill: "#cdc5ba",
    fillOpacity: 0.788
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33v1h-1v-1z",
    fill: "#d6a9a5"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M74 33h1v1h-1z",
    fill: "#a82828"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34v-1h1v1z",
    fill: "#ad2926"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34h-1v-1h1z",
    fill: "#9d312c"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M78 33v1h-1v-1z",
    fill: "#a8744f"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M79 33v1h-1v-1z",
    fill: "#ae5f4d"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h-1v-1h1z",
    fill: "#a25b51"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33v1h-1v-1z",
    fill: "#b4967a"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M81 33h1v1h-1z",
    fill: "#c0b38b"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M82 34v-1h1v1z",
    fill: "#cfc4a1"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33v1h-1v-1z",
    fill: "#ded4bd"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M84 33h1v1h-1z",
    fill: "#ebd9cc"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33v1h-1v-1z",
    fill: "#ecd8d2"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M86 33h1v1h-1z",
    fill: "#ecd7cf"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M87 33h1v1h-1z",
    fill: "#e7d3cc"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M89 33v1h-1v-1z",
    fill: "#e1cdc7"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h-1v-1h1z",
    fill: "#dbc8bc"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33v1h-1v-1z",
    fill: "#d5c1b5"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M91 33h1v1h-1z",
    fill: "#cfb9ae"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h-1v-1h1z",
    fill: "#c0aa9e"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M93 33h1v1h-1z",
    fill: "#a28d7e"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M95 33v1h-1v-1z",
    fill: "#92796d"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33v1h-1v-1z",
    fill: "#a68f82"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M96 33h1v1h-1z",
    fill: "#ae978b"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M98 33v1h-1v-1z",
    fill: "#b2998e"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M98 34v-1h1v1z",
    fill: "#baa398"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M99 33h1v1h-1z",
    fill: "#80695e"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M100 34v-1h1v1z",
    fill: "#704b3b"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h-1v-1h1z",
    fill: "#ddccc6"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33v1h-1v-1z",
    fill: "#ede3e0"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M103 33h1v1h-1z",
    fill: "#e5d6d1"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M105 33v1h-1v-1z",
    fill: "#c8baa5",
    fillOpacity: 0.918
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M106 33v1h-1v-1z",
    fill: "#756b3a",
    fillOpacity: 0.102
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M23 34v1h-1v-1z",
    fill: "#7f393f",
    fillOpacity: 0.173
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35h-1v-1h1z",
    fill: "#762b2e",
    fillOpacity: 0.455
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M25 35h-1v-1h1z",
    fill: "#722525",
    fillOpacity: 0.718
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M25 34h1v1h-1z",
    fill: "#711818",
    fillOpacity: 0.89
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34h1v1h-1z",
    fill: "#711212",
    fillOpacity: 0.98
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M27 34h1v1h-1z",
    fill: "#780f13"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34h1v1h-1z",
    fill: "#7c0a10"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M29 35v-1h1v1z",
    fill: "#7e0910"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M31 35h-1v-1h1z",
    fill: "#7f0b0f"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34v1h-1v-1z",
    fill: "#821216"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M32 34h1v1h-1z",
    fill: "#8c1d22"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M33 34h1v1h-1z",
    fill: "#97292f"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35v-1h1v1z",
    fill: "#a03439"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M36 35h-1v-1h1z",
    fill: "#a94447"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M37 34v1h-1v-1z",
    fill: "#b25053"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35h-1v-1h1z",
    fill: "#b85858"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34v1h-1v-1z",
    fill: "#b55a59"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35v-1h1v1z",
    fill: "#ac4d4e",
    fillOpacity: 0.969
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M41 35h-1v-1h1z",
    fill: "#9e3139",
    fillOpacity: 0.875
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M42 34v1h-1v-1z",
    fill: "#96343d",
    fillOpacity: 0.718
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M42 35v-1h1v1z",
    fill: "#c18c7c",
    fillOpacity: 0.941
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M44 34v1h-1v-1z",
    fill: "#deb99d"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M45 35h-1v-1h1z",
    fill: "#d8bf97"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M45 34h1v1h-1z",
    fill: "#dbbc8b"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v-1h1v1z",
    fill: "#87311e"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M48 35h-1v-1h1z",
    fill: "#8d0a16"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h-1v-1h1z",
    fill: "#9b0f1c"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35v-1h1v1z",
    fill: "#920e19"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M50 34h1v1h-1z",
    fill: "#861f24"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M52 34v1h-1v-1z",
    fill: "#954340"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M53 34v1h-1v-1z",
    fill: "#a36f61"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v-1h1v1z",
    fill: "#b99485"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M55 34v1h-1v-1z",
    fill: "#9a6e63"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v-1h1v1z",
    fill: "#9b6f5b"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M56 35v-1h1v1z",
    fill: "#a78568"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M57 34h1v1h-1z",
    fill: "#7c5349"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35v-1h1v1z",
    fill: "#977469"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34v1h-1v-1z",
    fill: "#856354"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M60 34h1v1h-1z",
    fill: "#7b4a45"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35v-1h1v1z",
    fill: "#6a2a2b"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M63 35h-1v-1h1z",
    fill: "#5c0f13"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M64 35h-1v-1h1z",
    fill: "#6a1019"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34v1h-1v-1z",
    fill: "#750e16"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M65 34h1v1h-1z",
    fill: "#83171c"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35h-1v-1h1z",
    fill: "#9c4048"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M67 34h1v1h-1z",
    fill: "#c67778"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35h-1v-1h1z",
    fill: "#aa3339"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M69 34h1v1h-1z",
    fill: "#af212a"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M71 35h-1v-1h1z",
    fill: "#891722",
    fillOpacity: 0.588
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M72 34h1v1h-1z",
    fill: "#cdc6bf",
    fillOpacity: 0.706
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M73 35v-1h1v1z",
    fill: "#dcb4b3"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v-1h1v1z",
    fill: "#ba3032"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M75 34h1v1h-1z",
    fill: "#bf2d2a"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M77 34v1h-1v-1z",
    fill: "#ac3635"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M78 34v1h-1v-1z",
    fill: "#b8825d"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35v-1h1v1z",
    fill: "#9c5b50"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M79 34h1v1h-1z",
    fill: "#9e6d57"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M80 34h1v1h-1z",
    fill: "#b5735b"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M81 34h1v1h-1z",
    fill: "#e9c9c1"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M83 34v1h-1v-1z",
    fill: "#fdf6f3"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h-1v-1h1z",
    fill: "#f8eee6"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M85 34v1h-1v-1z",
    fill: "#f6e8de"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M85 35v-1h1v1z",
    fill: "#f0e0db"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35h-1v-1h1z",
    fill: "#ecd7d0"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M87 35v-1h1v1z",
    fill: "#e5d0ca"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M88 34h1v1h-1z",
    fill: "#dfcac5"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M90 35h-1v-1h1z",
    fill: "#d8c5bb"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M90 34h1v1h-1z",
    fill: "#d2bab1"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35h-1v-1h1z",
    fill: "#c9ada6"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M92 35v-1h1v1z",
    fill: "#bda29b"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M93 34h1v1h-1z",
    fill: "#b29b92"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M95 35h-1v-1h1z",
    fill: "#af958e"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35h-1v-1h1z",
    fill: "#ad908a"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M97 35h-1v-1h1z",
    fill: "#ae9288"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h-1v-1h1z",
    fill: "#b1948b"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M99 34v1h-1v-1z",
    fill: "#ba9e99"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M99 35v-1h1v1z",
    fill: "#5a4239"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M101 34v1h-1v-1z",
    fill: "#917267"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v-1h1v1z",
    fill: "#e6d9cf"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M102 34h1v1h-1z",
    fill: "#ede0dd"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35h-1v-1h1z",
    fill: "#e8d6d1"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M104 35v-1h1v1z",
    fill: "#cbbfa8",
    fillOpacity: 0.847
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M106 35h-1v-1h1z",
    fill: "#8b8b45",
    fillOpacity: 0.043
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M20 36v-1h1v1z",
    fill: "#7a343b",
    fillOpacity: 0.286
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M22 36h-1v-1h1z",
    fill: "#732021",
    fillOpacity: 0.718
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M22 35h1v1h-1z",
    fill: "#6f191b",
    fillOpacity: 0.957
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M24 35v1h-1v-1z",
    fill: "#671012"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h-1v-1h1z",
    fill: "#590a0b"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "M26 35v1h-1v-1z",
    fill: "#54070c"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "M26 36v-1h1v1z",
    fill: "#5b1215"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36h-1v-1h1z",
    fill: "#682324"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36h-1v-1h1z",
    fill: "#7c3833"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "M29 36v-1h1v1z",
    fill: "#8d4942"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "M30 35h1v1h-1z",
    fill: "#955348"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v-1h1v1z",
    fill: "#9c5c53"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "M32 35h1v1h-1z",
    fill: "#ab6c65"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "M33 35h1v1h-1z",
    fill: "#ad6f6a"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "M34 35h1v1h-1z",
    fill: "#ac6862"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "M35 35h1v1h-1z",
    fill: "#ac6762"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "M37 36h-1v-1h1z",
    fill: "#a9625d"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "M38 35v1h-1v-1z",
    fill: "#a1544c"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v-1h1v1z",
    fill: "#9a413f"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "M39 35h1v1h-1z",
    fill: "#9f3839"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "M41 36h-1v-1h1z",
    fill: "#a42c2d"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "M42 36h-1v-1h1z",
    fill: "#9e1e22"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35v1h-1v-1z",
    fill: "#981816"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h-1v-1h1z",
    fill: "#a73a36"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "M44 35h1v1h-1z",
    fill: "#be735e"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "M46 35v1h-1v-1z",
    fill: "#e0c0a4"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36h-1v-1h1z",
    fill: "#a46644"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v-1h1v1z",
    fill: "#79050b"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36v-1h1v1z",
    fill: "#960b16"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "M49 35h1v1h-1z",
    fill: "#9d1e22"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35h1v1h-1z",
    fill: "#a1242c"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "M51 35h1v1h-1z",
    fill: "#951522"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35v1h-1v-1z",
    fill: "#9a3036"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "M53 35h1v1h-1z",
    fill: "#8b3132"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "M55 35v1h-1v-1z",
    fill: "#7a1720"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "M55 36v-1h1v1z",
    fill: "#81262c"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "M57 36h-1v-1h1z",
    fill: "#884343"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "M58 36h-1v-1h1z",
    fill: "#630d14"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "M58 35h1v1h-1z",
    fill: "#660c11"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "M59 35h1v1h-1z",
    fill: "#5c0810"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "M60 35h1v1h-1z",
    fill: "#691117"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "M61 35h1v1h-1z",
    fill: "#731517"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v-1h1v1z",
    fill: "#751316"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "M63 36v-1h1v1z",
    fill: "#7a111a"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "M65 35v1h-1v-1z",
    fill: "#7e0e16"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "M65 36v-1h1v1z",
    fill: "#8c181f"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "M67 35v1h-1v-1z",
    fill: "#ac4c53"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36v-1h1v1z",
    fill: "#ca7375"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "M69 35v1h-1v-1z",
    fill: "#ae2e34"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "M70 35v1h-1v-1z",
    fill: "#b0232d"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v-1h1v1z",
    fill: "#8d1e2c",
    fillOpacity: 0.518
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "M72 35h1v1h-1z",
    fill: "#cfc3c3",
    fillOpacity: 0.608
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "M74 35v1h-1v-1z",
    fill: "#e7c7c2"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h-1v-1h1z",
    fill: "#be3536"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36v-1h1v1z",
    fill: "#bd2a27"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "M77 36h-1v-1h1z",
    fill: "#9e3a31"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "M77 35h1v1h-1z",
    fill: "#ac8260"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "M78 35h1v1h-1z",
    fill: "#995c51"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "M80 36h-1v-1h1z",
    fill: "#a36155"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "M80 35h1v1h-1z",
    fill: "#af5d53"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "M81 35h1v1h-1z",
    fill: "#a57673"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36v-1h1v1z",
    fill: "#d4c5c1"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "M83 35h1v1h-1z",
    fill: "#d7c9c1"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "M84 35h1v1h-1z",
    fill: "#d2c5bc"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "M86 35v1h-1v-1z",
    fill: "#cdc0bb"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v-1h1v1z",
    fill: "#ccbab7"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36v-1h1v1z",
    fill: "#cdb8b4"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36h-1v-1h1z",
    fill: "#c9b6b2"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "M89 36v-1h1v1z",
    fill: "#c4b4ae"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "M91 35v1h-1v-1z",
    fill: "#c2aca4"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "M91 36v-1h1v1z",
    fill: "#bba39b"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "M92 36v-1h1v1z",
    fill: "#b39a92"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36h-1v-1h1z",
    fill: "#ad9089"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "M94 36v-1h1v1z",
    fill: "#ab8e85"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "M96 35v1h-1v-1z",
    fill: "#ad9087"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "M96 36v-1h1v1z",
    fill: "#b0948d"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35v1h-1v-1z",
    fill: "#b89d98"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "M98 35h1v1h-1z",
    fill: "#a9918b"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36v-1h1v1z",
    fill: "#695044"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "M101 35v1h-1v-1z",
    fill: "#c9afa7"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "M101 36v-1h1v1z",
    fill: "#e5d8d4"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "M102 35h1v1h-1z",
    fill: "#eddfdc"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "M103 36v-1h1v1z",
    fill: "#ebd7d2"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "M105 36h-1v-1h1z",
    fill: "#bcb09a",
    fillOpacity: 0.765
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "M106 36h-1v-1h1z",
    fillOpacity: 0.004
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "M19 36h1v1h-1z",
    fill: "#802831",
    fillOpacity: 0.522
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "M20 37v-1h1v1z",
    fill: "#881621",
    fillOpacity: 0.992
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37h-1v-1h1z",
    fill: "#852327"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "M22 37v-1h1v1z",
    fill: "#571513"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37h-1v-1h1z",
    fill: "#4e1713"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h1v1h-1z",
    fill: "#754038"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "M25 36h1v1h-1z",
    fill: "#a47c6e"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "M27 37h-1v-1h1z",
    fill: "#be9b93"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v1h-1v-1z",
    fill: "#d7c7bc"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37h-1v-1h1z",
    fill: "#e5ded3"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "M30 37h-1v-1h1z",
    fill: "#ece6da"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36v1h-1v-1z",
    fill: "#eae3d7"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "M31 36h1v1h-1z",
    fill: "#e7e0d5"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "M32 36h1v1h-1z",
    fill: "#ebe7de"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "M33 37v-1h1v1z",
    fill: "#e6e3de"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "M35 36v1h-1v-1z",
    fill: "#dcd6ce"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "M36 37h-1v-1h1z",
    fill: "#e0dad5"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37h-1v-1h1z",
    fill: "#dfd7d1"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36v1h-1v-1z",
    fill: "#e4d4c6"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "M38 36h1v1h-1z",
    fill: "#dec1a7"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37h-1v-1h1z",
    fill: "#be835e"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "M40 37v-1h1v1z",
    fill: "#923325"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "M41 37v-1h1v1z",
    fill: "#891b23"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "M43 37h-1v-1h1z",
    fill: "#961e24"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "M43 36h1v1h-1z",
    fill: "#931116"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "M44 36h1v1h-1z",
    fill: "#9e2120"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36v1h-1v-1z",
    fill: "#ad514b"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "M47 36v1h-1v-1z",
    fill: "#bc845f"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37h-1v-1h1z",
    fill: "#67130d"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "M48 36h1v1h-1z",
    fill: "#810911"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "M50 36v1h-1v-1z",
    fill: "#922124"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36v1h-1v-1z",
    fill: "#a13c3f"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "M51 36h1v1h-1z",
    fill: "#963334"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "M53 37h-1v-1h1z",
    fill: "#a23131"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h-1v-1h1z",
    fill: "#9e3233"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37v-1h1v1z",
    fill: "#941a21"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h-1v-1h1z",
    fill: "#851019"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "M57 37h-1v-1h1z",
    fill: "#780a13"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h-1v-1h1z",
    fill: "#740c11"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "M59 37h-1v-1h1z",
    fill: "#792127"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "M59 36h1v1h-1z",
    fill: "#71161b"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "M61 37h-1v-1h1z",
    fill: "#721316"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36v1h-1v-1z",
    fill: "#7b1b21"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "M62 36h1v1h-1z",
    fill: "#78181f"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h-1v-1h1z",
    fill: "#7f161e"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "M65 37h-1v-1h1z",
    fill: "#88101a"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "M66 36v1h-1v-1z",
    fill: "#951d23"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "M67 37h-1v-1h1z",
    fill: "#b6595c"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "M67 36h1v1h-1z",
    fill: "#c97774"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "M68 37v-1h1v1z",
    fill: "#b0353b"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36v1h-1v-1z",
    fill: "#ac373e"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "M70 36h1v1h-1z",
    fill: "#893339",
    fillOpacity: 0.467
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "M73 36v1h-1v-1z",
    fill: "#b57478",
    fillOpacity: 0.49
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v-1h1v1z",
    fill: "#bc5155"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "M75 37h-1v-1h1z",
    fill: "#c03c41"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "M75 36h1v1h-1z",
    fill: "#852c24"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h-1v-1h1z",
    fill: "#754431"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "M78 36v1h-1v-1z",
    fill: "#7d5541"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37h-1v-1h1z",
    fill: "#866858"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "M79 36h1v1h-1z",
    fill: "#7e6758"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36v1h-1v-1z",
    fill: "#826857"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "M81 36h1v1h-1z",
    fill: "#775a47"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "M82 36h1v1h-1z",
    fill: "#785c4d"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "M84 36v1h-1v-1z",
    fill: "#785d4a"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "M85 36v1h-1v-1z",
    fill: "#73523b"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36v1h-1v-1z",
    fill: "#593927"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "M86 36h1v1h-1z",
    fill: "#4f2d1f"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "M87 36h1v1h-1z",
    fill: "#562e21"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "M88 37v-1h1v1z",
    fill: "#4f2a1d"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "M90 36v1h-1v-1z",
    fill: "#452317"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v-1h1v1z",
    fill: "#47231e"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37h-1v-1h1z",
    fill: "#40201b"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "M93 36v1h-1v-1z",
    fill: "#3f221c"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "M93 37v-1h1v1z",
    fill: "#482a25"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "M95 36v1h-1v-1z",
    fill: "#442620"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "M96 37h-1v-1h1z",
    fill: "#4f302b"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "M97 36v1h-1v-1z",
    fill: "#50342e"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37v-1h1v1z",
    fill: "#5d4440"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "M98 36h1v1h-1z",
    fill: "#5a4138"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36h1v1h-1z",
    fill: "#6c5041"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "M101 37h-1v-1h1z",
    fill: "#a9978f"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "M102 36v1h-1v-1z",
    fill: "#e2d7d7"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "M102 37v-1h1v1z",
    fill: "#dbceca"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "M104 37h-1v-1h1z",
    fill: "#ead6d1"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "M105 36v1h-1v-1z",
    fill: "#b9ad96",
    fillOpacity: 0.659
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "M19 37v1h-1v-1z",
    fill: "#984c4c",
    fillOpacity: 0.224
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v-1h1v1z",
    fill: "#8c151d"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37v1h-1v-1z",
    fill: "#96212a"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "M22 38h-1v-1h1z",
    fill: "#6e1d22"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "M23 37v1h-1v-1z",
    fill: "#7a4336"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "M24 37v1h-1v-1z",
    fill: "#c3a793"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "M25 37v1h-1v-1z",
    fill: "#e6d3c2"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "M25 38v-1h1v1z",
    fill: "#ece2d4"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38h-1v-1h1z",
    fill: "#bebdb5"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "M27 38v-1h1v1z",
    fill: "#b7b6b2"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "M29 37v1h-1v-1z",
    fill: "#b8b9b5"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38v-1h1v1z",
    fill: "#bcbcbd"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "M31 37v1h-1v-1z",
    fill: "#aca9ac"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38v-1h1v1z",
    fill: "#c5bfc1"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "M32 37h1v1h-1z",
    fill: "#cecbcc"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37v1h-1v-1z",
    fill: "#d5cfce"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "M34 37h1v1h-1z",
    fill: "#d0ccca"
  })), _path1705 || (_path1705 = /*#__PURE__*/React.createElement("path", {
    d: "M35 37h1v1h-1z",
    fill: "#d3cac5"
  })), _path1706 || (_path1706 = /*#__PURE__*/React.createElement("path", {
    d: "M37 37v1h-1v-1z",
    fill: "#c3b5aa"
  })), _path1707 || (_path1707 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v-1h1v1z",
    fill: "#ae8a79"
  })), _path1708 || (_path1708 = /*#__PURE__*/React.createElement("path", {
    d: "M39 37v1h-1v-1z",
    fill: "#8c5236"
  })), _path1709 || (_path1709 = /*#__PURE__*/React.createElement("path", {
    d: "M39 38v-1h1v1z",
    fill: "#842f18"
  })), _path1710 || (_path1710 = /*#__PURE__*/React.createElement("path", {
    d: "M41 38h-1v-1h1z",
    fill: "#8a2d1c"
  })), _path1711 || (_path1711 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38h-1v-1h1z",
    fill: "#993d31"
  })), _path1712 || (_path1712 = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-1h1v1z",
    fill: "#80201f"
  })), _path1713 || (_path1713 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h-1v-1h1z",
    fill: "#922b2f"
  })), _path1714 || (_path1714 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38v-1h1v1z",
    fill: "#a32f2e"
  })), _path1715 || (_path1715 = /*#__PURE__*/React.createElement("path", {
    d: "M46 37v1h-1v-1z",
    fill: "#a22d2a"
  })), _path1716 || (_path1716 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v-1h1v1z",
    fill: "#bd806c"
  })), _path1717 || (_path1717 = /*#__PURE__*/React.createElement("path", {
    d: "M48 37v1h-1v-1z",
    fill: "#763724"
  })), _path1718 || (_path1718 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v-1h1v1z",
    fill: "#670a0f"
  })), _path1719 || (_path1719 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v-1h1v1z",
    fill: "#a85858"
  })), _path1720 || (_path1720 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h-1v-1h1z",
    fill: "#b1696f"
  })), _path1721 || (_path1721 = /*#__PURE__*/React.createElement("path", {
    d: "M51 37h1v1h-1z",
    fill: "#b67a7b"
  })), _path1722 || (_path1722 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38h-1v-1h1z",
    fill: "#ae6d6b"
  })), _path1723 || (_path1723 = /*#__PURE__*/React.createElement("path", {
    d: "M53 38v-1h1v1z",
    fill: "#ae6165"
  })), _path1724 || (_path1724 = /*#__PURE__*/React.createElement("path", {
    d: "M54 37h1v1h-1z",
    fill: "#99484c"
  })), _path1725 || (_path1725 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38h-1v-1h1z",
    fill: "#9f484c"
  })), _path1726 || (_path1726 = /*#__PURE__*/React.createElement("path", {
    d: "M56 37h1v1h-1z",
    fill: "#933d41"
  })), _path1727 || (_path1727 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37v1h-1v-1z",
    fill: "#8c4043"
  })), _path1728 || (_path1728 = /*#__PURE__*/React.createElement("path", {
    d: "M58 37h1v1h-1z",
    fill: "#9b636a"
  })), _path1729 || (_path1729 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37v1h-1v-1z",
    fill: "#904f53"
  })), _path1730 || (_path1730 = /*#__PURE__*/React.createElement("path", {
    d: "M60 37h1v1h-1z",
    fill: "#94585a"
  })), _path1731 || (_path1731 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h-1v-1h1z",
    fill: "#ae7b81"
  })), _path1732 || (_path1732 = /*#__PURE__*/React.createElement("path", {
    d: "M62 37h1v1h-1z",
    fill: "#ac6e76"
  })), _path1733 || (_path1733 = /*#__PURE__*/React.createElement("path", {
    d: "M63 38v-1h1v1z",
    fill: "#a0474c"
  })), _path1734 || (_path1734 = /*#__PURE__*/React.createElement("path", {
    d: "M64 37h1v1h-1z",
    fill: "#8e101a"
  })), _path1735 || (_path1735 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v-1h1v1z",
    fill: "#a22530"
  })), _path1736 || (_path1736 = /*#__PURE__*/React.createElement("path", {
    d: "M66 37h1v1h-1z",
    fill: "#c06565"
  })), _path1737 || (_path1737 = /*#__PURE__*/React.createElement("path", {
    d: "M68 38h-1v-1h1z",
    fill: "#c86f6e"
  })), _path1738 || (_path1738 = /*#__PURE__*/React.createElement("path", {
    d: "M69 38h-1v-1h1z",
    fill: "#ba4e56"
  })), _path1739 || (_path1739 = /*#__PURE__*/React.createElement("path", {
    d: "M70 37v1h-1v-1z",
    fill: "#934542"
  })), _path1740 || (_path1740 = /*#__PURE__*/React.createElement("path", {
    d: "M70 38v-1h1v1z",
    fill: "#733c3c",
    fillOpacity: 0.4
  })), _path1741 || (_path1741 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37v1h-1v-1z",
    fill: "#b05a62",
    fillOpacity: 0.408
  })), _path1742 || (_path1742 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37h1v1h-1z",
    fill: "#cc5f63"
  })), _path1743 || (_path1743 = /*#__PURE__*/React.createElement("path", {
    d: "M74 37h1v1h-1z",
    fill: "#c3353a"
  })), _path1744 || (_path1744 = /*#__PURE__*/React.createElement("path", {
    d: "M75 38v-1h1v1z",
    fill: "#822a23"
  })), _path1745 || (_path1745 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37v1h-1v-1z",
    fill: "#756f65"
  })), _path1746 || (_path1746 = /*#__PURE__*/React.createElement("path", {
    d: "M77 37h1v1h-1z",
    fill: "#aba8a5"
  })), _path1747 || (_path1747 = /*#__PURE__*/React.createElement("path", {
    d: "M79 37v1h-1v-1z",
    fill: "#9d9c99"
  })), _path1748 || (_path1748 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37v1h-1v-1z",
    fill: "#cecdcb"
  })), _path1749 || (_path1749 = /*#__PURE__*/React.createElement("path", {
    d: "M80 37h1v1h-1z",
    fill: "#b7b7b4"
  })), _path1750 || (_path1750 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v-1h1v1z",
    fill: "#c9c6c4"
  })), _path1751 || (_path1751 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38v-1h1v1z",
    fill: "#aeadaa"
  })), _path1752 || (_path1752 = /*#__PURE__*/React.createElement("path", {
    d: "M83 37h1v1h-1z",
    fill: "#5f5d59"
  })), _path1753 || (_path1753 = /*#__PURE__*/React.createElement("path", {
    d: "M84 37h1v1h-1z",
    fill: "#bfbbb5"
  })), _path1754 || (_path1754 = /*#__PURE__*/React.createElement("path", {
    d: "M85 37h1v1h-1z",
    fill: "#6e6a65"
  })), _path1755 || (_path1755 = /*#__PURE__*/React.createElement("path", {
    d: "M87 37v1h-1v-1z",
    fill: "#383430"
  })), _path1756 || (_path1756 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38v-1h1v1z",
    fill: "#a49f9b"
  })), _path1757 || (_path1757 = /*#__PURE__*/React.createElement("path", {
    d: "M88 38v-1h1v1z",
    fill: "#8e8a86"
  })), _path1758 || (_path1758 = /*#__PURE__*/React.createElement("path", {
    d: "M90 37v1h-1v-1z",
    fill: "#8b8a85"
  })), _path1759 || (_path1759 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h-1v-1h1z",
    fill: "#757471"
  })), _path1760 || (_path1760 = /*#__PURE__*/React.createElement("path", {
    d: "M92 37v1h-1v-1z",
    fill: "#656361"
  })), _path1761 || (_path1761 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h-1v-1h1z",
    fill: "#5b5957"
  })), _path1762 || (_path1762 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h-1v-1h1z",
    fill: "#251f1d"
  })), _path1763 || (_path1763 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38v-1h1v1z",
    fill: "#544d4b"
  })), _path1764 || (_path1764 = /*#__PURE__*/React.createElement("path", {
    d: "M95 37h1v1h-1z",
    fill: "#2f2827"
  })), _path1765 || (_path1765 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38v-1h1v1z",
    fill: "#342d29"
  })), _path1766 || (_path1766 = /*#__PURE__*/React.createElement("path", {
    d: "M97 37h1v1h-1z",
    fill: "#372c29"
  })), _path1767 || (_path1767 = /*#__PURE__*/React.createElement("path", {
    d: "M98 38v-1h1v1z",
    fill: "#54423e"
  })), _path1768 || (_path1768 = /*#__PURE__*/React.createElement("path", {
    d: "M99 38v-1h1v1z",
    fill: "#2e1a15"
  })), _path1769 || (_path1769 = /*#__PURE__*/React.createElement("path", {
    d: "M101 37v1h-1v-1z",
    fill: "#4f322c"
  })), _path1770 || (_path1770 = /*#__PURE__*/React.createElement("path", {
    d: "M101 38v-1h1v1z",
    fill: "#dbd1cd"
  })), _path1771 || (_path1771 = /*#__PURE__*/React.createElement("path", {
    d: "M103 37v1h-1v-1z",
    fill: "#6f6564"
  })), _path1772 || (_path1772 = /*#__PURE__*/React.createElement("path", {
    d: "M104 37v1h-1v-1z",
    fill: "#9d8981"
  })), _path1773 || (_path1773 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38v-1h1v1z",
    fill: "#c6b99e",
    fillOpacity: 0.549
  })), _path1774 || (_path1774 = /*#__PURE__*/React.createElement("path", {
    d: "M19 38v1h-1v-1z",
    fill: "#91393f",
    fillOpacity: 0.329
  })), _path1775 || (_path1775 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39v-1h1v1z",
    fill: "#9a1a22"
  })), _path1776 || (_path1776 = /*#__PURE__*/React.createElement("path", {
    d: "M21 39h-1v-1h1z",
    fill: "#83181c"
  })), _path1777 || (_path1777 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h-1v-1h1z",
    fill: "#8f524c"
  })), _path1778 || (_path1778 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v-1h1v1z",
    fill: "#c8ad94"
  })), _path1779 || (_path1779 = /*#__PURE__*/React.createElement("path", {
    d: "M24 38v1h-1v-1z",
    fill: "#b0a594"
  })), _path1780 || (_path1780 = /*#__PURE__*/React.createElement("path", {
    d: "M25 39h-1v-1h1z",
    fill: "#a1908c"
  })), _path1781 || (_path1781 = /*#__PURE__*/React.createElement("path", {
    d: "M26 38v1h-1v-1z",
    fill: "#a38b86"
  })), _path1782 || (_path1782 = /*#__PURE__*/React.createElement("path", {
    d: "M26 39v-1h1v1z",
    fill: "#a1867c"
  })), _path1783 || (_path1783 = /*#__PURE__*/React.createElement("path", {
    d: "M28 38v1h-1v-1z",
    fill: "#957668"
  })), _path1784 || (_path1784 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v-1h1v1z",
    fill: "#a28a80"
  })), _path1785 || (_path1785 = /*#__PURE__*/React.createElement("path", {
    d: "M29 38h1v1h-1z",
    fill: "#c5b3a7"
  })), _path1786 || (_path1786 = /*#__PURE__*/React.createElement("path", {
    d: "M30 38h1v1h-1z",
    fill: "#d6c3ab"
  })), _path1787 || (_path1787 = /*#__PURE__*/React.createElement("path", {
    d: "M31 38h1v1h-1z",
    fill: "#dcccbd"
  })), _path1788 || (_path1788 = /*#__PURE__*/React.createElement("path", {
    d: "M33 38v1h-1v-1z",
    fill: "#d7cbb6"
  })), _path1789 || (_path1789 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v-1h1v1z",
    fill: "#cfb69e"
  })), _path1790 || (_path1790 = /*#__PURE__*/React.createElement("path", {
    d: "M34 38h1v1h-1z",
    fill: "#c3a086"
  })), _path1791 || (_path1791 = /*#__PURE__*/React.createElement("path", {
    d: "M36 38v1h-1v-1z",
    fill: "#a87058"
  })), _path1792 || (_path1792 = /*#__PURE__*/React.createElement("path", {
    d: "M37 38v1h-1v-1z",
    fill: "#925745"
  })), _path1793 || (_path1793 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38v1h-1v-1z",
    fill: "#954f44"
  })), _path1794 || (_path1794 = /*#__PURE__*/React.createElement("path", {
    d: "M38 38h1v1h-1z",
    fill: "#8c3b2a"
  })), _path1795 || (_path1795 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39h-1v-1h1z",
    fill: "#923620"
  })), _path1796 || (_path1796 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v-1h1v1z",
    fill: "#914a33"
  })), _path1797 || (_path1797 = /*#__PURE__*/React.createElement("path", {
    d: "M42 39h-1v-1h1z",
    fill: "#7a3828"
  })), _path1798 || (_path1798 = /*#__PURE__*/React.createElement("path", {
    d: "M43 39h-1v-1h1z",
    fill: "#823a2d"
  })), _path1799 || (_path1799 = /*#__PURE__*/React.createElement("path", {
    d: "M43 38h1v1h-1z",
    fill: "#974338"
  })), _path1800 || (_path1800 = /*#__PURE__*/React.createElement("path", {
    d: "M44 38h1v1h-1z",
    fill: "#ac4341"
  })), _path1801 || (_path1801 = /*#__PURE__*/React.createElement("path", {
    d: "M46 38v1h-1v-1z",
    fill: "#912c2e"
  })), _path1802 || (_path1802 = /*#__PURE__*/React.createElement("path", {
    d: "M47 38v1h-1v-1z",
    fill: "#a77466"
  })), _path1803 || (_path1803 = /*#__PURE__*/React.createElement("path", {
    d: "M48 38v1h-1v-1z",
    fill: "#906042"
  })), _path1804 || (_path1804 = /*#__PURE__*/React.createElement("path", {
    d: "M49 38v1h-1v-1z",
    fill: "#530a07"
  })), _path1805 || (_path1805 = /*#__PURE__*/React.createElement("path", {
    d: "M50 38v1h-1v-1z",
    fill: "#984a4e"
  })), _path1806 || (_path1806 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v-1h1v1z",
    fill: "#a4575b"
  })), _path1807 || (_path1807 = /*#__PURE__*/React.createElement("path", {
    d: "M51 38h1v1h-1z",
    fill: "#a05e62"
  })), _path1808 || (_path1808 = /*#__PURE__*/React.createElement("path", {
    d: "M52 39v-1h1v1z",
    fill: "#cfa7ac"
  })), _path1809 || (_path1809 = /*#__PURE__*/React.createElement("path", {
    d: "M54 39h-1v-1h1z",
    fill: "#9e5d5b"
  })), _path1810 || (_path1810 = /*#__PURE__*/React.createElement("path", {
    d: "M54 38h1v1h-1z",
    fill: "#cea2a8"
  })), _path1811 || (_path1811 = /*#__PURE__*/React.createElement("path", {
    d: "M56 38v1h-1v-1z",
    fill: "#904249"
  })), _path1812 || (_path1812 = /*#__PURE__*/React.createElement("path", {
    d: "M57 38v1h-1v-1z",
    fill: "#aa696d"
  })), _path1813 || (_path1813 = /*#__PURE__*/React.createElement("path", {
    d: "M58 39h-1v-1h1z",
    fill: "#8c4b50"
  })), _path1814 || (_path1814 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38v1h-1v-1z",
    fill: "#bb8f92"
  })), _path1815 || (_path1815 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38h1v1h-1z",
    fill: "#a57175"
  })), _path1816 || (_path1816 = /*#__PURE__*/React.createElement("path", {
    d: "M60 38h1v1h-1z",
    fill: "#a37a79"
  })), _path1817 || (_path1817 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38v1h-1v-1z",
    fill: "#b3898b"
  })), _path1818 || (_path1818 = /*#__PURE__*/React.createElement("path", {
    d: "M62 38h1v1h-1z",
    fill: "#a96970"
  })), _path1819 || (_path1819 = /*#__PURE__*/React.createElement("path", {
    d: "M64 38v1h-1v-1z",
    fill: "#973038"
  })), _path1820 || (_path1820 = /*#__PURE__*/React.createElement("path", {
    d: "M65 38v1h-1v-1z",
    fill: "#9d1c26"
  })), _path1821 || (_path1821 = /*#__PURE__*/React.createElement("path", {
    d: "M66 39h-1v-1h1z",
    fill: "#b13842"
  })), _path1822 || (_path1822 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38v1h-1v-1z",
    fill: "#c8696d"
  })), _path1823 || (_path1823 = /*#__PURE__*/React.createElement("path", {
    d: "M67 38h1v1h-1z",
    fill: "#ca797a"
  })), _path1824 || (_path1824 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39v-1h1v1z",
    fill: "#c4777a"
  })), _path1825 || (_path1825 = /*#__PURE__*/React.createElement("path", {
    d: "M69 39v-1h1v1z",
    fill: "#723d37"
  })), _path1826 || (_path1826 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39h-1v-1h1z",
    fill: "#5e3232",
    fillOpacity: 0.337
  })), _path1827 || (_path1827 = /*#__PURE__*/React.createElement("path", {
    d: "M72 39v-1h1v1z",
    fill: "#a55a60",
    fillOpacity: 0.333
  })), _path1828 || (_path1828 = /*#__PURE__*/React.createElement("path", {
    d: "M73 38h1v1h-1z",
    fill: "#cf5d63"
  })), _path1829 || (_path1829 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39v-1h1v1z",
    fill: "#c23639"
  })), _path1830 || (_path1830 = /*#__PURE__*/React.createElement("path", {
    d: "M76 38v1h-1v-1z",
    fill: "#902620"
  })), _path1831 || (_path1831 = /*#__PURE__*/React.createElement("path", {
    d: "M77 39h-1v-1h1z",
    fill: "#735e54"
  })), _path1832 || (_path1832 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h-1v-1h1z",
    fill: "#e6eae7"
  })), _path1833 || (_path1833 = /*#__PURE__*/React.createElement("path", {
    d: "M79 38v1h-1v-1z",
    fill: "#b3b3b0"
  })), _path1834 || (_path1834 = /*#__PURE__*/React.createElement("path", {
    d: "M80 39h-1v-1h1z",
    fill: "#cecdca"
  })), _path1835 || (_path1835 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38v1h-1v-1z",
    fill: "#959591"
  })), _path1836 || (_path1836 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38h1v1h-1z",
    fill: "#fefffd"
  })), _path1837 || (_path1837 = /*#__PURE__*/React.createElement("path", {
    d: "M82 38h1v1h-1z",
    fill: "#c2c1be"
  })), _path1838 || (_path1838 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38v1h-1v-1z",
    fill: "#999694"
  })), _path1839 || (_path1839 = /*#__PURE__*/React.createElement("path", {
    d: "M84 38h1v1h-1z",
    fill: "#c7c4c1"
  })), _path1840 || (_path1840 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v-1h1v1z",
    fill: "#c7c6c3"
  })), _path1841 || (_path1841 = /*#__PURE__*/React.createElement("path", {
    d: "M86 39v-1h1v1z",
    fill: "#757571"
  })), _path1842 || (_path1842 = /*#__PURE__*/React.createElement("path", {
    d: "M87 38h1v1h-1z",
    fill: "#a7a7a3"
  })), _path1843 || (_path1843 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v-1h1v1z",
    fill: "#9b9b97"
  })), _path1844 || (_path1844 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39v-1h1v1z",
    fill: "#c5c5c1"
  })), _path1845 || (_path1845 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h-1v-1h1z",
    fill: "#636461"
  })), _path1846 || (_path1846 = /*#__PURE__*/React.createElement("path", {
    d: "M91 38h1v1h-1z",
    fill: "#969795"
  })), _path1847 || (_path1847 = /*#__PURE__*/React.createElement("path", {
    d: "M92 38h1v1h-1z",
    fill: "#b4b4b2"
  })), _path1848 || (_path1848 = /*#__PURE__*/React.createElement("path", {
    d: "M93 38h1v1h-1z",
    fill: "#515250"
  })), _path1849 || (_path1849 = /*#__PURE__*/React.createElement("path", {
    d: "M94 38h1v1h-1z",
    fill: "#a5a7a4"
  })), _path1850 || (_path1850 = /*#__PURE__*/React.createElement("path", {
    d: "M96 39h-1v-1h1z",
    fill: "#7f807d"
  })), _path1851 || (_path1851 = /*#__PURE__*/React.createElement("path", {
    d: "M96 38h1v1h-1z",
    fill: "#929290"
  })), _path1852 || (_path1852 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v-1h1v1z",
    fill: "#787876"
  })), _path1853 || (_path1853 = /*#__PURE__*/React.createElement("path", {
    d: "M98 39v-1h1v1z",
    fill: "#808382"
  })), _path1854 || (_path1854 = /*#__PURE__*/React.createElement("path", {
    d: "M100 39h-1v-1h1z",
    fill: "#7d7875"
  })), _path1855 || (_path1855 = /*#__PURE__*/React.createElement("path", {
    d: "M100 38h1v1h-1z",
    fill: "#6f544b"
  })), _path1856 || (_path1856 = /*#__PURE__*/React.createElement("path", {
    d: "M102 38v1h-1v-1z",
    fill: "#ddcec8"
  })), _path1857 || (_path1857 = /*#__PURE__*/React.createElement("path", {
    d: "M102 39v-1h1v1z",
    fill: "#4e4545"
  })), _path1858 || (_path1858 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38v1h-1v-1z",
    fill: "#5e4c43"
  })), _path1859 || (_path1859 = /*#__PURE__*/React.createElement("path", {
    d: "M104 38h1v1h-1z",
    fill: "#cfc2a4",
    fillOpacity: 0.443
  })), _path1860 || (_path1860 = /*#__PURE__*/React.createElement("path", {
    d: "M18 40v-1h1v1z",
    fill: "#883033",
    fillOpacity: 0.329
  })), _path1861 || (_path1861 = /*#__PURE__*/React.createElement("path", {
    d: "M19 39h1v1h-1z",
    fill: "#9e1922"
  })), _path1862 || (_path1862 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40v-1h1v1z",
    fill: "#9e141f"
  })), _path1863 || (_path1863 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39v1h-1v-1z",
    fill: "#94363a"
  })), _path1864 || (_path1864 = /*#__PURE__*/React.createElement("path", {
    d: "M22 39h1v1h-1z",
    fill: "#af7a6a"
  })), _path1865 || (_path1865 = /*#__PURE__*/React.createElement("path", {
    d: "M23 39h1v1h-1z",
    fill: "#c2a687"
  })), _path1866 || (_path1866 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h-1v-1h1z",
    fill: "#98775d"
  })), _path1867 || (_path1867 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40v-1h1v1z",
    fill: "#57311b"
  })), _path1868 || (_path1868 = /*#__PURE__*/React.createElement("path", {
    d: "M27 39v1h-1v-1z",
    fill: "#5b341b"
  })), _path1869 || (_path1869 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39v1h-1v-1z",
    fill: "#653720"
  })), _path1870 || (_path1870 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h-1v-1h1z",
    fill: "#7b3d28"
  })), _path1871 || (_path1871 = /*#__PURE__*/React.createElement("path", {
    d: "M30 39v1h-1v-1z",
    fill: "#92482d"
  })), _path1872 || (_path1872 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40h-1v-1h1z",
    fill: "#aa5f3e"
  })), _path1873 || (_path1873 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v-1h1v1z",
    fill: "#a45137"
  })), _path1874 || (_path1874 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39v1h-1v-1z",
    fill: "#af5a48"
  })), _path1875 || (_path1875 = /*#__PURE__*/React.createElement("path", {
    d: "M33 39h1v1h-1z",
    fill: "#a24a3e"
  })), _path1876 || (_path1876 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v-1h1v1z",
    fill: "#a8695b"
  })), _path1877 || (_path1877 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39v1h-1v-1z",
    fill: "#9b5543"
  })), _path1878 || (_path1878 = /*#__PURE__*/React.createElement("path", {
    d: "M36 39h1v1h-1z",
    fill: "#9c594e"
  })), _path1879 || (_path1879 = /*#__PURE__*/React.createElement("path", {
    d: "M37 40v-1h1v1z",
    fill: "#975652"
  })), _path1880 || (_path1880 = /*#__PURE__*/React.createElement("path", {
    d: "M39 40h-1v-1h1z",
    fill: "#8d5250"
  })), _path1881 || (_path1881 = /*#__PURE__*/React.createElement("path", {
    d: "M40 39v1h-1v-1z",
    fill: "#894f4d"
  })), _path1882 || (_path1882 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39v1h-1v-1z",
    fill: "#804643"
  })), _path1883 || (_path1883 = /*#__PURE__*/React.createElement("path", {
    d: "M41 39h1v1h-1z",
    fill: "#7d2d2b"
  })), _path1884 || (_path1884 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40h-1v-1h1z",
    fill: "#983a35"
  })), _path1885 || (_path1885 = /*#__PURE__*/React.createElement("path", {
    d: "M44 39v1h-1v-1z",
    fill: "#9a3233"
  })), _path1886 || (_path1886 = /*#__PURE__*/React.createElement("path", {
    d: "M44 40v-1h1v1z",
    fill: "#7d1f29"
  })), _path1887 || (_path1887 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h-1v-1h1z",
    fill: "#5a1317"
  })), _path1888 || (_path1888 = /*#__PURE__*/React.createElement("path", {
    d: "M47 40h-1v-1h1z",
    fill: "#946658"
  })), _path1889 || (_path1889 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39h1v1h-1z",
    fill: "#996541"
  })), _path1890 || (_path1890 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h-1v-1h1z",
    fill: "#5c160a"
  })), _path1891 || (_path1891 = /*#__PURE__*/React.createElement("path", {
    d: "M50 39v1h-1v-1z",
    fill: "#6e151d"
  })), _path1892 || (_path1892 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39v1h-1v-1z",
    fill: "#8a2f35"
  })), _path1893 || (_path1893 = /*#__PURE__*/React.createElement("path", {
    d: "M51 39h1v1h-1z",
    fill: "#832931"
  })), _path1894 || (_path1894 = /*#__PURE__*/React.createElement("path", {
    d: "M53 39v1h-1v-1z",
    fill: "#9e5254"
  })), _path1895 || (_path1895 = /*#__PURE__*/React.createElement("path", {
    d: "M53 40v-1h1v1z",
    fill: "#a65455"
  })), _path1896 || (_path1896 = /*#__PURE__*/React.createElement("path", {
    d: "M54 40v-1h1v1z",
    fill: "#923a3f"
  })), _path1897 || (_path1897 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40h-1v-1h1z",
    fill: "#9c3f45"
  })), _path1898 || (_path1898 = /*#__PURE__*/React.createElement("path", {
    d: "M56 40v-1h1v1z",
    fill: "#92333b"
  })), _path1899 || (_path1899 = /*#__PURE__*/React.createElement("path", {
    d: "M57 39h1v1h-1z",
    fill: "#8c3a3e"
  })), _path1900 || (_path1900 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39v1h-1v-1z",
    fill: "#8b3e40"
  })), _path1901 || (_path1901 = /*#__PURE__*/React.createElement("path", {
    d: "M59 40v-1h1v1z",
    fill: "#934345"
  })), _path1902 || (_path1902 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v-1h1v1z",
    fill: "#8c383a"
  })), _path1903 || (_path1903 = /*#__PURE__*/React.createElement("path", {
    d: "M61 40v-1h1v1z",
    fill: "#882e36"
  })), _path1904 || (_path1904 = /*#__PURE__*/React.createElement("path", {
    d: "M63 40h-1v-1h1z",
    fill: "#8f2731"
  })), _path1905 || (_path1905 = /*#__PURE__*/React.createElement("path", {
    d: "M63 39h1v1h-1z",
    fill: "#941f27"
  })), _path1906 || (_path1906 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39v1h-1v-1z",
    fill: "#b23742"
  })), _path1907 || (_path1907 = /*#__PURE__*/React.createElement("path", {
    d: "M65 39h1v1h-1z",
    fill: "#bd5259"
  })), _path1908 || (_path1908 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40h-1v-1h1z",
    fill: "#d28988"
  })), _path1909 || (_path1909 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h-1v-1h1z",
    fill: "#daaaa6"
  })), _path1910 || (_path1910 = /*#__PURE__*/React.createElement("path", {
    d: "M68 39h1v1h-1z",
    fill: "#976463"
  })), _path1911 || (_path1911 = /*#__PURE__*/React.createElement("path", {
    d: "M70 40h-1v-1h1z",
    fill: "#572926",
    fillOpacity: 0.996
  })), _path1912 || (_path1912 = /*#__PURE__*/React.createElement("path", {
    d: "M71 39v1h-1v-1z",
    fill: "#5a3336",
    fillOpacity: 0.255
  })), _path1913 || (_path1913 = /*#__PURE__*/React.createElement("path", {
    d: "M72 40v-1h1v1z",
    fill: "#b55a5a",
    fillOpacity: 0.231
  })), _path1914 || (_path1914 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40h-1v-1h1z",
    fill: "#b6292a",
    fillOpacity: 0.996
  })), _path1915 || (_path1915 = /*#__PURE__*/React.createElement("path", {
    d: "M74 39h1v1h-1z",
    fill: "#c4312f"
  })), _path1916 || (_path1916 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40v-1h1v1z",
    fill: "#a53322"
  })), _path1917 || (_path1917 = /*#__PURE__*/React.createElement("path", {
    d: "M76 39h1v1h-1z",
    fill: "#6d4b38"
  })), _path1918 || (_path1918 = /*#__PURE__*/React.createElement("path", {
    d: "M77 40v-1h1v1z",
    fill: "#dddbd7"
  })), _path1919 || (_path1919 = /*#__PURE__*/React.createElement("path", {
    d: "M78 39h1v1h-1z",
    fill: "#dcdddd"
  })), _path1920 || (_path1920 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h-1v-1h1z",
    fill: "#dadbda"
  })), _path1921 || (_path1921 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h-1v-1h1z",
    fill: "#cdcdcd"
  })), _path1922 || (_path1922 = /*#__PURE__*/React.createElement("path", {
    d: "M82 39v1h-1v-1z",
    fill: "#d2d2d2"
  })), _path1923 || (_path1923 = /*#__PURE__*/React.createElement("path", {
    d: "M83 40h-1v-1h1z",
    fill: "#c2c3c2"
  })), _path1924 || (_path1924 = /*#__PURE__*/React.createElement("path", {
    d: "M84 39v1h-1v-1z",
    fill: "#979797"
  })), _path1925 || (_path1925 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39v1h-1v-1z",
    fill: "#d0cece"
  })), _path1926 || (_path1926 = /*#__PURE__*/React.createElement("path", {
    d: "M85 39h1v1h-1z",
    fill: "#adadad"
  })), _path1927 || (_path1927 = /*#__PURE__*/React.createElement("path", {
    d: "M87 39v1h-1v-1z",
    fill: "#757575"
  })), _path1928 || (_path1928 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39v1h-1v-1z",
    fill: "#e0e0e0"
  })), _path1929 || (_path1929 = /*#__PURE__*/React.createElement("path", {
    d: "M88 39h1v1h-1z",
    fill: "#8a8989"
  })), _path1930 || (_path1930 = /*#__PURE__*/React.createElement("path", {
    d: "M90 40h-1v-1h1z",
    fill: "#d0cdcd"
  })), _path1931 || (_path1931 = /*#__PURE__*/React.createElement("path", {
    d: "M90 39h1v1h-1z",
    fill: "#8e8b88"
  })), _path1932 || (_path1932 = /*#__PURE__*/React.createElement("path", {
    d: "M91 39h1v1h-1z",
    fill: "#a9a7a3"
  })), _path1933 || (_path1933 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v-1h1v1z",
    fill: "#a8a8a4"
  })), _path1934 || (_path1934 = /*#__PURE__*/React.createElement("path", {
    d: "M93 40v-1h1v1z",
    fill: "#6c6c68"
  })), _path1935 || (_path1935 = /*#__PURE__*/React.createElement("path", {
    d: "M95 39v1h-1v-1z",
    fill: "#a7a7a2"
  })), _path1936 || (_path1936 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40h-1v-1h1z",
    fill: "#6b6b68"
  })), _path1937 || (_path1937 = /*#__PURE__*/React.createElement("path", {
    d: "M97 39v1h-1v-1z",
    fill: "#82827f"
  })), _path1938 || (_path1938 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h-1v-1h1z",
    fill: "#262725"
  })), _path1939 || (_path1939 = /*#__PURE__*/React.createElement("path", {
    d: "M99 39v1h-1v-1z",
    fill: "#878984"
  })), _path1940 || (_path1940 = /*#__PURE__*/React.createElement("path", {
    d: "M100 40h-1v-1h1z",
    fill: "#5a504a"
  })), _path1941 || (_path1941 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40h-1v-1h1z",
    fill: "#947d75"
  })), _path1942 || (_path1942 = /*#__PURE__*/React.createElement("path", {
    d: "M101 40v-1h1v1z",
    fill: "#b8a7a6"
  })), _path1943 || (_path1943 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40h-1v-1h1z",
    fill: "#473a3b"
  })), _path1944 || (_path1944 = /*#__PURE__*/React.createElement("path", {
    d: "M104 39v1h-1v-1z",
    fill: "#48382f"
  })), _path1945 || (_path1945 = /*#__PURE__*/React.createElement("path", {
    d: "M104 40v-1h1v1z",
    fill: "#c7bfa0",
    fillOpacity: 0.361
  })), _path1946 || (_path1946 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-1v-1h1z",
    fill: "#892c33",
    fillOpacity: 0.314
  })), _path1947 || (_path1947 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41h-1v-1h1z",
    fill: "#9f1720"
  })), _path1948 || (_path1948 = /*#__PURE__*/React.createElement("path", {
    d: "M20 40h1v1h-1z",
    fill: "#ae1a24"
  })), _path1949 || (_path1949 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h-1v-1h1z",
    fill: "#a91b25"
  })), _path1950 || (_path1950 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41h-1v-1h1z",
    fill: "#a01f27"
  })), _path1951 || (_path1951 = /*#__PURE__*/React.createElement("path", {
    d: "M23 41v-1h1v1z",
    fill: "#a8423e"
  })), _path1952 || (_path1952 = /*#__PURE__*/React.createElement("path", {
    d: "M24 41v-1h1v1z",
    fill: "#b56045"
  })), _path1953 || (_path1953 = /*#__PURE__*/React.createElement("path", {
    d: "M25 40h1v1h-1z",
    fill: "#a05135"
  })), _path1954 || (_path1954 = /*#__PURE__*/React.createElement("path", {
    d: "M27 41h-1v-1h1z",
    fill: "#742922"
  })), _path1955 || (_path1955 = /*#__PURE__*/React.createElement("path", {
    d: "M27 40h1v1h-1z",
    fill: "#662421"
  })), _path1956 || (_path1956 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40v1h-1v-1z",
    fill: "#935447"
  })), _path1957 || (_path1957 = /*#__PURE__*/React.createElement("path", {
    d: "M29 40h1v1h-1z",
    fill: "#884937"
  })), _path1958 || (_path1958 = /*#__PURE__*/React.createElement("path", {
    d: "M31 40v1h-1v-1z",
    fill: "#803b32"
  })), _path1959 || (_path1959 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41v-1h1v1z",
    fill: "#8d4c45"
  })), _path1960 || (_path1960 = /*#__PURE__*/React.createElement("path", {
    d: "M32 40h1v1h-1z",
    fill: "#964544"
  })), _path1961 || (_path1961 = /*#__PURE__*/React.createElement("path", {
    d: "M34 40v1h-1v-1z",
    fill: "#902f2c"
  })), _path1962 || (_path1962 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v-1h1v1z",
    fill: "#a76865"
  })), _path1963 || (_path1963 = /*#__PURE__*/React.createElement("path", {
    d: "M36 40v1h-1v-1z",
    fill: "#a04f50"
  })), _path1964 || (_path1964 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h-1v-1h1z",
    fill: "#a3585c"
  })), _path1965 || (_path1965 = /*#__PURE__*/React.createElement("path", {
    d: "M38 41h-1v-1h1z",
    fill: "#99444b"
  })), _path1966 || (_path1966 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h-1v-1h1z",
    fill: "#8b282d"
  })), _path1967 || (_path1967 = /*#__PURE__*/React.createElement("path", {
    d: "M40 41h-1v-1h1z",
    fill: "#871b20"
  })), _path1968 || (_path1968 = /*#__PURE__*/React.createElement("path", {
    d: "M41 40v1h-1v-1z",
    fill: "#881c1e"
  })), _path1969 || (_path1969 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h-1v-1h1z",
    fill: "#861d1f"
  })), _path1970 || (_path1970 = /*#__PURE__*/React.createElement("path", {
    d: "M43 40v1h-1v-1z",
    fill: "#75181d"
  })), _path1971 || (_path1971 = /*#__PURE__*/React.createElement("path", {
    d: "M43 41v-1h1v1z",
    fill: "#590f16"
  })), _path1972 || (_path1972 = /*#__PURE__*/React.createElement("path", {
    d: "M45 40v1h-1v-1z",
    fill: "#451016"
  })), _path1973 || (_path1973 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v-1h1v1z",
    fill: "#481113"
  })), _path1974 || (_path1974 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40h1v1h-1z",
    fill: "#8c5c4f"
  })), _path1975 || (_path1975 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40v1h-1v-1z",
    fill: "#986640"
  })), _path1976 || (_path1976 = /*#__PURE__*/React.createElement("path", {
    d: "M48 40h1v1h-1z",
    fill: "#6d2d16"
  })), _path1977 || (_path1977 = /*#__PURE__*/React.createElement("path", {
    d: "M49 40h1v1h-1z",
    fill: "#5c0c0e"
  })), _path1978 || (_path1978 = /*#__PURE__*/React.createElement("path", {
    d: "M50 41v-1h1v1z",
    fill: "#771b1f"
  })), _path1979 || (_path1979 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41h-1v-1h1z",
    fill: "#76161b"
  })), _path1980 || (_path1980 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v-1h1v1z",
    fill: "#8d3634"
  })), _path1981 || (_path1981 = /*#__PURE__*/React.createElement("path", {
    d: "M53 41v-1h1v1z",
    fill: "#902f32"
  })), _path1982 || (_path1982 = /*#__PURE__*/React.createElement("path", {
    d: "M55 41h-1v-1h1z",
    fill: "#912127"
  })), _path1983 || (_path1983 = /*#__PURE__*/React.createElement("path", {
    d: "M55 40h1v1h-1z",
    fill: "#8d2026"
  })), _path1984 || (_path1984 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h-1v-1h1z",
    fill: "#8e232e"
  })), _path1985 || (_path1985 = /*#__PURE__*/React.createElement("path", {
    d: "M58 40v1h-1v-1z",
    fill: "#8b242c"
  })), _path1986 || (_path1986 = /*#__PURE__*/React.createElement("path", {
    d: "M59 41h-1v-1h1z",
    fill: "#84151c"
  })), _path1987 || (_path1987 = /*#__PURE__*/React.createElement("path", {
    d: "M60 40v1h-1v-1z",
    fill: "#7d0e14"
  })), _path1988 || (_path1988 = /*#__PURE__*/React.createElement("path", {
    d: "M60 41v-1h1v1z",
    fill: "#85141a"
  })), _path1989 || (_path1989 = /*#__PURE__*/React.createElement("path", {
    d: "M62 40v1h-1v-1z",
    fill: "#911f27"
  })), _path1990 || (_path1990 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41v-1h1v1z",
    fill: "#992731"
  })), _path1991 || (_path1991 = /*#__PURE__*/React.createElement("path", {
    d: "M63 41v-1h1v1z",
    fill: "#a83c43"
  })), _path1992 || (_path1992 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41v-1h1v1z",
    fill: "#c16369"
  })), _path1993 || (_path1993 = /*#__PURE__*/React.createElement("path", {
    d: "M65 40h1v1h-1z",
    fill: "#cf8a8a"
  })), _path1994 || (_path1994 = /*#__PURE__*/React.createElement("path", {
    d: "M67 40v1h-1v-1z",
    fill: "#e5bab4"
  })), _path1995 || (_path1995 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41v-1h1v1z",
    fill: "#caa6a0"
  })), _path1996 || (_path1996 = /*#__PURE__*/React.createElement("path", {
    d: "M68 40h1v1h-1z",
    fill: "#733e3f"
  })), _path1997 || (_path1997 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41v-1h1v1z",
    fill: "#5b2929",
    fillOpacity: 0.973
  })), _path1998 || (_path1998 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41v-1h1v1z",
    fill: "#4f3333",
    fillOpacity: 0.176
  })), _path1999 || (_path1999 = /*#__PURE__*/React.createElement("path", {
    d: "M73 40v1h-1v-1z",
    fill: "#b4696f",
    fillOpacity: 0.161
  })), _path2000 || (_path2000 = /*#__PURE__*/React.createElement("path", {
    d: "M74 40v1h-1v-1z",
    fill: "#b63032",
    fillOpacity: 0.965
  })), _path2001 || (_path2001 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v-1h1v1z",
    fill: "#b22f27"
  })), _path2002 || (_path2002 = /*#__PURE__*/React.createElement("path", {
    d: "M76 40v1h-1v-1z",
    fill: "#933e25"
  })), _path2003 || (_path2003 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v-1h1v1z",
    fill: "#6a3f26"
  })), _path2004 || (_path2004 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40v1h-1v-1z",
    fill: "#877564"
  })), _path2005 || (_path2005 = /*#__PURE__*/React.createElement("path", {
    d: "M78 40h1v1h-1z",
    fill: "#847464"
  })), _path2006 || (_path2006 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40v1h-1v-1z",
    fill: "#847463"
  })), _path2007 || (_path2007 = /*#__PURE__*/React.createElement("path", {
    d: "M80 40h1v1h-1z",
    fill: "#817061"
  })), _path2008 || (_path2008 = /*#__PURE__*/React.createElement("path", {
    d: "M81 40h1v1h-1z",
    fill: "#786758"
  })), _path2009 || (_path2009 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h-1v-1h1z",
    fill: "#6b5b4c"
  })), _path2010 || (_path2010 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40v1h-1v-1z",
    fill: "#635142"
  })), _path2011 || (_path2011 = /*#__PURE__*/React.createElement("path", {
    d: "M84 40h1v1h-1z",
    fill: "#715c4e"
  })), _path2012 || (_path2012 = /*#__PURE__*/React.createElement("path", {
    d: "M85 40h1v1h-1z",
    fill: "#4c372b"
  })), _path2013 || (_path2013 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41v-1h1v1z",
    fill: "#342015"
  })), _path2014 || (_path2014 = /*#__PURE__*/React.createElement("path", {
    d: "M88 40h1v1h-1z",
    fill: "#3c271f"
  })), _path2015 || (_path2015 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41v-1h1v1z",
    fill: "#5a4640"
  })), _path2016 || (_path2016 = /*#__PURE__*/React.createElement("path", {
    d: "M91 40v1h-1v-1z",
    fill: "#584341"
  })), _path2017 || (_path2017 = /*#__PURE__*/React.createElement("path", {
    d: "M92 40v1h-1v-1z",
    fill: "#51413e"
  })), _path2018 || (_path2018 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v-1h1v1z",
    fill: "#4d3f3b"
  })), _path2019 || (_path2019 = /*#__PURE__*/React.createElement("path", {
    d: "M94 40v1h-1v-1z",
    fill: "#5f524c"
  })), _path2020 || (_path2020 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41v-1h1v1z",
    fill: "#504a45"
  })), _path2021 || (_path2021 = /*#__PURE__*/React.createElement("path", {
    d: "M96 40v1h-1v-1z",
    fill: "#63605c"
  })), _path2022 || (_path2022 = /*#__PURE__*/React.createElement("path", {
    d: "M96 41v-1h1v1z",
    fill: "#5c5854"
  })), _path2023 || (_path2023 = /*#__PURE__*/React.createElement("path", {
    d: "M97 40h1v1h-1z",
    fill: "#413c3c"
  })), _path2024 || (_path2024 = /*#__PURE__*/React.createElement("path", {
    d: "M98 40h1v1h-1z",
    fill: "#a2a19c"
  })), _path2025 || (_path2025 = /*#__PURE__*/React.createElement("path", {
    d: "M99 40h1v1h-1z",
    fill: "#604741"
  })), _path2026 || (_path2026 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v-1h1v1z",
    fill: "#8e7a73"
  })), _path2027 || (_path2027 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41h-1v-1h1z",
    fill: "#9c8a8c"
  })), _path2028 || (_path2028 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40v1h-1v-1z",
    fill: "#3d3133"
  })), _path2029 || (_path2029 = /*#__PURE__*/React.createElement("path", {
    d: "M103 40h1v1h-1z",
    fill: "#382e24",
    fillOpacity: 0.996
  })), _path2030 || (_path2030 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41h-1v-1h1z",
    fill: "#bfbb9f",
    fillOpacity: 0.251
  })), _path2031 || (_path2031 = /*#__PURE__*/React.createElement("path", {
    d: "M18 42v-1h1v1z",
    fill: "#7f363f",
    fillOpacity: 0.11
  })), _path2032 || (_path2032 = /*#__PURE__*/React.createElement("path", {
    d: "M20 41v1h-1v-1z",
    fill: "#921b25",
    fillOpacity: 0.835
  })), _path2033 || (_path2033 = /*#__PURE__*/React.createElement("path", {
    d: "M21 41v1h-1v-1z",
    fill: "#b31b22"
  })), _path2034 || (_path2034 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42v-1h1v1z",
    fill: "#b02328"
  })), _path2035 || (_path2035 = /*#__PURE__*/React.createElement("path", {
    d: "M22 41h1v1h-1z",
    fill: "#b83035"
  })), _path2036 || (_path2036 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42h-1v-1h1z",
    fill: "#b93c42"
  })), _path2037 || (_path2037 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42h-1v-1h1z",
    fill: "#b83e42"
  })), _path2038 || (_path2038 = /*#__PURE__*/React.createElement("path", {
    d: "M25 42v-1h1v1z",
    fill: "#b84148"
  })), _path2039 || (_path2039 = /*#__PURE__*/React.createElement("path", {
    d: "M26 41h1v1h-1z",
    fill: "#b44549"
  })), _path2040 || (_path2040 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42v-1h1v1z",
    fill: "#ae474b"
  })), _path2041 || (_path2041 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42h-1v-1h1z",
    fill: "#ab4f4f"
  })), _path2042 || (_path2042 = /*#__PURE__*/React.createElement("path", {
    d: "M30 41v1h-1v-1z",
    fill: "#a3464b"
  })), _path2043 || (_path2043 = /*#__PURE__*/React.createElement("path", {
    d: "M31 42h-1v-1h1z",
    fill: "#9d3a3f"
  })), _path2044 || (_path2044 = /*#__PURE__*/React.createElement("path", {
    d: "M32 41v1h-1v-1z",
    fill: "#9d383f"
  })), _path2045 || (_path2045 = /*#__PURE__*/React.createElement("path", {
    d: "M33 41v1h-1v-1z",
    fill: "#97363c"
  })), _path2046 || (_path2046 = /*#__PURE__*/React.createElement("path", {
    d: "M34 41v1h-1v-1z",
    fill: "#9b2c33"
  })), _path2047 || (_path2047 = /*#__PURE__*/React.createElement("path", {
    d: "M35 41v1h-1v-1z",
    fill: "#911e24"
  })), _path2048 || (_path2048 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42h-1v-1h1z",
    fill: "#91181d"
  })), _path2049 || (_path2049 = /*#__PURE__*/React.createElement("path", {
    d: "M36 41h1v1h-1z",
    fill: "#87181d"
  })), _path2050 || (_path2050 = /*#__PURE__*/React.createElement("path", {
    d: "M37 41h1v1h-1z",
    fill: "#80151b"
  })), _path2051 || (_path2051 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41v1h-1v-1z",
    fill: "#761214"
  })), _path2052 || (_path2052 = /*#__PURE__*/React.createElement("path", {
    d: "M39 41h1v1h-1z",
    fill: "#670e11"
  })), _path2053 || (_path2053 = /*#__PURE__*/React.createElement("path", {
    d: "M41 42h-1v-1h1z",
    fill: "#560b0f"
  })), _path2054 || (_path2054 = /*#__PURE__*/React.createElement("path", {
    d: "M42 42h-1v-1h1z",
    fill: "#4c0a0e"
  })), _path2055 || (_path2055 = /*#__PURE__*/React.createElement("path", {
    d: "M42 41h1v1h-1z",
    fill: "#41100f"
  })), _path2056 || (_path2056 = /*#__PURE__*/React.createElement("path", {
    d: "M44 42h-1v-1h1z",
    fill: "#3c1412"
  })), _path2057 || (_path2057 = /*#__PURE__*/React.createElement("path", {
    d: "M45 41v1h-1v-1z",
    fill: "#3e1015"
  })), _path2058 || (_path2058 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42h-1v-1h1z",
    fill: "#673136"
  })), _path2059 || (_path2059 = /*#__PURE__*/React.createElement("path", {
    d: "M47 41v1h-1v-1z",
    fill: "#9f7b6f"
  })), _path2060 || (_path2060 = /*#__PURE__*/React.createElement("path", {
    d: "M47 42v-1h1v1z",
    fill: "#916950"
  })), _path2061 || (_path2061 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h-1v-1h1z",
    fill: "#7d4522"
  })), _path2062 || (_path2062 = /*#__PURE__*/React.createElement("path", {
    d: "M49 41h1v1h-1z",
    fill: "#56100c"
  })), _path2063 || (_path2063 = /*#__PURE__*/React.createElement("path", {
    d: "M51 41v1h-1v-1z",
    fill: "#711b20"
  })), _path2064 || (_path2064 = /*#__PURE__*/React.createElement("path", {
    d: "M52 41v1h-1v-1z",
    fill: "#7c1921"
  })), _path2065 || (_path2065 = /*#__PURE__*/React.createElement("path", {
    d: "M53 42h-1v-1h1z",
    fill: "#92393f"
  })), _path2066 || (_path2066 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h-1v-1h1z",
    fill: "#973c42"
  })), _path2067 || (_path2067 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42v-1h1v1z",
    fill: "#993840"
  })), _path2068 || (_path2068 = /*#__PURE__*/React.createElement("path", {
    d: "M55 42v-1h1v1z",
    fill: "#a1434a"
  })), _path2069 || (_path2069 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41v1h-1v-1z",
    fill: "#a8545b"
  })), _path2070 || (_path2070 = /*#__PURE__*/React.createElement("path", {
    d: "M57 41h1v1h-1z",
    fill: "#a95e61"
  })), _path2071 || (_path2071 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h-1v-1h1z",
    fill: "#a54d53"
  })), _path2072 || (_path2072 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42v-1h1v1z",
    fill: "#95373c"
  })), _path2073 || (_path2073 = /*#__PURE__*/React.createElement("path", {
    d: "M61 41v1h-1v-1z",
    fill: "#9e3d45"
  })), _path2074 || (_path2074 = /*#__PURE__*/React.createElement("path", {
    d: "M62 42h-1v-1h1z",
    fill: "#ad555b"
  })), _path2075 || (_path2075 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41h1v1h-1z",
    fill: "#b96d6e"
  })), _path2076 || (_path2076 = /*#__PURE__*/React.createElement("path", {
    d: "M64 42h-1v-1h1z",
    fill: "#8c504c"
  })), _path2077 || (_path2077 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42h-1v-1h1z",
    fill: "#a47472"
  })), _path2078 || (_path2078 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42h-1v-1h1z",
    fill: "#edc7c6"
  })), _path2079 || (_path2079 = /*#__PURE__*/React.createElement("path", {
    d: "M66 42v-1h1v1z",
    fill: "#edcfc9"
  })), _path2080 || (_path2080 = /*#__PURE__*/React.createElement("path", {
    d: "M67 41h1v1h-1z",
    fill: "#956a64"
  })), _path2081 || (_path2081 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v-1h1v1z",
    fill: "#723a35"
  })), _path2082 || (_path2082 = /*#__PURE__*/React.createElement("path", {
    d: "M69 41h1v1h-1z",
    fill: "#5e312c",
    fillOpacity: 0.925
  })), _path2083 || (_path2083 = /*#__PURE__*/React.createElement("path", {
    d: "M70 41h1v1h-1z",
    fill: "#604f4f",
    fillOpacity: 0.114
  })), _path2084 || (_path2084 = /*#__PURE__*/React.createElement("path", {
    d: "M73 41v1h-1v-1z",
    fill: "#b77a84",
    fillOpacity: 0.098
  })), _path2085 || (_path2085 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41v1h-1v-1z",
    fill: "#b53438",
    fillOpacity: 0.918
  })), _path2086 || (_path2086 = /*#__PURE__*/React.createElement("path", {
    d: "M74 41h1v1h-1z",
    fill: "#b02c29"
  })), _path2087 || (_path2087 = /*#__PURE__*/React.createElement("path", {
    d: "M76 41v1h-1v-1z",
    fill: "#86211a"
  })), _path2088 || (_path2088 = /*#__PURE__*/React.createElement("path", {
    d: "M77 41v1h-1v-1z",
    fill: "#8a3431"
  })), _path2089 || (_path2089 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42h-1v-1h1z",
    fill: "#7e4e47"
  })), _path2090 || (_path2090 = /*#__PURE__*/React.createElement("path", {
    d: "M78 42v-1h1v1z",
    fill: "#978377"
  })), _path2091 || (_path2091 = /*#__PURE__*/React.createElement("path", {
    d: "M79 41h1v1h-1z",
    fill: "#9b8b80"
  })), _path2092 || (_path2092 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h-1v-1h1z",
    fill: "#ab9a8d"
  })), _path2093 || (_path2093 = /*#__PURE__*/React.createElement("path", {
    d: "M82 42h-1v-1h1z",
    fill: "#b6a598"
  })), _path2094 || (_path2094 = /*#__PURE__*/React.createElement("path", {
    d: "M82 41h1v1h-1z",
    fill: "#b5a598"
  })), _path2095 || (_path2095 = /*#__PURE__*/React.createElement("path", {
    d: "M83 41h1v1h-1z",
    fill: "#ac998d"
  })), _path2096 || (_path2096 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41h1v1h-1z",
    fill: "#a08d81"
  })), _path2097 || (_path2097 = /*#__PURE__*/React.createElement("path", {
    d: "M86 42h-1v-1h1z",
    fill: "#89756a"
  })), _path2098 || (_path2098 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42h-1v-1h1z",
    fill: "#7c675d"
  })), _path2099 || (_path2099 = /*#__PURE__*/React.createElement("path", {
    d: "M87 42v-1h1v1z",
    fill: "#776158"
  })), _path2100 || (_path2100 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42v-1h1v1z",
    fill: "#68524b"
  })), _path2101 || (_path2101 = /*#__PURE__*/React.createElement("path", {
    d: "M89 41h1v1h-1z",
    fill: "#604a44"
  })), _path2102 || (_path2102 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h-1v-1h1z",
    fill: "#4b3a34"
  })), _path2103 || (_path2103 = /*#__PURE__*/React.createElement("path", {
    d: "M92 41v1h-1v-1z",
    fill: "#402e28"
  })), _path2104 || (_path2104 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42h-1v-1h1z",
    fill: "#3a241f"
  })), _path2105 || (_path2105 = /*#__PURE__*/React.createElement("path", {
    d: "M93 41h1v1h-1z",
    fill: "#351f1a"
  })), _path2106 || (_path2106 = /*#__PURE__*/React.createElement("path", {
    d: "M94 41h1v1h-1z",
    fill: "#331d1a"
  })), _path2107 || (_path2107 = /*#__PURE__*/React.createElement("path", {
    d: "M95 42v-1h1v1z",
    fill: "#2d1513"
  })), _path2108 || (_path2108 = /*#__PURE__*/React.createElement("path", {
    d: "M97 41v1h-1v-1z",
    fill: "#2b110f"
  })), _path2109 || (_path2109 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42v-1h1v1z",
    fill: "#2c1510"
  })), _path2110 || (_path2110 = /*#__PURE__*/React.createElement("path", {
    d: "M99 42h-1v-1h1z",
    fill: "#2e1b15"
  })), _path2111 || (_path2111 = /*#__PURE__*/React.createElement("path", {
    d: "M100 41v1h-1v-1z",
    fill: "#573b38"
  })), _path2112 || (_path2112 = /*#__PURE__*/React.createElement("path", {
    d: "M100 42v-1h1v1z",
    fill: "#6d5b58"
  })), _path2113 || (_path2113 = /*#__PURE__*/React.createElement("path", {
    d: "M102 41v1h-1v-1z",
    fill: "#978c8d"
  })), _path2114 || (_path2114 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42v-1h1v1z",
    fill: "#2e292a"
  })), _path2115 || (_path2115 = /*#__PURE__*/React.createElement("path", {
    d: "M104 41v1h-1v-1z",
    fill: "#3a3226",
    fillOpacity: 0.953
  })), _path2116 || (_path2116 = /*#__PURE__*/React.createElement("path", {
    d: "M105 41v1h-1v-1z",
    fill: "#cec0a5",
    fillOpacity: 0.145
  })), _path2117 || (_path2117 = /*#__PURE__*/React.createElement("path", {
    d: "M20 42v1h-1v-1z",
    fill: "#914148",
    fillOpacity: 0.137
  })), _path2118 || (_path2118 = /*#__PURE__*/React.createElement("path", {
    d: "M21 43h-1v-1h1z",
    fill: "#a53238",
    fillOpacity: 0.847
  })), _path2119 || (_path2119 = /*#__PURE__*/React.createElement("path", {
    d: "M21 42h1v1h-1z",
    fill: "#b5242c"
  })), _path2120 || (_path2120 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43h-1v-1h1z",
    fill: "#b92d36"
  })), _path2121 || (_path2121 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42v1h-1v-1z",
    fill: "#bc4247"
  })), _path2122 || (_path2122 = /*#__PURE__*/React.createElement("path", {
    d: "M24 43v-1h1v1z",
    fill: "#b9424a"
  })), _path2123 || (_path2123 = /*#__PURE__*/React.createElement("path", {
    d: "M25 43v-1h1v1z",
    fill: "#b74347"
  })), _path2124 || (_path2124 = /*#__PURE__*/React.createElement("path", {
    d: "M26 43v-1h1v1z",
    fill: "#b34043"
  })), _path2125 || (_path2125 = /*#__PURE__*/React.createElement("path", {
    d: "M27 42h1v1h-1z",
    fill: "#b03a40"
  })), _path2126 || (_path2126 = /*#__PURE__*/React.createElement("path", {
    d: "M29 42v1h-1v-1z",
    fill: "#a52f35"
  })), _path2127 || (_path2127 = /*#__PURE__*/React.createElement("path", {
    d: "M29 43v-1h1v1z",
    fill: "#9f242e"
  })), _path2128 || (_path2128 = /*#__PURE__*/React.createElement("path", {
    d: "M30 42h1v1h-1z",
    fill: "#971b23"
  })), _path2129 || (_path2129 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43v-1h1v1z",
    fill: "#8b151a"
  })), _path2130 || (_path2130 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42h1v1h-1z",
    fill: "#851015"
  })), _path2131 || (_path2131 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42v1h-1v-1z",
    fill: "#7d0d11"
  })), _path2132 || (_path2132 = /*#__PURE__*/React.createElement("path", {
    d: "M34 42h1v1h-1z",
    fill: "#720c11"
  })), _path2133 || (_path2133 = /*#__PURE__*/React.createElement("path", {
    d: "M36 42v1h-1v-1z",
    fill: "#680a0c"
  })), _path2134 || (_path2134 = /*#__PURE__*/React.createElement("path", {
    d: "M36 43v-1h1v1z",
    fill: "#5e0908"
  })), _path2135 || (_path2135 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43h-1v-1h1z",
    fill: "#550709"
  })), _path2136 || (_path2136 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43h-1v-1h1z",
    fill: "#49080b"
  })), _path2137 || (_path2137 = /*#__PURE__*/React.createElement("path", {
    d: "M40 42h1v1h-1z",
    fill: "#47060c"
  })), _path2138 || (_path2138 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h-1v-1h1z",
    fill: "#48090d"
  })), _path2139 || (_path2139 = /*#__PURE__*/React.createElement("path", {
    d: "M43 42v1h-1v-1z",
    fill: "#4b1111"
  })), _path2140 || (_path2140 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43v-1h1v1z",
    fill: "#4b1314"
  })), _path2141 || (_path2141 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43h-1v-1h1z",
    fill: "#64383a"
  })), _path2142 || (_path2142 = /*#__PURE__*/React.createElement("path", {
    d: "M46 42v1h-1v-1z",
    fill: "#947976"
  })), _path2143 || (_path2143 = /*#__PURE__*/React.createElement("path", {
    d: "M46 43v-1h1v1z",
    fill: "#997d75"
  })), _path2144 || (_path2144 = /*#__PURE__*/React.createElement("path", {
    d: "M48 42v1h-1v-1z",
    fill: "#825541"
  })), _path2145 || (_path2145 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v-1h1v1z",
    fill: "#783d16"
  })), _path2146 || (_path2146 = /*#__PURE__*/React.createElement("path", {
    d: "M49 42h1v1h-1z",
    fill: "#632014"
  })), _path2147 || (_path2147 = /*#__PURE__*/React.createElement("path", {
    d: "M51 42v1h-1v-1z",
    fill: "#712125"
  })), _path2148 || (_path2148 = /*#__PURE__*/React.createElement("path", {
    d: "M51 43v-1h1v1z",
    fill: "#8b2a30"
  })), _path2149 || (_path2149 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h-1v-1h1z",
    fill: "#a34f56"
  })), _path2150 || (_path2150 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43v-1h1v1z",
    fill: "#ad6266"
  })), _path2151 || (_path2151 = /*#__PURE__*/React.createElement("path", {
    d: "M54 42h1v1h-1z",
    fill: "#a55b5f"
  })), _path2152 || (_path2152 = /*#__PURE__*/React.createElement("path", {
    d: "M56 42v1h-1v-1z",
    fill: "#ad686a"
  })), _path2153 || (_path2153 = /*#__PURE__*/React.createElement("path", {
    d: "M56 43v-1h1v1z",
    fill: "#8c5553"
  })), _path2154 || (_path2154 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v-1h1v1z",
    fill: "#703f3a"
  })), _path2155 || (_path2155 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43v-1h1v1z",
    fill: "#b57d7a"
  })), _path2156 || (_path2156 = /*#__PURE__*/React.createElement("path", {
    d: "M59 42h1v1h-1z",
    fill: "#bd8382"
  })), _path2157 || (_path2157 = /*#__PURE__*/React.createElement("path", {
    d: "M60 42h1v1h-1z",
    fill: "#c59194"
  })), _path2158 || (_path2158 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h-1v-1h1z",
    fill: "#bc8c8b"
  })), _path2159 || (_path2159 = /*#__PURE__*/React.createElement("path", {
    d: "M63 42v1h-1v-1z",
    fill: "#74433c"
  })), _path2160 || (_path2160 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43v-1h1v1z",
    fill: "#4f221c"
  })), _path2161 || (_path2161 = /*#__PURE__*/React.createElement("path", {
    d: "M65 42v1h-1v-1z",
    fill: "#987776"
  })), _path2162 || (_path2162 = /*#__PURE__*/React.createElement("path", {
    d: "M65 43v-1h1v1z",
    fill: "#b09094"
  })), _path2163 || (_path2163 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h-1v-1h1z",
    fill: "#c2a4a2"
  })), _path2164 || (_path2164 = /*#__PURE__*/React.createElement("path", {
    d: "M68 42v1h-1v-1z",
    fill: "#885552"
  })), _path2165 || (_path2165 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h-1v-1h1z",
    fill: "#6b3530"
  })), _path2166 || (_path2166 = /*#__PURE__*/React.createElement("path", {
    d: "M70 42v1h-1v-1z",
    fill: "#623a35",
    fillOpacity: 0.871
  })), _path2167 || (_path2167 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43v-1h1v1z",
    fill: "#afafaf",
    fillOpacity: 0.063
  })), _path2168 || (_path2168 = /*#__PURE__*/React.createElement("path", {
    d: "M72 43v-1h1v1z",
    fill: "#998",
    fillOpacity: 0.059
  })), _path2169 || (_path2169 = /*#__PURE__*/React.createElement("path", {
    d: "M74 43h-1v-1h1z",
    fill: "#b43737",
    fillOpacity: 0.871
  })), _path2170 || (_path2170 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43h-1v-1h1z",
    fill: "#be2c2e"
  })), _path2171 || (_path2171 = /*#__PURE__*/React.createElement("path", {
    d: "M75 43v-1h1v1z",
    fill: "#982422"
  })), _path2172 || (_path2172 = /*#__PURE__*/React.createElement("path", {
    d: "M77 42v1h-1v-1z",
    fill: "#8f2c2b"
  })), _path2173 || (_path2173 = /*#__PURE__*/React.createElement("path", {
    d: "M77 43v-1h1v1z",
    fill: "#b04d51"
  })), _path2174 || (_path2174 = /*#__PURE__*/React.createElement("path", {
    d: "M79 42v1h-1v-1z",
    fill: "#dab4b1"
  })), _path2175 || (_path2175 = /*#__PURE__*/React.createElement("path", {
    d: "M79 43v-1h1v1z",
    fill: "#dfdcd8"
  })), _path2176 || (_path2176 = /*#__PURE__*/React.createElement("path", {
    d: "M80 42h1v1h-1z",
    fill: "#dfd5d0"
  })), _path2177 || (_path2177 = /*#__PURE__*/React.createElement("path", {
    d: "M81 42h1v1h-1z",
    fill: "#d7d1c9"
  })), _path2178 || (_path2178 = /*#__PURE__*/React.createElement("path", {
    d: "M83 43h-1v-1h1z",
    fill: "#d8cdc7"
  })), _path2179 || (_path2179 = /*#__PURE__*/React.createElement("path", {
    d: "M83 42h1v1h-1z",
    fill: "#d6c5c1"
  })), _path2180 || (_path2180 = /*#__PURE__*/React.createElement("path", {
    d: "M85 43h-1v-1h1z",
    fill: "#d7c7c0"
  })), _path2181 || (_path2181 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h-1v-1h1z",
    fill: "#d1c1b9"
  })), _path2182 || (_path2182 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v-1h1v1z",
    fill: "#c2afa7"
  })), _path2183 || (_path2183 = /*#__PURE__*/React.createElement("path", {
    d: "M88 43h-1v-1h1z",
    fill: "#b39e95"
  })), _path2184 || (_path2184 = /*#__PURE__*/React.createElement("path", {
    d: "M88 42h1v1h-1z",
    fill: "#a68f87"
  })), _path2185 || (_path2185 = /*#__PURE__*/React.createElement("path", {
    d: "M89 42h1v1h-1z",
    fill: "#c1a9a2"
  })), _path2186 || (_path2186 = /*#__PURE__*/React.createElement("path", {
    d: "M90 42h1v1h-1z",
    fill: "#9a887f"
  })), _path2187 || (_path2187 = /*#__PURE__*/React.createElement("path", {
    d: "M91 42h1v1h-1z",
    fill: "#98837b"
  })), _path2188 || (_path2188 = /*#__PURE__*/React.createElement("path", {
    d: "M93 42v1h-1v-1z",
    fill: "#8a756e"
  })), _path2189 || (_path2189 = /*#__PURE__*/React.createElement("path", {
    d: "M93 43v-1h1v1z",
    fill: "#67554d"
  })), _path2190 || (_path2190 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43h-1v-1h1z",
    fill: "#6c5851"
  })), _path2191 || (_path2191 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h-1v-1h1z",
    fill: "#6c5854"
  })), _path2192 || (_path2192 = /*#__PURE__*/React.createElement("path", {
    d: "M97 43h-1v-1h1z",
    fill: "#6a5857"
  })), _path2193 || (_path2193 = /*#__PURE__*/React.createElement("path", {
    d: "M97 42h1v1h-1z",
    fill: "#6a5d57"
  })), _path2194 || (_path2194 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h-1v-1h1z",
    fill: "#483727"
  })), _path2195 || (_path2195 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v-1h1v1z",
    fill: "#7c675b"
  })), _path2196 || (_path2196 = /*#__PURE__*/React.createElement("path", {
    d: "M101 42v1h-1v-1z",
    fill: "#644e4e"
  })), _path2197 || (_path2197 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43v-1h1v1z",
    fill: "#8c8685"
  })), _path2198 || (_path2198 = /*#__PURE__*/React.createElement("path", {
    d: "M102 42h1v1h-1z",
    fill: "#252121"
  })), _path2199 || (_path2199 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43h-1v-1h1z",
    fill: "#423b2c",
    fillOpacity: 0.871
  })), _path2200 || (_path2200 = /*#__PURE__*/React.createElement("path", {
    d: "M104 43v-1h1v1z",
    fill: "#fff",
    fillOpacity: 0.059
  })), _path2201 || (_path2201 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44h-1v-1h1z",
    fill: "#b4978b",
    fillOpacity: 0.522
  })), _path2202 || (_path2202 = /*#__PURE__*/React.createElement("path", {
    d: "M21 44v-1h1v1z",
    fill: "#b67061"
  })), _path2203 || (_path2203 = /*#__PURE__*/React.createElement("path", {
    d: "M23 43v1h-1v-1z",
    fill: "#ba635e"
  })), _path2204 || (_path2204 = /*#__PURE__*/React.createElement("path", {
    d: "M24 44h-1v-1h1z",
    fill: "#bb5b53"
  })), _path2205 || (_path2205 = /*#__PURE__*/React.createElement("path", {
    d: "M25 44h-1v-1h1z",
    fill: "#bc5054"
  })), _path2206 || (_path2206 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44h-1v-1h1z",
    fill: "#b9464c"
  })), _path2207 || (_path2207 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44h-1v-1h1z",
    fill: "#b64043"
  })), _path2208 || (_path2208 = /*#__PURE__*/React.createElement("path", {
    d: "M27 44v-1h1v1z",
    fill: "#b2393a"
  })), _path2209 || (_path2209 = /*#__PURE__*/React.createElement("path", {
    d: "M28 44v-1h1v1z",
    fill: "#a92e31"
  })), _path2210 || (_path2210 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h-1v-1h1z",
    fill: "#a02324"
  })), _path2211 || (_path2211 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44v-1h1v1z",
    fill: "#991b20"
  })), _path2212 || (_path2212 = /*#__PURE__*/React.createElement("path", {
    d: "M31 43h1v1h-1z",
    fill: "#8e1419"
  })), _path2213 || (_path2213 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v-1h1v1z",
    fill: "#811115"
  })), _path2214 || (_path2214 = /*#__PURE__*/React.createElement("path", {
    d: "M33 44v-1h1v1z",
    fill: "#7b0e12"
  })), _path2215 || (_path2215 = /*#__PURE__*/React.createElement("path", {
    d: "M35 43v1h-1v-1z",
    fill: "#710b0d"
  })), _path2216 || (_path2216 = /*#__PURE__*/React.createElement("path", {
    d: "M36 44h-1v-1h1z",
    fill: "#650809"
  })), _path2217 || (_path2217 = /*#__PURE__*/React.createElement("path", {
    d: "M37 44h-1v-1h1z",
    fill: "#5b0605"
  })), _path2218 || (_path2218 = /*#__PURE__*/React.createElement("path", {
    d: "M38 43v1h-1v-1z",
    fill: "#570707"
  })), _path2219 || (_path2219 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44v-1h1v1z",
    fill: "#5a080a"
  })), _path2220 || (_path2220 = /*#__PURE__*/React.createElement("path", {
    d: "M40 43v1h-1v-1z",
    fill: "#59090c"
  })), _path2221 || (_path2221 = /*#__PURE__*/React.createElement("path", {
    d: "M41 43v1h-1v-1z",
    fill: "#570e12"
  })), _path2222 || (_path2222 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43v1h-1v-1z",
    fill: "#5e2120"
  })), _path2223 || (_path2223 = /*#__PURE__*/React.createElement("path", {
    d: "M42 43h1v1h-1z",
    fill: "#5d2e27"
  })), _path2224 || (_path2224 = /*#__PURE__*/React.createElement("path", {
    d: "M43 43h1v1h-1z",
    fill: "#461c1a"
  })), _path2225 || (_path2225 = /*#__PURE__*/React.createElement("path", {
    d: "M45 43v1h-1v-1z",
    fill: "#735751"
  })), _path2226 || (_path2226 = /*#__PURE__*/React.createElement("path", {
    d: "M45 44v-1h1v1z",
    fill: "#6a5850"
  })), _path2227 || (_path2227 = /*#__PURE__*/React.createElement("path", {
    d: "M47 43v1h-1v-1z",
    fill: "#6e4f4b"
  })), _path2228 || (_path2228 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43v1h-1v-1z",
    fill: "#79513e"
  })), _path2229 || (_path2229 = /*#__PURE__*/React.createElement("path", {
    d: "M48 43h1v1h-1z",
    fill: "#7e4e34"
  })), _path2230 || (_path2230 = /*#__PURE__*/React.createElement("path", {
    d: "M49 43h1v1h-1z",
    fill: "#76433a"
  })), _path2231 || (_path2231 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44v-1h1v1z",
    fill: "#642c2d"
  })), _path2232 || (_path2232 = /*#__PURE__*/React.createElement("path", {
    d: "M52 43v1h-1v-1z",
    fill: "#803a3c"
  })), _path2233 || (_path2233 = /*#__PURE__*/React.createElement("path", {
    d: "M53 44h-1v-1h1z",
    fill: "#aa6c6c"
  })), _path2234 || (_path2234 = /*#__PURE__*/React.createElement("path", {
    d: "M53 43h1v1h-1z",
    fill: "#bb8683"
  })), _path2235 || (_path2235 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h-1v-1h1z",
    fill: "#784441"
  })), _path2236 || (_path2236 = /*#__PURE__*/React.createElement("path", {
    d: "M55 43h1v1h-1z",
    fill: "#592c27"
  })), _path2237 || (_path2237 = /*#__PURE__*/React.createElement("path", {
    d: "M57 43v1h-1v-1z",
    fill: "#4f2720"
  })), _path2238 || (_path2238 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44h-1v-1h1z",
    fill: "#4b221b"
  })), _path2239 || (_path2239 = /*#__PURE__*/React.createElement("path", {
    d: "M58 43h1v1h-1z",
    fill: "#542c24"
  })), _path2240 || (_path2240 = /*#__PURE__*/React.createElement("path", {
    d: "M59 44v-1h1v1z",
    fill: "#b5968f"
  })), _path2241 || (_path2241 = /*#__PURE__*/React.createElement("path", {
    d: "M60 43h1v1h-1z",
    fill: "#d8c4c3"
  })), _path2242 || (_path2242 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43v1h-1v-1z",
    fill: "#663f41"
  })), _path2243 || (_path2243 = /*#__PURE__*/React.createElement("path", {
    d: "M62 43h1v1h-1z",
    fill: "#743934"
  })), _path2244 || (_path2244 = /*#__PURE__*/React.createElement("path", {
    d: "M63 43h1v1h-1z",
    fill: "#874f47"
  })), _path2245 || (_path2245 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44h-1v-1h1z",
    fill: "#683d3c"
  })), _path2246 || (_path2246 = /*#__PURE__*/React.createElement("path", {
    d: "M66 43v1h-1v-1z",
    fill: "#542e31"
  })), _path2247 || (_path2247 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43v1h-1v-1z",
    fill: "#967271"
  })), _path2248 || (_path2248 = /*#__PURE__*/React.createElement("path", {
    d: "M67 43h1v1h-1z",
    fill: "#7f4c49"
  })), _path2249 || (_path2249 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43v1h-1v-1z",
    fill: "#7e4845"
  })), _path2250 || (_path2250 = /*#__PURE__*/React.createElement("path", {
    d: "M69 43h1v1h-1z",
    fill: "#6e494b",
    fillOpacity: 0.847
  })), _path2251 || (_path2251 = /*#__PURE__*/React.createElement("path", {
    d: "M70 43h1v1h-1z",
    fill: "#aaa",
    fillOpacity: 0.047
  })), _path2252 || (_path2252 = /*#__PURE__*/React.createElement("path", {
    d: "M73 43v1h-1v-1z",
    fill: "#5ff",
    fillOpacity: 0.012
  })), _path2253 || (_path2253 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44v-1h1v1z",
    fill: "#b73535",
    fillOpacity: 0.788
  })), _path2254 || (_path2254 = /*#__PURE__*/React.createElement("path", {
    d: "M74 44v-1h1v1z",
    fill: "#c72b2b"
  })), _path2255 || (_path2255 = /*#__PURE__*/React.createElement("path", {
    d: "M76 43v1h-1v-1z",
    fill: "#aa292c"
  })), _path2256 || (_path2256 = /*#__PURE__*/React.createElement("path", {
    d: "M77 44h-1v-1h1z",
    fill: "#802726"
  })), _path2257 || (_path2257 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44h-1v-1h1z",
    fill: "#813934"
  })), _path2258 || (_path2258 = /*#__PURE__*/React.createElement("path", {
    d: "M78 44v-1h1v1z",
    fill: "#c0827e"
  })), _path2259 || (_path2259 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44h-1v-1h1z",
    fill: "#fbf2ec"
  })), _path2260 || (_path2260 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43v1h-1v-1z",
    fill: "#f0e6dd"
  })), _path2261 || (_path2261 = /*#__PURE__*/React.createElement("path", {
    d: "M81 43h1v1h-1z",
    fill: "#dfcfc8"
  })), _path2262 || (_path2262 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h-1v-1h1z",
    fill: "#f5e6e0"
  })), _path2263 || (_path2263 = /*#__PURE__*/React.createElement("path", {
    d: "M84 43v1h-1v-1z",
    fill: "#fbf1e9"
  })), _path2264 || (_path2264 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44h-1v-1h1z",
    fill: "#f2e7df"
  })), _path2265 || (_path2265 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43v1h-1v-1z",
    fill: "#ecdfd8"
  })), _path2266 || (_path2266 = /*#__PURE__*/React.createElement("path", {
    d: "M86 43h1v1h-1z",
    fill: "#e7d7cc"
  })), _path2267 || (_path2267 = /*#__PURE__*/React.createElement("path", {
    d: "M87 43h1v1h-1z",
    fill: "#e2d1c6"
  })), _path2268 || (_path2268 = /*#__PURE__*/React.createElement("path", {
    d: "M89 44h-1v-1h1z",
    fill: "#ddcbc0"
  })), _path2269 || (_path2269 = /*#__PURE__*/React.createElement("path", {
    d: "M89 43h1v1h-1z",
    fill: "#d2bfb5"
  })), _path2270 || (_path2270 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v-1h1v1z",
    fill: "#c4b3a8"
  })), _path2271 || (_path2271 = /*#__PURE__*/React.createElement("path", {
    d: "M91 44v-1h1v1z",
    fill: "#bda79d"
  })), _path2272 || (_path2272 = /*#__PURE__*/React.createElement("path", {
    d: "M92 43h1v1h-1z",
    fill: "#b99e95"
  })), _path2273 || (_path2273 = /*#__PURE__*/React.createElement("path", {
    d: "M94 43v1h-1v-1z",
    fill: "#a98e83"
  })), _path2274 || (_path2274 = /*#__PURE__*/React.createElement("path", {
    d: "M95 43v1h-1v-1z",
    fill: "#a4897e"
  })), _path2275 || (_path2275 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43v1h-1v-1z",
    fill: "#a0877e"
  })), _path2276 || (_path2276 = /*#__PURE__*/React.createElement("path", {
    d: "M96 43h1v1h-1z",
    fill: "#9c867e"
  })), _path2277 || (_path2277 = /*#__PURE__*/React.createElement("path", {
    d: "M98 43v1h-1v-1z",
    fill: "#ac9792"
  })), _path2278 || (_path2278 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43v1h-1v-1z",
    fill: "#7b6744"
  })), _path2279 || (_path2279 = /*#__PURE__*/React.createElement("path", {
    d: "M99 43h1v1h-1z",
    fill: "#ab9882"
  })), _path2280 || (_path2280 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v-1h1v1z",
    fill: "#665758"
  })), _path2281 || (_path2281 = /*#__PURE__*/React.createElement("path", {
    d: "M101 43h1v1h-1z",
    fill: "#877776"
  })), _path2282 || (_path2282 = /*#__PURE__*/React.createElement("path", {
    d: "M102 44v-1h1v1z",
    fill: "#532324"
  })), _path2283 || (_path2283 = /*#__PURE__*/React.createElement("path", {
    d: "M103 44v-1h1v1z",
    fill: "#5f4839",
    fillOpacity: 0.8
  })), _path2284 || (_path2284 = /*#__PURE__*/React.createElement("path", {
    d: "M20 44h1v1h-1z",
    fill: "#b0a597",
    fillOpacity: 0.369
  })), _path2285 || (_path2285 = /*#__PURE__*/React.createElement("path", {
    d: "M22 44v1h-1v-1z",
    fill: "#cbb7a0"
  })), _path2286 || (_path2286 = /*#__PURE__*/React.createElement("path", {
    d: "M23 45h-1v-1h1z",
    fill: "#cebaa0"
  })), _path2287 || (_path2287 = /*#__PURE__*/React.createElement("path", {
    d: "M23 44h1v1h-1z",
    fill: "#d8b899"
  })), _path2288 || (_path2288 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h-1v-1h1z",
    fill: "#cea991"
  })), _path2289 || (_path2289 = /*#__PURE__*/React.createElement("path", {
    d: "M26 44v1h-1v-1z",
    fill: "#d5a898"
  })), _path2290 || (_path2290 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45h-1v-1h1z",
    fill: "#d29f97"
  })), _path2291 || (_path2291 = /*#__PURE__*/React.createElement("path", {
    d: "M27 45v-1h1v1z",
    fill: "#c07e78"
  })), _path2292 || (_path2292 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h-1v-1h1z",
    fill: "#bd6f6a"
  })), _path2293 || (_path2293 = /*#__PURE__*/React.createElement("path", {
    d: "M30 45h-1v-1h1z",
    fill: "#b35a52"
  })), _path2294 || (_path2294 = /*#__PURE__*/React.createElement("path", {
    d: "M30 44h1v1h-1z",
    fill: "#a13a31"
  })), _path2295 || (_path2295 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v1h-1v-1z",
    fill: "#99312c"
  })), _path2296 || (_path2296 = /*#__PURE__*/React.createElement("path", {
    d: "M32 45v-1h1v1z",
    fill: "#92302b"
  })), _path2297 || (_path2297 = /*#__PURE__*/React.createElement("path", {
    d: "M34 44v1h-1v-1z",
    fill: "#802221"
  })), _path2298 || (_path2298 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v-1h1v1z",
    fill: "#842d2c"
  })), _path2299 || (_path2299 = /*#__PURE__*/React.createElement("path", {
    d: "M35 44h1v1h-1z",
    fill: "#853c3b"
  })), _path2300 || (_path2300 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45h-1v-1h1z",
    fill: "#7e403e"
  })), _path2301 || (_path2301 = /*#__PURE__*/React.createElement("path", {
    d: "M37 45v-1h1v1z",
    fill: "#8b4f4c"
  })), _path2302 || (_path2302 = /*#__PURE__*/React.createElement("path", {
    d: "M38 44h1v1h-1z",
    fill: "#622b28"
  })), _path2303 || (_path2303 = /*#__PURE__*/React.createElement("path", {
    d: "M40 45h-1v-1h1z",
    fill: "#70423d"
  })), _path2304 || (_path2304 = /*#__PURE__*/React.createElement("path", {
    d: "M41 44v1h-1v-1z",
    fill: "#66443e"
  })), _path2305 || (_path2305 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45h-1v-1h1z",
    fill: "#60483b"
  })), _path2306 || (_path2306 = /*#__PURE__*/React.createElement("path", {
    d: "M42 45v-1h1v1z",
    fill: "#473025"
  })), _path2307 || (_path2307 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v-1h1v1z",
    fill: "#371917"
  })), _path2308 || (_path2308 = /*#__PURE__*/React.createElement("path", {
    d: "M45 45h-1v-1h1z",
    fill: "#6d524c"
  })), _path2309 || (_path2309 = /*#__PURE__*/React.createElement("path", {
    d: "M46 44v1h-1v-1z",
    fill: "#624a3f"
  })), _path2310 || (_path2310 = /*#__PURE__*/React.createElement("path", {
    d: "M47 45h-1v-1h1z",
    fill: "#5d3e35"
  })), _path2311 || (_path2311 = /*#__PURE__*/React.createElement("path", {
    d: "M47 44h1v1h-1z",
    fill: "#714f45"
  })), _path2312 || (_path2312 = /*#__PURE__*/React.createElement("path", {
    d: "M48 45v-1h1v1z",
    fill: "#583330"
  })), _path2313 || (_path2313 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45h-1v-1h1z",
    fill: "#46201f"
  })), _path2314 || (_path2314 = /*#__PURE__*/React.createElement("path", {
    d: "M50 44h1v1h-1z",
    fill: "#57302c"
  })), _path2315 || (_path2315 = /*#__PURE__*/React.createElement("path", {
    d: "M51 45v-1h1v1z",
    fill: "#5a2c28"
  })), _path2316 || (_path2316 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45h-1v-1h1z",
    fill: "#774d47"
  })), _path2317 || (_path2317 = /*#__PURE__*/React.createElement("path", {
    d: "M53 45v-1h1v1z",
    fill: "#9c726d"
  })), _path2318 || (_path2318 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44v1h-1v-1z",
    fill: "#623733"
  })), _path2319 || (_path2319 = /*#__PURE__*/React.createElement("path", {
    d: "M55 44h1v1h-1z",
    fill: "#4b251e"
  })), _path2320 || (_path2320 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45h-1v-1h1z",
    fill: "#4b251d"
  })), _path2321 || (_path2321 = /*#__PURE__*/React.createElement("path", {
    d: "M58 44v1h-1v-1z",
    fill: "#4c231e"
  })), _path2322 || (_path2322 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45v-1h1v1z",
    fill: "#4c211c"
  })), _path2323 || (_path2323 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45v-1h1v1z",
    fill: "#593932"
  })), _path2324 || (_path2324 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h-1v-1h1z",
    fill: "#d2c6c2"
  })), _path2325 || (_path2325 = /*#__PURE__*/React.createElement("path", {
    d: "M61 44h1v1h-1z",
    fill: "#baa19d"
  })), _path2326 || (_path2326 = /*#__PURE__*/React.createElement("path", {
    d: "M63 45h-1v-1h1z",
    fill: "#6b3b34"
  })), _path2327 || (_path2327 = /*#__PURE__*/React.createElement("path", {
    d: "M64 45h-1v-1h1z",
    fill: "#51261c"
  })), _path2328 || (_path2328 = /*#__PURE__*/React.createElement("path", {
    d: "M65 44v1h-1v-1z",
    fill: "#482221"
  })), _path2329 || (_path2329 = /*#__PURE__*/React.createElement("path", {
    d: "M66 44v1h-1v-1z",
    fill: "#603b3c"
  })), _path2330 || (_path2330 = /*#__PURE__*/React.createElement("path", {
    d: "M66 45v-1h1v1z",
    fill: "#957170"
  })), _path2331 || (_path2331 = /*#__PURE__*/React.createElement("path", {
    d: "M68 44v1h-1v-1z",
    fill: "#845451"
  })), _path2332 || (_path2332 = /*#__PURE__*/React.createElement("path", {
    d: "M69 45h-1v-1h1z",
    fill: "#76403c"
  })), _path2333 || (_path2333 = /*#__PURE__*/React.createElement("path", {
    d: "M69 44h1v1h-1z",
    fill: "#947174",
    fillOpacity: 0.827
  })), _path2334 || (_path2334 = /*#__PURE__*/React.createElement("path", {
    d: "M73 44h1v1h-1z",
    fill: "#bb3738",
    fillOpacity: 0.706
  })), _path2335 || (_path2335 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45h-1v-1h1z",
    fill: "#c92a28"
  })), _path2336 || (_path2336 = /*#__PURE__*/React.createElement("path", {
    d: "M76 45h-1v-1h1z",
    fill: "#b32728"
  })), _path2337 || (_path2337 = /*#__PURE__*/React.createElement("path", {
    d: "M76 44h1v1h-1z",
    fill: "#902928"
  })), _path2338 || (_path2338 = /*#__PURE__*/React.createElement("path", {
    d: "M77 45v-1h1v1z",
    fill: "#743633"
  })), _path2339 || (_path2339 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v-1h1v1z",
    fill: "#b5716d"
  })), _path2340 || (_path2340 = /*#__PURE__*/React.createElement("path", {
    d: "M80 44v1h-1v-1z",
    fill: "#debdba"
  })), _path2341 || (_path2341 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h-1v-1h1z",
    fill: "#ae8a88"
  })), _path2342 || (_path2342 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45v-1h1v1z",
    fill: "#af898b"
  })), _path2343 || (_path2343 = /*#__PURE__*/React.createElement("path", {
    d: "M83 44h1v1h-1z",
    fill: "#c4a6a6"
  })), _path2344 || (_path2344 = /*#__PURE__*/React.createElement("path", {
    d: "M85 44v1h-1v-1z",
    fill: "#f1e2dc"
  })), _path2345 || (_path2345 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h-1v-1h1z",
    fill: "#f2e6de"
  })), _path2346 || (_path2346 = /*#__PURE__*/React.createElement("path", {
    d: "M87 45h-1v-1h1z",
    fill: "#eaddd2"
  })), _path2347 || (_path2347 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44v1h-1v-1z",
    fill: "#e7d8cb"
  })), _path2348 || (_path2348 = /*#__PURE__*/React.createElement("path", {
    d: "M88 44h1v1h-1z",
    fill: "#e0cec4"
  })), _path2349 || (_path2349 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44v1h-1v-1z",
    fill: "#cdb9b0"
  })), _path2350 || (_path2350 = /*#__PURE__*/React.createElement("path", {
    d: "M90 44h1v1h-1z",
    fill: "#d0b8b1"
  })), _path2351 || (_path2351 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45h-1v-1h1z",
    fill: "#c7b2a9"
  })), _path2352 || (_path2352 = /*#__PURE__*/React.createElement("path", {
    d: "M93 45h-1v-1h1z",
    fill: "#a8928a"
  })), _path2353 || (_path2353 = /*#__PURE__*/React.createElement("path", {
    d: "M94 45h-1v-1h1z",
    fill: "#9e827c"
  })), _path2354 || (_path2354 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44v1h-1v-1z",
    fill: "#907670"
  })), _path2355 || (_path2355 = /*#__PURE__*/React.createElement("path", {
    d: "M95 44h1v1h-1z",
    fill: "#a38b83"
  })), _path2356 || (_path2356 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45v-1h1v1z",
    fill: "#b59e94"
  })), _path2357 || (_path2357 = /*#__PURE__*/React.createElement("path", {
    d: "M98 45h-1v-1h1z",
    fill: "#b49e98"
  })), _path2358 || (_path2358 = /*#__PURE__*/React.createElement("path", {
    d: "M98 44h1v1h-1z",
    fill: "#736345"
  })), _path2359 || (_path2359 = /*#__PURE__*/React.createElement("path", {
    d: "M100 44v1h-1v-1z",
    fill: "#af9d89"
  })), _path2360 || (_path2360 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45h-1v-1h1z",
    fill: "#968c8c"
  })), _path2361 || (_path2361 = /*#__PURE__*/React.createElement("path", {
    d: "M102 45h-1v-1h1z",
    fill: "#a77274"
  })), _path2362 || (_path2362 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45h-1v-1h1z",
    fill: "#a84244"
  })), _path2363 || (_path2363 = /*#__PURE__*/React.createElement("path", {
    d: "M104 44v1h-1v-1z",
    fill: "#996152",
    fillOpacity: 0.718
  })), _path2364 || (_path2364 = /*#__PURE__*/React.createElement("path", {
    d: "M20 45h1v1h-1z",
    fill: "#aa9d91",
    fillOpacity: 0.247
  })), _path2365 || (_path2365 = /*#__PURE__*/React.createElement("path", {
    d: "M21 46v-1h1v1z",
    fill: "#c2b09c",
    fillOpacity: 0.996
  })), _path2366 || (_path2366 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v-1h1v1z",
    fill: "#d4c0a7"
  })), _path2367 || (_path2367 = /*#__PURE__*/React.createElement("path", {
    d: "M24 45v1h-1v-1z",
    fill: "#c2aa87"
  })), _path2368 || (_path2368 = /*#__PURE__*/React.createElement("path", {
    d: "M25 46h-1v-1h1z",
    fill: "#daceb2"
  })), _path2369 || (_path2369 = /*#__PURE__*/React.createElement("path", {
    d: "M25 45h1v1h-1z",
    fill: "#deceb8"
  })), _path2370 || (_path2370 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46h-1v-1h1z",
    fill: "#e7d8c1"
  })), _path2371 || (_path2371 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46h-1v-1h1z",
    fill: "#e6d8c2"
  })), _path2372 || (_path2372 = /*#__PURE__*/React.createElement("path", {
    d: "M28 46v-1h1v1z",
    fill: "#dbccb3"
  })), _path2373 || (_path2373 = /*#__PURE__*/React.createElement("path", {
    d: "M29 45h1v1h-1z",
    fill: "#d8c7ad"
  })), _path2374 || (_path2374 = /*#__PURE__*/React.createElement("path", {
    d: "M31 45v1h-1v-1z",
    fill: "#cbb094"
  })), _path2375 || (_path2375 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46v-1h1v1z",
    fill: "#be9c82"
  })), _path2376 || (_path2376 = /*#__PURE__*/React.createElement("path", {
    d: "M33 45v1h-1v-1z",
    fill: "#b09075"
  })), _path2377 || (_path2377 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45v1h-1v-1z",
    fill: "#a68975"
  })), _path2378 || (_path2378 = /*#__PURE__*/React.createElement("path", {
    d: "M34 45h1v1h-1z",
    fill: "#a18678"
  })), _path2379 || (_path2379 = /*#__PURE__*/React.createElement("path", {
    d: "M36 45v1h-1v-1z",
    fill: "#937d70"
  })), _path2380 || (_path2380 = /*#__PURE__*/React.createElement("path", {
    d: "M36 46v-1h1v1z",
    fill: "#8a7869"
  })), _path2381 || (_path2381 = /*#__PURE__*/React.createElement("path", {
    d: "M38 45v1h-1v-1z",
    fill: "#725d4f"
  })), _path2382 || (_path2382 = /*#__PURE__*/React.createElement("path", {
    d: "M39 46h-1v-1h1z",
    fill: "#745d4f"
  })), _path2383 || (_path2383 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46h-1v-1h1z",
    fill: "#60463c"
  })), _path2384 || (_path2384 = /*#__PURE__*/React.createElement("path", {
    d: "M41 46h-1v-1h1z",
    fill: "#5d453e"
  })), _path2385 || (_path2385 = /*#__PURE__*/React.createElement("path", {
    d: "M42 46h-1v-1h1z",
    fill: "#4f3f32"
  })), _path2386 || (_path2386 = /*#__PURE__*/React.createElement("path", {
    d: "M43 45v1h-1v-1z",
    fill: "#341e18"
  })), _path2387 || (_path2387 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45v1h-1v-1z",
    fill: "#3d1d1e"
  })), _path2388 || (_path2388 = /*#__PURE__*/React.createElement("path", {
    d: "M44 45h1v1h-1z",
    fill: "#8b6e66"
  })), _path2389 || (_path2389 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h-1v-1h1z",
    fill: "#765b4f"
  })), _path2390 || (_path2390 = /*#__PURE__*/React.createElement("path", {
    d: "M46 45h1v1h-1z",
    fill: "#654538"
  })), _path2391 || (_path2391 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h-1v-1h1z",
    fill: "#654334"
  })), _path2392 || (_path2392 = /*#__PURE__*/React.createElement("path", {
    d: "M49 46h-1v-1h1z",
    fill: "#391613"
  })), _path2393 || (_path2393 = /*#__PURE__*/React.createElement("path", {
    d: "M50 45v1h-1v-1z",
    fill: "#330f0e"
  })), _path2394 || (_path2394 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v-1h1v1z",
    fill: "#45201c"
  })), _path2395 || (_path2395 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45v1h-1v-1z",
    fill: "#441f1a"
  })), _path2396 || (_path2396 = /*#__PURE__*/React.createElement("path", {
    d: "M52 45h1v1h-1z",
    fill: "#5d3b37"
  })), _path2397 || (_path2397 = /*#__PURE__*/React.createElement("path", {
    d: "M54 46h-1v-1h1z",
    fill: "#613e39"
  })), _path2398 || (_path2398 = /*#__PURE__*/React.createElement("path", {
    d: "M54 45h1v1h-1z",
    fill: "#58312e"
  })), _path2399 || (_path2399 = /*#__PURE__*/React.createElement("path", {
    d: "M56 45v1h-1v-1z",
    fill: "#49221f"
  })), _path2400 || (_path2400 = /*#__PURE__*/React.createElement("path", {
    d: "M57 45v1h-1v-1z",
    fill: "#461e1c"
  })), _path2401 || (_path2401 = /*#__PURE__*/React.createElement("path", {
    d: "M58 46h-1v-1h1z",
    fill: "#49201d"
  })), _path2402 || (_path2402 = /*#__PURE__*/React.createElement("path", {
    d: "M58 45h1v1h-1z",
    fill: "#4d1d19"
  })), _path2403 || (_path2403 = /*#__PURE__*/React.createElement("path", {
    d: "M59 45h1v1h-1z",
    fill: "#3b100c"
  })), _path2404 || (_path2404 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46h-1v-1h1z",
    fill: "#9b8681"
  })), _path2405 || (_path2405 = /*#__PURE__*/React.createElement("path", {
    d: "M61 45h1v1h-1z",
    fill: "#6c4b49"
  })), _path2406 || (_path2406 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v-1h1v1z",
    fill: "#451915"
  })), _path2407 || (_path2407 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46v-1h1v1z",
    fill: "#44211e"
  })), _path2408 || (_path2408 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46v-1h1v1z",
    fill: "#4e2827"
  })), _path2409 || (_path2409 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46h-1v-1h1z",
    fill: "#6c4341"
  })), _path2410 || (_path2410 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45v1h-1v-1z",
    fill: "#b49996"
  })), _path2411 || (_path2411 = /*#__PURE__*/React.createElement("path", {
    d: "M67 45h1v1h-1z",
    fill: "#ad8380"
  })), _path2412 || (_path2412 = /*#__PURE__*/React.createElement("path", {
    d: "M68 45h1v1h-1z",
    fill: "#743c37"
  })), _path2413 || (_path2413 = /*#__PURE__*/React.createElement("path", {
    d: "M69 46v-1h1v1z",
    fill: "#937a78",
    fillOpacity: 0.816
  })), _path2414 || (_path2414 = /*#__PURE__*/React.createElement("path", {
    d: "M70 46v-1h1v1z",
    fill: "#557f7f",
    fillOpacity: 0.024
  })), _path2415 || (_path2415 = /*#__PURE__*/React.createElement("path", {
    d: "M73 45h1v1h-1z",
    fill: "#be3e43",
    fillOpacity: 0.639
  })), _path2416 || (_path2416 = /*#__PURE__*/React.createElement("path", {
    d: "M75 45v1h-1v-1z",
    fill: "#ca2b2a"
  })), _path2417 || (_path2417 = /*#__PURE__*/React.createElement("path", {
    d: "M75 46v-1h1v1z",
    fill: "#b42928"
  })), _path2418 || (_path2418 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46v-1h1v1z",
    fill: "#8e2826"
  })), _path2419 || (_path2419 = /*#__PURE__*/React.createElement("path", {
    d: "M78 45v1h-1v-1z",
    fill: "#78342f"
  })), _path2420 || (_path2420 = /*#__PURE__*/React.createElement("path", {
    d: "M79 45v1h-1v-1z",
    fill: "#c5817a"
  })), _path2421 || (_path2421 = /*#__PURE__*/React.createElement("path", {
    d: "M80 46h-1v-1h1z",
    fill: "#b79291"
  })), _path2422 || (_path2422 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45v1h-1v-1z",
    fill: "#bc9b9d"
  })), _path2423 || (_path2423 = /*#__PURE__*/React.createElement("path", {
    d: "M81 45h1v1h-1z",
    fill: "#b78e8f"
  })), _path2424 || (_path2424 = /*#__PURE__*/React.createElement("path", {
    d: "M82 45h1v1h-1z",
    fill: "#b48d90"
  })), _path2425 || (_path2425 = /*#__PURE__*/React.createElement("path", {
    d: "M83 45h1v1h-1z",
    fill: "#ad8d8f"
  })), _path2426 || (_path2426 = /*#__PURE__*/React.createElement("path", {
    d: "M84 46v-1h1v1z",
    fill: "#b08e8d"
  })), _path2427 || (_path2427 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v-1h1v1z",
    fill: "#c1a29e"
  })), _path2428 || (_path2428 = /*#__PURE__*/React.createElement("path", {
    d: "M86 45h1v1h-1z",
    fill: "#9e7978"
  })), _path2429 || (_path2429 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h-1v-1h1z",
    fill: "#a17776"
  })), _path2430 || (_path2430 = /*#__PURE__*/React.createElement("path", {
    d: "M89 45v1h-1v-1z",
    fill: "#845f5e"
  })), _path2431 || (_path2431 = /*#__PURE__*/React.createElement("path", {
    d: "M90 46h-1v-1h1z",
    fill: "#785c5b"
  })), _path2432 || (_path2432 = /*#__PURE__*/React.createElement("path", {
    d: "M90 45h1v1h-1z",
    fill: "#785657"
  })), _path2433 || (_path2433 = /*#__PURE__*/React.createElement("path", {
    d: "M92 45v1h-1v-1z",
    fill: "#724b4a"
  })), _path2434 || (_path2434 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46v-1h1v1z",
    fill: "#594440"
  })), _path2435 || (_path2435 = /*#__PURE__*/React.createElement("path", {
    d: "M93 46v-1h1v1z",
    fill: "#4b3332"
  })), _path2436 || (_path2436 = /*#__PURE__*/React.createElement("path", {
    d: "M95 46h-1v-1h1z",
    fill: "#5a4343"
  })), _path2437 || (_path2437 = /*#__PURE__*/React.createElement("path", {
    d: "M96 46h-1v-1h1z",
    fill: "#49302e"
  })), _path2438 || (_path2438 = /*#__PURE__*/React.createElement("path", {
    d: "M96 45h1v1h-1z",
    fill: "#a79086"
  })), _path2439 || (_path2439 = /*#__PURE__*/React.createElement("path", {
    d: "M97 45h1v1h-1z",
    fill: "#bea59d"
  })), _path2440 || (_path2440 = /*#__PURE__*/React.createElement("path", {
    d: "M99 45v1h-1v-1z",
    fill: "#827262"
  })), _path2441 || (_path2441 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46h-1v-1h1z",
    fill: "#8f8266"
  })), _path2442 || (_path2442 = /*#__PURE__*/React.createElement("path", {
    d: "M101 45v1h-1v-1z",
    fill: "#bb9493"
  })), _path2443 || (_path2443 = /*#__PURE__*/React.createElement("path", {
    d: "M102 46h-1v-1h1z",
    fill: "#b87476"
  })), _path2444 || (_path2444 = /*#__PURE__*/React.createElement("path", {
    d: "M103 45v1h-1v-1z",
    fill: "#b85d5b"
  })), _path2445 || (_path2445 = /*#__PURE__*/React.createElement("path", {
    d: "M104 45v1h-1v-1z",
    fill: "#aa735e",
    fillOpacity: 0.604
  })), _path2446 || (_path2446 = /*#__PURE__*/React.createElement("path", {
    d: "M20 46h1v1h-1z",
    fill: "#c2c2b5",
    fillOpacity: 0.149
  })), _path2447 || (_path2447 = /*#__PURE__*/React.createElement("path", {
    d: "M22 46v1h-1v-1z",
    fill: "#b7a090",
    fillOpacity: 0.957
  })), _path2448 || (_path2448 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h-1v-1h1z",
    fill: "#c2a181"
  })), _path2449 || (_path2449 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47v-1h1v1z",
    fill: "#d1b893"
  })), _path2450 || (_path2450 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47h-1v-1h1z",
    fill: "#d7c2a4"
  })), _path2451 || (_path2451 = /*#__PURE__*/React.createElement("path", {
    d: "M26 47h-1v-1h1z",
    fill: "#f2e5d2"
  })), _path2452 || (_path2452 = /*#__PURE__*/React.createElement("path", {
    d: "M27 46v1h-1v-1z",
    fill: "#e6d5c0"
  })), _path2453 || (_path2453 = /*#__PURE__*/React.createElement("path", {
    d: "M28 47h-1v-1h1z",
    fill: "#f1ebdb"
  })), _path2454 || (_path2454 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h-1v-1h1z",
    fill: "#f5f0e6"
  })), _path2455 || (_path2455 = /*#__PURE__*/React.createElement("path", {
    d: "M29 46h1v1h-1z",
    fill: "#f0f0ea"
  })), _path2456 || (_path2456 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47h-1v-1h1z",
    fill: "#f2f3f0"
  })), _path2457 || (_path2457 = /*#__PURE__*/React.createElement("path", {
    d: "M31 46h1v1h-1z",
    fill: "#e4ddd1"
  })), _path2458 || (_path2458 = /*#__PURE__*/React.createElement("path", {
    d: "M33 46v1h-1v-1z",
    fill: "#cfc6b8"
  })), _path2459 || (_path2459 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47h-1v-1h1z",
    fill: "#d0cbbf"
  })), _path2460 || (_path2460 = /*#__PURE__*/React.createElement("path", {
    d: "M35 47h-1v-1h1z",
    fill: "#d6d5d0"
  })), _path2461 || (_path2461 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47h-1v-1h1z",
    fill: "#c9c5c2"
  })), _path2462 || (_path2462 = /*#__PURE__*/React.createElement("path", {
    d: "M37 46v1h-1v-1z",
    fill: "#bab2aa"
  })), _path2463 || (_path2463 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v-1h1v1z",
    fill: "#a2968a"
  })), _path2464 || (_path2464 = /*#__PURE__*/React.createElement("path", {
    d: "M38 47v-1h1v1z",
    fill: "#7f7164"
  })), _path2465 || (_path2465 = /*#__PURE__*/React.createElement("path", {
    d: "M39 47v-1h1v1z",
    fill: "#6b554a"
  })), _path2466 || (_path2466 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47h-1v-1h1z",
    fill: "#5e453b"
  })), _path2467 || (_path2467 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47h-1v-1h1z",
    fill: "#3d2518"
  })), _path2468 || (_path2468 = /*#__PURE__*/React.createElement("path", {
    d: "M42 47v-1h1v1z",
    fill: "#311411"
  })), _path2469 || (_path2469 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h-1v-1h1z",
    fill: "#482527"
  })), _path2470 || (_path2470 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47v-1h1v1z",
    fill: "#856f63"
  })), _path2471 || (_path2471 = /*#__PURE__*/React.createElement("path", {
    d: "M46 47h-1v-1h1z",
    fill: "#6a4a38"
  })), _path2472 || (_path2472 = /*#__PURE__*/React.createElement("path", {
    d: "M46 46h1v1h-1z",
    fill: "#724b3b"
  })), _path2473 || (_path2473 = /*#__PURE__*/React.createElement("path", {
    d: "M47 46h1v1h-1z",
    fill: "#7c5547"
  })), _path2474 || (_path2474 = /*#__PURE__*/React.createElement("path", {
    d: "M48 46h1v1h-1z",
    fill: "#411d16"
  })), _path2475 || (_path2475 = /*#__PURE__*/React.createElement("path", {
    d: "M50 46v1h-1v-1z",
    fill: "#2e0c09"
  })), _path2476 || (_path2476 = /*#__PURE__*/React.createElement("path", {
    d: "M51 46v1h-1v-1z",
    fill: "#3c1a14"
  })), _path2477 || (_path2477 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47h-1v-1h1z",
    fill: "#381b15"
  })), _path2478 || (_path2478 = /*#__PURE__*/React.createElement("path", {
    d: "M52 46h1v1h-1z",
    fill: "#462e2a"
  })), _path2479 || (_path2479 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v-1h1v1z",
    fill: "#4e3530"
  })), _path2480 || (_path2480 = /*#__PURE__*/React.createElement("path", {
    d: "M54 47v-1h1v1z",
    fill: "#442422"
  })), _path2481 || (_path2481 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46v1h-1v-1z",
    fill: "#401f1d"
  })), _path2482 || (_path2482 = /*#__PURE__*/React.createElement("path", {
    d: "M56 46h1v1h-1z",
    fill: "#411d1d"
  })), _path2483 || (_path2483 = /*#__PURE__*/React.createElement("path", {
    d: "M57 46h1v1h-1z",
    fill: "#471e1e"
  })), _path2484 || (_path2484 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h-1v-1h1z",
    fill: "#4a2421"
  })), _path2485 || (_path2485 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47v-1h1v1z",
    fill: "#826866"
  })), _path2486 || (_path2486 = /*#__PURE__*/React.createElement("path", {
    d: "M61 46v1h-1v-1z",
    fill: "#dccdcc"
  })), _path2487 || (_path2487 = /*#__PURE__*/React.createElement("path", {
    d: "M62 46v1h-1v-1z",
    fill: "#613d3e"
  })), _path2488 || (_path2488 = /*#__PURE__*/React.createElement("path", {
    d: "M63 47h-1v-1h1z",
    fill: "#4d1f1d"
  })), _path2489 || (_path2489 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46h1v1h-1z",
    fill: "#552a24"
  })), _path2490 || (_path2490 = /*#__PURE__*/React.createElement("path", {
    d: "M64 46h1v1h-1z",
    fill: "#5c332c"
  })), _path2491 || (_path2491 = /*#__PURE__*/React.createElement("path", {
    d: "M66 46v1h-1v-1z",
    fill: "#7b514d"
  })), _path2492 || (_path2492 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47v-1h1v1z",
    fill: "#d0bfbc"
  })), _path2493 || (_path2493 = /*#__PURE__*/React.createElement("path", {
    d: "M68 46v1h-1v-1z",
    fill: "#9e7575"
  })), _path2494 || (_path2494 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47v-1h1v1z",
    fill: "#7c4945"
  })), _path2495 || (_path2495 = /*#__PURE__*/React.createElement("path", {
    d: "M69 47v-1h1v1z",
    fill: "#b2a49e",
    fillOpacity: 0.796
  })), _path2496 || (_path2496 = /*#__PURE__*/React.createElement("path", {
    d: "M71 46v1h-1v-1z",
    fill: "#055",
    fillOpacity: 0.012
  })), _path2497 || (_path2497 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47v-1h1v1z",
    fill: "#c06063",
    fillOpacity: 0.573
  })), _path2498 || (_path2498 = /*#__PURE__*/React.createElement("path", {
    d: "M74 46h1v1h-1z",
    fill: "#ca3133"
  })), _path2499 || (_path2499 = /*#__PURE__*/React.createElement("path", {
    d: "M76 47h-1v-1h1z",
    fill: "#b72b2a"
  })), _path2500 || (_path2500 = /*#__PURE__*/React.createElement("path", {
    d: "M76 46h1v1h-1z",
    fill: "#8e2322"
  })), _path2501 || (_path2501 = /*#__PURE__*/React.createElement("path", {
    d: "M78 46v1h-1v-1z",
    fill: "#9b413d"
  })), _path2502 || (_path2502 = /*#__PURE__*/React.createElement("path", {
    d: "M79 47h-1v-1h1z",
    fill: "#dea39d"
  })), _path2503 || (_path2503 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47h-1v-1h1z",
    fill: "#bba3a2"
  })), _path2504 || (_path2504 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47h-1v-1h1z",
    fill: "#ba8e94"
  })), _path2505 || (_path2505 = /*#__PURE__*/React.createElement("path", {
    d: "M81 47v-1h1v1z",
    fill: "#b05960"
  })), _path2506 || (_path2506 = /*#__PURE__*/React.createElement("path", {
    d: "M83 46v1h-1v-1z",
    fill: "#b16c72"
  })), _path2507 || (_path2507 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v-1h1v1z",
    fill: "#cfbfbc"
  })), _path2508 || (_path2508 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46v1h-1v-1z",
    fill: "#a98689"
  })), _path2509 || (_path2509 = /*#__PURE__*/React.createElement("path", {
    d: "M85 46h1v1h-1z",
    fill: "#8c6267"
  })), _path2510 || (_path2510 = /*#__PURE__*/React.createElement("path", {
    d: "M86 46h1v1h-1z",
    fill: "#9b8483"
  })), _path2511 || (_path2511 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46v1h-1v-1z",
    fill: "#927277"
  })), _path2512 || (_path2512 = /*#__PURE__*/React.createElement("path", {
    d: "M88 46h1v1h-1z",
    fill: "#9b8181"
  })), _path2513 || (_path2513 = /*#__PURE__*/React.createElement("path", {
    d: "M90 47h-1v-1h1z",
    fill: "#8f7b7b"
  })), _path2514 || (_path2514 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h-1v-1h1z",
    fill: "#887476"
  })), _path2515 || (_path2515 = /*#__PURE__*/React.createElement("path", {
    d: "M91 46h1v1h-1z",
    fill: "#7e6764"
  })), _path2516 || (_path2516 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46h1v1h-1z",
    fill: "#796b68"
  })), _path2517 || (_path2517 = /*#__PURE__*/React.createElement("path", {
    d: "M94 46v1h-1v-1z",
    fill: "#6b5a5b"
  })), _path2518 || (_path2518 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h-1v-1h1z",
    fill: "#6d6260"
  })), _path2519 || (_path2519 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47v-1h1v1z",
    fill: "#503534"
  })), _path2520 || (_path2520 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h-1v-1h1z",
    fill: "#ab978b"
  })), _path2521 || (_path2521 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47v-1h1v1z",
    fill: "#c4a7a2"
  })), _path2522 || (_path2522 = /*#__PURE__*/React.createElement("path", {
    d: "M99 47h-1v-1h1z",
    fill: "#9e897f"
  })), _path2523 || (_path2523 = /*#__PURE__*/React.createElement("path", {
    d: "M100 46v1h-1v-1z",
    fill: "#59452a"
  })), _path2524 || (_path2524 = /*#__PURE__*/React.createElement("path", {
    d: "M100 47v-1h1v1z",
    fill: "#ad7d77"
  })), _path2525 || (_path2525 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v-1h1v1z",
    fill: "#b56260"
  })), _path2526 || (_path2526 = /*#__PURE__*/React.createElement("path", {
    d: "M103 47h-1v-1h1z",
    fill: "#9a2f29"
  })), _path2527 || (_path2527 = /*#__PURE__*/React.createElement("path", {
    d: "M103 46h1v1h-1z",
    fill: "#b17a63",
    fillOpacity: 0.475
  })), _path2528 || (_path2528 = /*#__PURE__*/React.createElement("path", {
    d: "M21 48h-1v-1h1z",
    fill: "#fff",
    fillOpacity: 0.051
  })), _path2529 || (_path2529 = /*#__PURE__*/React.createElement("path", {
    d: "M21 47h1v1h-1z",
    fill: "#b8a897",
    fillOpacity: 0.871
  })), _path2530 || (_path2530 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48h-1v-1h1z",
    fill: "#c3ab8b"
  })), _path2531 || (_path2531 = /*#__PURE__*/React.createElement("path", {
    d: "M23 47h1v1h-1z",
    fill: "#d4ba9b"
  })), _path2532 || (_path2532 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47v1h-1v-1z",
    fill: "#d3c19f"
  })), _path2533 || (_path2533 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48v-1h1v1z",
    fill: "#e1d4bb"
  })), _path2534 || (_path2534 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48h-1v-1h1z",
    fill: "#d0ccc4"
  })), _path2535 || (_path2535 = /*#__PURE__*/React.createElement("path", {
    d: "M27 48v-1h1v1z",
    fill: "#dededc"
  })), _path2536 || (_path2536 = /*#__PURE__*/React.createElement("path", {
    d: "M29 48h-1v-1h1z",
    fill: "#ebebe7"
  })), _path2537 || (_path2537 = /*#__PURE__*/React.createElement("path", {
    d: "M29 47h1v1h-1z",
    fill: "#fdfdfc"
  })), _path2538 || (_path2538 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h-1v-1h1z",
    fill: "#fbfbfe"
  })), _path2539 || (_path2539 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48h-1v-1h1z",
    fill: "#f9f8fb"
  })), _path2540 || (_path2540 = /*#__PURE__*/React.createElement("path", {
    d: "M32 48v-1h1v1z",
    fill: "#f5f3f2"
  })), _path2541 || (_path2541 = /*#__PURE__*/React.createElement("path", {
    d: "M34 47v1h-1v-1z",
    fill: "#eeece6"
  })), _path2542 || (_path2542 = /*#__PURE__*/React.createElement("path", {
    d: "M35 48h-1v-1h1z",
    fill: "#d4d2d0"
  })), _path2543 || (_path2543 = /*#__PURE__*/React.createElement("path", {
    d: "M36 47v1h-1v-1z",
    fill: "#c8c5c4"
  })), _path2544 || (_path2544 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47v1h-1v-1z",
    fill: "#cecac8"
  })), _path2545 || (_path2545 = /*#__PURE__*/React.createElement("path", {
    d: "M37 47h1v1h-1z",
    fill: "#bfbab8"
  })), _path2546 || (_path2546 = /*#__PURE__*/React.createElement("path", {
    d: "M39 48h-1v-1h1z",
    fill: "#a19b95"
  })), _path2547 || (_path2547 = /*#__PURE__*/React.createElement("path", {
    d: "M40 48h-1v-1h1z",
    fill: "#716058"
  })), _path2548 || (_path2548 = /*#__PURE__*/React.createElement("path", {
    d: "M41 47v1h-1v-1z",
    fill: "#5d4538"
  })), _path2549 || (_path2549 = /*#__PURE__*/React.createElement("path", {
    d: "M41 48v-1h1v1z",
    fill: "#3c180c"
  })), _path2550 || (_path2550 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47v1h-1v-1z",
    fill: "#3b1616"
  })), _path2551 || (_path2551 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47h1v1h-1z",
    fill: "#5a3b3a"
  })), _path2552 || (_path2552 = /*#__PURE__*/React.createElement("path", {
    d: "M44 47h1v1h-1z",
    fill: "#6c5b4a"
  })), _path2553 || (_path2553 = /*#__PURE__*/React.createElement("path", {
    d: "M45 47h1v1h-1z",
    fill: "#4f3423"
  })), _path2554 || (_path2554 = /*#__PURE__*/React.createElement("path", {
    d: "M46 48v-1h1v1z",
    fill: "#5d3c2e"
  })), _path2555 || (_path2555 = /*#__PURE__*/React.createElement("path", {
    d: "M47 47h1v1h-1z",
    fill: "#6e493c"
  })), _path2556 || (_path2556 = /*#__PURE__*/React.createElement("path", {
    d: "M48 47h1v1h-1z",
    fill: "#482317"
  })), _path2557 || (_path2557 = /*#__PURE__*/React.createElement("path", {
    d: "M50 48h-1v-1h1z",
    fill: "#300c06"
  })), _path2558 || (_path2558 = /*#__PURE__*/React.createElement("path", {
    d: "M51 48h-1v-1h1z",
    fill: "#411e19"
  })), _path2559 || (_path2559 = /*#__PURE__*/React.createElement("path", {
    d: "M52 47v1h-1v-1z",
    fill: "#41211c"
  })), _path2560 || (_path2560 = /*#__PURE__*/React.createElement("path", {
    d: "M53 47v1h-1v-1z",
    fill: "#462d29"
  })), _path2561 || (_path2561 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48v-1h1v1z",
    fill: "#533c38"
  })), _path2562 || (_path2562 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48v-1h1v1z",
    fill: "#472a28"
  })), _path2563 || (_path2563 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48v-1h1v1z",
    fill: "#361b18"
  })), _path2564 || (_path2564 = /*#__PURE__*/React.createElement("path", {
    d: "M56 47h1v1h-1z",
    fill: "#755a59"
  })), _path2565 || (_path2565 = /*#__PURE__*/React.createElement("path", {
    d: "M58 47v1h-1v-1z",
    fill: "#876462"
  })), _path2566 || (_path2566 = /*#__PURE__*/React.createElement("path", {
    d: "M59 48h-1v-1h1z",
    fill: "#a99590"
  })), _path2567 || (_path2567 = /*#__PURE__*/React.createElement("path", {
    d: "M59 47h1v1h-1z",
    fill: "#ddd6d5"
  })), _path2568 || (_path2568 = /*#__PURE__*/React.createElement("path", {
    d: "M61 47v1h-1v-1z",
    fill: "#ebe4e4"
  })), _path2569 || (_path2569 = /*#__PURE__*/React.createElement("path", {
    d: "M61 48v-1h1v1z",
    fill: "#7c6062"
  })), _path2570 || (_path2570 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v-1h1v1z",
    fill: "#3f1716"
  })), _path2571 || (_path2571 = /*#__PURE__*/React.createElement("path", {
    d: "M64 48h-1v-1h1z",
    fill: "#4b221d"
  })), _path2572 || (_path2572 = /*#__PURE__*/React.createElement("path", {
    d: "M65 47v1h-1v-1z",
    fill: "#4b2721"
  })), _path2573 || (_path2573 = /*#__PURE__*/React.createElement("path", {
    d: "M66 48h-1v-1h1z",
    fill: "#72504e"
  })), _path2574 || (_path2574 = /*#__PURE__*/React.createElement("path", {
    d: "M66 47h1v1h-1z",
    fill: "#e1d6d6"
  })), _path2575 || (_path2575 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h-1v-1h1z",
    fill: "#b99fa4"
  })), _path2576 || (_path2576 = /*#__PURE__*/React.createElement("path", {
    d: "M68 47h1v1h-1z",
    fill: "#e1c8ca"
  })), _path2577 || (_path2577 = /*#__PURE__*/React.createElement("path", {
    d: "M70 48h-1v-1h1z",
    fill: "#dedbd9",
    fillOpacity: 0.616
  })), _path2578 || (_path2578 = /*#__PURE__*/React.createElement("path", {
    d: "M73 47h1v1h-1z",
    fill: "#e2ccc1",
    fillOpacity: 0.49
  })), _path2579 || (_path2579 = /*#__PURE__*/React.createElement("path", {
    d: "M75 47v1h-1v-1z",
    fill: "#c96e6d"
  })), _path2580 || (_path2580 = /*#__PURE__*/React.createElement("path", {
    d: "M75 48v-1h1v1z",
    fill: "#b22b2b"
  })), _path2581 || (_path2581 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48v-1h1v1z",
    fill: "#ad3234"
  })), _path2582 || (_path2582 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47v1h-1v-1z",
    fill: "#a64749"
  })), _path2583 || (_path2583 = /*#__PURE__*/React.createElement("path", {
    d: "M78 47h1v1h-1z",
    fill: "#a17c72"
  })), _path2584 || (_path2584 = /*#__PURE__*/React.createElement("path", {
    d: "M80 47v1h-1v-1z",
    fill: "#c8b9b3"
  })), _path2585 || (_path2585 = /*#__PURE__*/React.createElement("path", {
    d: "M82 47v1h-1v-1z",
    fill: "#bd8687"
  })), _path2586 || (_path2586 = /*#__PURE__*/React.createElement("path", {
    d: "M83 47v1h-1v-1z",
    fill: "#c0a9ab"
  })), _path2587 || (_path2587 = /*#__PURE__*/React.createElement("path", {
    d: "M84 47v1h-1v-1z",
    fill: "#af8e91"
  })), _path2588 || (_path2588 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48v-1h1v1z",
    fill: "#a57477"
  })), _path2589 || (_path2589 = /*#__PURE__*/React.createElement("path", {
    d: "M85 47h1v1h-1z",
    fill: "#cec4c1"
  })), _path2590 || (_path2590 = /*#__PURE__*/React.createElement("path", {
    d: "M86 48v-1h1v1z",
    fill: "#947f82"
  })), _path2591 || (_path2591 = /*#__PURE__*/React.createElement("path", {
    d: "M88 48h-1v-1h1z",
    fill: "#886f6f"
  })), _path2592 || (_path2592 = /*#__PURE__*/React.createElement("path", {
    d: "M89 48h-1v-1h1z",
    fill: "#816461"
  })), _path2593 || (_path2593 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48h-1v-1h1z",
    fill: "#603737"
  })), _path2594 || (_path2594 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47v1h-1v-1z",
    fill: "#96797a"
  })), _path2595 || (_path2595 = /*#__PURE__*/React.createElement("path", {
    d: "M91 47h1v1h-1z",
    fill: "#5a3e3b"
  })), _path2596 || (_path2596 = /*#__PURE__*/React.createElement("path", {
    d: "M93 47v1h-1v-1z",
    fill: "#3d0c0f"
  })), _path2597 || (_path2597 = /*#__PURE__*/React.createElement("path", {
    d: "M94 47v1h-1v-1z",
    fill: "#867572"
  })), _path2598 || (_path2598 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v-1h1v1z",
    fill: "#574943"
  })), _path2599 || (_path2599 = /*#__PURE__*/React.createElement("path", {
    d: "M95 47h1v1h-1z",
    fill: "#886c69"
  })), _path2600 || (_path2600 = /*#__PURE__*/React.createElement("path", {
    d: "M96 48v-1h1v1z",
    fill: "#bda49b"
  })), _path2601 || (_path2601 = /*#__PURE__*/React.createElement("path", {
    d: "M97 47h1v1h-1z",
    fill: "#a48e86"
  })), _path2602 || (_path2602 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48v-1h1v1z",
    fill: "#6c3736"
  })), _path2603 || (_path2603 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48h-1v-1h1z",
    fill: "#512218"
  })), _path2604 || (_path2604 = /*#__PURE__*/React.createElement("path", {
    d: "M101 47v1h-1v-1z",
    fill: "#a3807a"
  })), _path2605 || (_path2605 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48v-1h1v1z",
    fill: "#a95858"
  })), _path2606 || (_path2606 = /*#__PURE__*/React.createElement("path", {
    d: "M102 47h1v1h-1z",
    fill: "#9d322d"
  })), _path2607 || (_path2607 = /*#__PURE__*/React.createElement("path", {
    d: "M103 48v-1h1v1z",
    fill: "#ac7960",
    fillOpacity: 0.353
  })), _path2608 || (_path2608 = /*#__PURE__*/React.createElement("path", {
    d: "M22 49h-1v-1h1z",
    fill: "#c9bdb4",
    fillOpacity: 0.753
  })), _path2609 || (_path2609 = /*#__PURE__*/React.createElement("path", {
    d: "M23 48v1h-1v-1z",
    fill: "#d6c09e"
  })), _path2610 || (_path2610 = /*#__PURE__*/React.createElement("path", {
    d: "M24 49h-1v-1h1z",
    fill: "#c1a97b"
  })), _path2611 || (_path2611 = /*#__PURE__*/React.createElement("path", {
    d: "M25 49h-1v-1h1z",
    fill: "#e0d5bc"
  })), _path2612 || (_path2612 = /*#__PURE__*/React.createElement("path", {
    d: "M25 48h1v1h-1z",
    fill: "#ebe2d1"
  })), _path2613 || (_path2613 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h-1v-1h1z",
    fill: "#a3a39d"
  })), _path2614 || (_path2614 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48v1h-1v-1z",
    fill: "#80827f"
  })), _path2615 || (_path2615 = /*#__PURE__*/React.createElement("path", {
    d: "M29 49h-1v-1h1z",
    fill: "#8a8988"
  })), _path2616 || (_path2616 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h-1v-1h1z",
    fill: "#a2a09f"
  })), _path2617 || (_path2617 = /*#__PURE__*/React.createElement("path", {
    d: "M31 49h-1v-1h1z",
    fill: "#a7a5a6"
  })), _path2618 || (_path2618 = /*#__PURE__*/React.createElement("path", {
    d: "M31 48h1v1h-1z",
    fill: "#9d9d9e"
  })), _path2619 || (_path2619 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v-1h1v1z",
    fill: "#979997"
  })), _path2620 || (_path2620 = /*#__PURE__*/React.createElement("path", {
    d: "M33 49v-1h1v1z",
    fill: "#a6a5a3"
  })), _path2621 || (_path2621 = /*#__PURE__*/React.createElement("path", {
    d: "M34 48h1v1h-1z",
    fill: "#817e7b"
  })), _path2622 || (_path2622 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49v-1h1v1z",
    fill: "#4f4d4b"
  })), _path2623 || (_path2623 = /*#__PURE__*/React.createElement("path", {
    d: "M36 48h1v1h-1z",
    fill: "#565655"
  })), _path2624 || (_path2624 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48v1h-1v-1z",
    fill: "#474747"
  })), _path2625 || (_path2625 = /*#__PURE__*/React.createElement("path", {
    d: "M38 48h1v1h-1z",
    fill: "#55514e"
  })), _path2626 || (_path2626 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h-1v-1h1z",
    fill: "#6e5a53"
  })), _path2627 || (_path2627 = /*#__PURE__*/React.createElement("path", {
    d: "M41 49h-1v-1h1z",
    fill: "#3f1d14"
  })), _path2628 || (_path2628 = /*#__PURE__*/React.createElement("path", {
    d: "M42 48v1h-1v-1z",
    fill: "#471d13"
  })), _path2629 || (_path2629 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h-1v-1h1z",
    fill: "#3f1919"
  })), _path2630 || (_path2630 = /*#__PURE__*/React.createElement("path", {
    d: "M43 48h1v1h-1z",
    fill: "#5b3d3d",
    fillOpacity: 0.776
  })), _path2631 || (_path2631 = /*#__PURE__*/React.createElement("path", {
    d: "M45 48v1h-1v-1z",
    fill: "#82695e",
    fillOpacity: 0.741
  })), _path2632 || (_path2632 = /*#__PURE__*/React.createElement("path", {
    d: "M45 49v-1h1v1z",
    fill: "#604738"
  })), _path2633 || (_path2633 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49h-1v-1h1z",
    fill: "#462919"
  })), _path2634 || (_path2634 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v-1h1v1z",
    fill: "#5a3523"
  })), _path2635 || (_path2635 = /*#__PURE__*/React.createElement("path", {
    d: "M48 48h1v1h-1z",
    fill: "#502714"
  })), _path2636 || (_path2636 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49v-1h1v1z",
    fill: "#330f07"
  })), _path2637 || (_path2637 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49v-1h1v1z",
    fill: "#3e1e1c"
  })), _path2638 || (_path2638 = /*#__PURE__*/React.createElement("path", {
    d: "M52 48v1h-1v-1z",
    fill: "#452521"
  })), _path2639 || (_path2639 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49h-1v-1h1z",
    fill: "#452926"
  })), _path2640 || (_path2640 = /*#__PURE__*/React.createElement("path", {
    d: "M53 48h1v1h-1z",
    fill: "#4e3832"
  })), _path2641 || (_path2641 = /*#__PURE__*/React.createElement("path", {
    d: "M54 48h1v1h-1z",
    fill: "#452a27"
  })), _path2642 || (_path2642 = /*#__PURE__*/React.createElement("path", {
    d: "M55 48h1v1h-1z",
    fill: "#65514f"
  })), _path2643 || (_path2643 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48v1h-1v-1z",
    fill: "#af9593"
  })), _path2644 || (_path2644 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49v-1h1v1z",
    fill: "#6a3734"
  })), _path2645 || (_path2645 = /*#__PURE__*/React.createElement("path", {
    d: "M59 49h-1v-1h1z",
    fill: "#643e3a"
  })), _path2646 || (_path2646 = /*#__PURE__*/React.createElement("path", {
    d: "M60 49h-1v-1h1z",
    fill: "#847470"
  })), _path2647 || (_path2647 = /*#__PURE__*/React.createElement("path", {
    d: "M60 48h1v1h-1z",
    fill: "#cec2c0"
  })), _path2648 || (_path2648 = /*#__PURE__*/React.createElement("path", {
    d: "M62 48v1h-1v-1z",
    fill: "#b9a5a6"
  })), _path2649 || (_path2649 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h-1v-1h1z",
    fill: "#5e3f43"
  })), _path2650 || (_path2650 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49v-1h1v1z",
    fill: "#654345"
  })), _path2651 || (_path2651 = /*#__PURE__*/React.createElement("path", {
    d: "M64 49v-1h1v1z",
    fill: "#705454"
  })), _path2652 || (_path2652 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v-1h1v1z",
    fill: "#b19a9e"
  })), _path2653 || (_path2653 = /*#__PURE__*/React.createElement("path", {
    d: "M67 48v1h-1v-1z",
    fill: "#f6f1f4"
  })), _path2654 || (_path2654 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49h-1v-1h1z",
    fill: "#fbf5f9"
  })), _path2655 || (_path2655 = /*#__PURE__*/React.createElement("path", {
    d: "M68 48h1v1h-1z",
    fill: "#dddade",
    fillOpacity: 0.765
  })), _path2656 || (_path2656 = /*#__PURE__*/React.createElement("path", {
    d: "M69 48h1v1h-1z",
    fill: "#909099",
    fillOpacity: 0.118
  })), _path2657 || (_path2657 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48v1h-1v-1z",
    fill: "#f5f8e5",
    fillOpacity: 0.431
  })), _path2658 || (_path2658 = /*#__PURE__*/React.createElement("path", {
    d: "M74 48h1v1h-1z",
    fill: "#aa938f"
  })), _path2659 || (_path2659 = /*#__PURE__*/React.createElement("path", {
    d: "M76 49h-1v-1h1z",
    fill: "#4f1916"
  })), _path2660 || (_path2660 = /*#__PURE__*/React.createElement("path", {
    d: "M76 48h1v1h-1z",
    fill: "#581f22"
  })), _path2661 || (_path2661 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h-1v-1h1z",
    fill: "#693736"
  })), _path2662 || (_path2662 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49v-1h1v1z",
    fill: "#80534d"
  })), _path2663 || (_path2663 = /*#__PURE__*/React.createElement("path", {
    d: "M80 48v1h-1v-1z",
    fill: "#cab6ad"
  })), _path2664 || (_path2664 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49v-1h1v1z",
    fill: "#af9392"
  })), _path2665 || (_path2665 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49v-1h1v1z",
    fill: "#b38d8d"
  })), _path2666 || (_path2666 = /*#__PURE__*/React.createElement("path", {
    d: "M82 48h1v1h-1z",
    fill: "#af9d9f"
  })), _path2667 || (_path2667 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v-1h1v1z",
    fill: "#b99c9c"
  })), _path2668 || (_path2668 = /*#__PURE__*/React.createElement("path", {
    d: "M84 48h1v1h-1z",
    fill: "#af8885"
  })), _path2669 || (_path2669 = /*#__PURE__*/React.createElement("path", {
    d: "M85 48h1v1h-1z",
    fill: "#a99392"
  })), _path2670 || (_path2670 = /*#__PURE__*/React.createElement("path", {
    d: "M86 49v-1h1v1z",
    fill: "#9b7578"
  })), _path2671 || (_path2671 = /*#__PURE__*/React.createElement("path", {
    d: "M87 48h1v1h-1z",
    fill: "#846063"
  })), _path2672 || (_path2672 = /*#__PURE__*/React.createElement("path", {
    d: "M88 49v-1h1v1z",
    fill: "#9c8282"
  })), _path2673 || (_path2673 = /*#__PURE__*/React.createElement("path", {
    d: "M90 48v1h-1v-1z",
    fill: "#6e3e42"
  })), _path2674 || (_path2674 = /*#__PURE__*/React.createElement("path", {
    d: "M91 49h-1v-1h1z",
    fill: "#825c5e"
  })), _path2675 || (_path2675 = /*#__PURE__*/React.createElement("path", {
    d: "M92 48v1h-1v-1z",
    fill: "#5f3f3f"
  })), _path2676 || (_path2676 = /*#__PURE__*/React.createElement("path", {
    d: "M93 48v1h-1v-1z",
    fill: "#65413d"
  })), _path2677 || (_path2677 = /*#__PURE__*/React.createElement("path", {
    d: "M94 48v1h-1v-1z",
    fill: "#756762"
  })), _path2678 || (_path2678 = /*#__PURE__*/React.createElement("path", {
    d: "M95 49h-1v-1h1z",
    fill: "#4b3632"
  })), _path2679 || (_path2679 = /*#__PURE__*/React.createElement("path", {
    d: "M95 48h1v1h-1z",
    fill: "#ad938d"
  })), _path2680 || (_path2680 = /*#__PURE__*/React.createElement("path", {
    d: "M97 48v1h-1v-1z",
    fill: "#9f837e"
  })), _path2681 || (_path2681 = /*#__PURE__*/React.createElement("path", {
    d: "M97 49v-1h1v1z",
    fill: "#5f2626"
  })), _path2682 || (_path2682 = /*#__PURE__*/React.createElement("path", {
    d: "M98 48h1v1h-1z",
    fill: "#64141a"
  })), _path2683 || (_path2683 = /*#__PURE__*/React.createElement("path", {
    d: "M100 48v1h-1v-1z",
    fill: "#5b2323"
  })), _path2684 || (_path2684 = /*#__PURE__*/React.createElement("path", {
    d: "M100 49v-1h1v1z",
    fill: "#a07f7b"
  })), _path2685 || (_path2685 = /*#__PURE__*/React.createElement("path", {
    d: "M101 48h1v1h-1z",
    fill: "#a65050"
  })), _path2686 || (_path2686 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h-1v-1h1z",
    fill: "#9d3632"
  })), _path2687 || (_path2687 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49v-1h1v1z",
    fill: "#9c745e",
    fillOpacity: 0.275
  })), _path2688 || (_path2688 = /*#__PURE__*/React.createElement("path", {
    d: "M21 49h1v1h-1z",
    fill: "#b9aaa0",
    fillOpacity: 0.6
  })), _path2689 || (_path2689 = /*#__PURE__*/React.createElement("path", {
    d: "M23 50h-1v-1h1z",
    fill: "#ba9c7b"
  })), _path2690 || (_path2690 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h-1v-1h1z",
    fill: "#d5b697"
  })), _path2691 || (_path2691 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50v-1h1v1z",
    fill: "#f2edde"
  })), _path2692 || (_path2692 = /*#__PURE__*/React.createElement("path", {
    d: "M26 49v1h-1v-1z",
    fill: "#e8e5d9"
  })), _path2693 || (_path2693 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49v1h-1v-1z",
    fill: "#e7e2d9"
  })), _path2694 || (_path2694 = /*#__PURE__*/React.createElement("path", {
    d: "M27 49h1v1h-1z",
    fill: "#dcdcdb"
  })), _path2695 || (_path2695 = /*#__PURE__*/React.createElement("path", {
    d: "M28 49h1v1h-1z",
    fill: "#c0bebf"
  })), _path2696 || (_path2696 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49v1h-1v-1z",
    fill: "#aeadad"
  })), _path2697 || (_path2697 = /*#__PURE__*/React.createElement("path", {
    d: "M30 49h1v1h-1z",
    fill: "#777775"
  })), _path2698 || (_path2698 = /*#__PURE__*/React.createElement("path", {
    d: "M32 49v1h-1v-1z",
    fill: "#757370"
  })), _path2699 || (_path2699 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v-1h1v1z",
    fill: "#8a8b88"
  })), _path2700 || (_path2700 = /*#__PURE__*/React.createElement("path", {
    d: "M34 49v1h-1v-1z",
    fill: "#9a9f9f"
  })), _path2701 || (_path2701 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50v-1h1v1z",
    fill: "#999997"
  })), _path2702 || (_path2702 = /*#__PURE__*/React.createElement("path", {
    d: "M35 49h1v1h-1z",
    fill: "#8d8c87"
  })), _path2703 || (_path2703 = /*#__PURE__*/React.createElement("path", {
    d: "M37 49v1h-1v-1z",
    fill: "#878681"
  })), _path2704 || (_path2704 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v-1h1v1z",
    fill: "#93918e"
  })), _path2705 || (_path2705 = /*#__PURE__*/React.createElement("path", {
    d: "M39 49v1h-1v-1z",
    fill: "#756d65"
  })), _path2706 || (_path2706 = /*#__PURE__*/React.createElement("path", {
    d: "M40 50h-1v-1h1z",
    fill: "#45261e"
  })), _path2707 || (_path2707 = /*#__PURE__*/React.createElement("path", {
    d: "M40 49h1v1h-1z",
    fill: "#3d140d"
  })), _path2708 || (_path2708 = /*#__PURE__*/React.createElement("path", {
    d: "M42 49v1h-1v-1z",
    fill: "#472117"
  })), _path2709 || (_path2709 = /*#__PURE__*/React.createElement("path", {
    d: "M42 50v-1h1v1z",
    fill: "#341415"
  })), _path2710 || (_path2710 = /*#__PURE__*/React.createElement("path", {
    d: "M43 49h1v1h-1z",
    fill: "#543a3a",
    fillOpacity: 0.58
  })), _path2711 || (_path2711 = /*#__PURE__*/React.createElement("path", {
    d: "M44 49h1v1h-1z",
    fill: "#6a5555",
    fillOpacity: 0.047
  })), _path2712 || (_path2712 = /*#__PURE__*/React.createElement("path", {
    d: "M46 49v1h-1v-1z",
    fill: "#5a4235",
    fillOpacity: 0.467
  })), _path2713 || (_path2713 = /*#__PURE__*/React.createElement("path", {
    d: "M47 49v1h-1v-1z",
    fill: "#664a3d",
    fillOpacity: 0.859
  })), _path2714 || (_path2714 = /*#__PURE__*/React.createElement("path", {
    d: "M48 49v1h-1v-1z",
    fill: "#57301f"
  })), _path2715 || (_path2715 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v-1h1v1z",
    fill: "#51220b"
  })), _path2716 || (_path2716 = /*#__PURE__*/React.createElement("path", {
    d: "M49 49h1v1h-1z",
    fill: "#451f12"
  })), _path2717 || (_path2717 = /*#__PURE__*/React.createElement("path", {
    d: "M50 49h1v1h-1z",
    fill: "#492d29"
  })), _path2718 || (_path2718 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50h-1v-1h1z",
    fill: "#482c29"
  })), _path2719 || (_path2719 = /*#__PURE__*/React.createElement("path", {
    d: "M53 49v1h-1v-1z",
    fill: "#4b2e29"
  })), _path2720 || (_path2720 = /*#__PURE__*/React.createElement("path", {
    d: "M53 50v-1h1v1z",
    fill: "#513934"
  })), _path2721 || (_path2721 = /*#__PURE__*/React.createElement("path", {
    d: "M55 49v1h-1v-1z",
    fill: "#4e3733"
  })), _path2722 || (_path2722 = /*#__PURE__*/React.createElement("path", {
    d: "M56 49v1h-1v-1z",
    fill: "#7b6764"
  })), _path2723 || (_path2723 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v-1h1v1z",
    fill: "#9b7e7b"
  })), _path2724 || (_path2724 = /*#__PURE__*/React.createElement("path", {
    d: "M57 49h1v1h-1z",
    fill: "#51241b"
  })), _path2725 || (_path2725 = /*#__PURE__*/React.createElement("path", {
    d: "M58 49h1v1h-1z",
    fill: "#3b1815"
  })), _path2726 || (_path2726 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50v-1h1v1z",
    fill: "#311212"
  })), _path2727 || (_path2727 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49v1h-1v-1z",
    fill: "#624c47"
  })), _path2728 || (_path2728 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h-1v-1h1z",
    fill: "#cbbabb"
  })), _path2729 || (_path2729 = /*#__PURE__*/React.createElement("path", {
    d: "M63 50h-1v-1h1z",
    fill: "#c6b2ba"
  })), _path2730 || (_path2730 = /*#__PURE__*/React.createElement("path", {
    d: "M63 49h1v1h-1z",
    fill: "#c6afb7"
  })), _path2731 || (_path2731 = /*#__PURE__*/React.createElement("path", {
    d: "M65 49v1h-1v-1z",
    fill: "#cfbec3"
  })), _path2732 || (_path2732 = /*#__PURE__*/React.createElement("path", {
    d: "M66 49v1h-1v-1z",
    fill: "#e4dae0"
  })), _path2733 || (_path2733 = /*#__PURE__*/React.createElement("path", {
    d: "M67 50h-1v-1h1z",
    fill: "#dedbdb",
    fillOpacity: 0.851
  })), _path2734 || (_path2734 = /*#__PURE__*/React.createElement("path", {
    d: "M68 49v1h-1v-1z",
    fill: "#bdbbbd",
    fillOpacity: 0.471
  })), _path2735 || (_path2735 = /*#__PURE__*/React.createElement("path", {
    d: "M68 50v-1h1v1z",
    fill: "#363648",
    fillOpacity: 0.055
  })), _path2736 || (_path2736 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50v-1h1v1z",
    fill: "#f1e3d6",
    fillOpacity: 0.369
  })), _path2737 || (_path2737 = /*#__PURE__*/React.createElement("path", {
    d: "M74 49h1v1h-1z",
    fill: "#73605d"
  })), _path2738 || (_path2738 = /*#__PURE__*/React.createElement("path", {
    d: "M76 50h-1v-1h1z",
    fill: "#281312"
  })), _path2739 || (_path2739 = /*#__PURE__*/React.createElement("path", {
    d: "M77 49v1h-1v-1z",
    fill: "#331f1d"
  })), _path2740 || (_path2740 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50v-1h1v1z",
    fill: "#52302e"
  })), _path2741 || (_path2741 = /*#__PURE__*/React.createElement("path", {
    d: "M78 49h1v1h-1z",
    fill: "#81534f"
  })), _path2742 || (_path2742 = /*#__PURE__*/React.createElement("path", {
    d: "M80 50h-1v-1h1z",
    fill: "#9f7672"
  })), _path2743 || (_path2743 = /*#__PURE__*/React.createElement("path", {
    d: "M80 49h1v1h-1z",
    fill: "#b08d8e"
  })), _path2744 || (_path2744 = /*#__PURE__*/React.createElement("path", {
    d: "M81 49h1v1h-1z",
    fill: "#b89194"
  })), _path2745 || (_path2745 = /*#__PURE__*/React.createElement("path", {
    d: "M83 49v1h-1v-1z",
    fill: "#bda4a0"
  })), _path2746 || (_path2746 = /*#__PURE__*/React.createElement("path", {
    d: "M84 50h-1v-1h1z",
    fill: "#a07273"
  })), _path2747 || (_path2747 = /*#__PURE__*/React.createElement("path", {
    d: "M85 49v1h-1v-1z",
    fill: "#a37575"
  })), _path2748 || (_path2748 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h-1v-1h1z",
    fill: "#8c4e56"
  })), _path2749 || (_path2749 = /*#__PURE__*/React.createElement("path", {
    d: "M87 49v1h-1v-1z",
    fill: "#7d1e29"
  })), _path2750 || (_path2750 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50v-1h1v1z",
    fill: "#6b141d"
  })), _path2751 || (_path2751 = /*#__PURE__*/React.createElement("path", {
    d: "M89 49v1h-1v-1z",
    fill: "#65121a"
  })), _path2752 || (_path2752 = /*#__PURE__*/React.createElement("path", {
    d: "M89 50v-1h1v1z",
    fill: "#5a0c13"
  })), _path2753 || (_path2753 = /*#__PURE__*/React.createElement("path", {
    d: "M90 49h1v1h-1z",
    fill: "#77494d"
  })), _path2754 || (_path2754 = /*#__PURE__*/React.createElement("path", {
    d: "M92 49v1h-1v-1z",
    fill: "#664b4a"
  })), _path2755 || (_path2755 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50h-1v-1h1z",
    fill: "#573734"
  })), _path2756 || (_path2756 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50h-1v-1h1z",
    fill: "#483130"
  })), _path2757 || (_path2757 = /*#__PURE__*/React.createElement("path", {
    d: "M94 50v-1h1v1z",
    fill: "#5d433f"
  })), _path2758 || (_path2758 = /*#__PURE__*/React.createElement("path", {
    d: "M95 50v-1h1v1z",
    fill: "#b19992"
  })), _path2759 || (_path2759 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v-1h1v1z",
    fill: "#5f3736"
  })), _path2760 || (_path2760 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50v-1h1v1z",
    fill: "#4e0f11"
  })), _path2761 || (_path2761 = /*#__PURE__*/React.createElement("path", {
    d: "M99 49v1h-1v-1z",
    fill: "#44100c"
  })), _path2762 || (_path2762 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50h-1v-1h1z",
    fill: "#552626"
  })), _path2763 || (_path2763 = /*#__PURE__*/React.createElement("path", {
    d: "M100 50v-1h1v1z",
    fill: "#b68684"
  })), _path2764 || (_path2764 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49v1h-1v-1z",
    fill: "#a84847"
  })), _path2765 || (_path2765 = /*#__PURE__*/React.createElement("path", {
    d: "M102 49h1v1h-1z",
    fill: "#a23f39",
    fillOpacity: 0.961
  })), _path2766 || (_path2766 = /*#__PURE__*/React.createElement("path", {
    d: "M103 49h1v1h-1z",
    fill: "#c5a58c",
    fillOpacity: 0.157
  })), _path2767 || (_path2767 = /*#__PURE__*/React.createElement("path", {
    d: "M22 51h-1v-1h1z",
    fill: "#bdb0a4",
    fillOpacity: 0.486
  })), _path2768 || (_path2768 = /*#__PURE__*/React.createElement("path", {
    d: "M22 50h1v1h-1z",
    fill: "#bba481"
  })), _path2769 || (_path2769 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h-1v-1h1z",
    fill: "#c7ac90"
  })), _path2770 || (_path2770 = /*#__PURE__*/React.createElement("path", {
    d: "M24 50h1v1h-1z",
    fill: "#ebe3d6"
  })), _path2771 || (_path2771 = /*#__PURE__*/React.createElement("path", {
    d: "M26 50v1h-1v-1z",
    fill: "#f4f1e7"
  })), _path2772 || (_path2772 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51h-1v-1h1z",
    fill: "#dfd4c9"
  })), _path2773 || (_path2773 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v-1h1v1z",
    fill: "#f2e7e1"
  })), _path2774 || (_path2774 = /*#__PURE__*/React.createElement("path", {
    d: "M30 51v-1h1v1z",
    fill: "#e8e5e6"
  })), _path2775 || (_path2775 = /*#__PURE__*/React.createElement("path", {
    d: "M32 50v1h-1v-1z",
    fill: "#f4f3f0"
  })), _path2776 || (_path2776 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51h-1v-1h1z",
    fill: "#f6f7f3"
  })), _path2777 || (_path2777 = /*#__PURE__*/React.createElement("path", {
    d: "M34 51h-1v-1h1z",
    fill: "#eaedec"
  })), _path2778 || (_path2778 = /*#__PURE__*/React.createElement("path", {
    d: "M34 50h1v1h-1z",
    fill: "#e1e3e1"
  })), _path2779 || (_path2779 = /*#__PURE__*/React.createElement("path", {
    d: "M36 51h-1v-1h1z",
    fill: "#dddadc"
  })), _path2780 || (_path2780 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50v1h-1v-1z",
    fill: "#d0ceca"
  })), _path2781 || (_path2781 = /*#__PURE__*/React.createElement("path", {
    d: "M37 50h1v1h-1z",
    fill: "#a3988f"
  })), _path2782 || (_path2782 = /*#__PURE__*/React.createElement("path", {
    d: "M38 50h1v1h-1z",
    fill: "#563a2d"
  })), _path2783 || (_path2783 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h-1v-1h1z",
    fill: "#441c10"
  })), _path2784 || (_path2784 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50v1h-1v-1z",
    fill: "#44100b"
  })), _path2785 || (_path2785 = /*#__PURE__*/React.createElement("path", {
    d: "M41 50h1v1h-1z",
    fill: "#431e18"
  })), _path2786 || (_path2786 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50v1h-1v-1z",
    fill: "#3f2124"
  })), _path2787 || (_path2787 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50h1v1h-1z",
    fill: "#57383e",
    fillOpacity: 0.494
  })), _path2788 || (_path2788 = /*#__PURE__*/React.createElement("path", {
    d: "M46 50h1v1h-1z",
    fill: "#4f3f4f",
    fillOpacity: 0.063
  })), _path2789 || (_path2789 = /*#__PURE__*/React.createElement("path", {
    d: "M48 50v1h-1v-1z",
    fill: "#44251e",
    fillOpacity: 0.294
  })), _path2790 || (_path2790 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50v1h-1v-1z",
    fill: "#451e10",
    fillOpacity: 0.561
  })), _path2791 || (_path2791 = /*#__PURE__*/React.createElement("path", {
    d: "M49 50h1v1h-1z",
    fill: "#4d2e1c",
    fillOpacity: 0.761
  })), _path2792 || (_path2792 = /*#__PURE__*/React.createElement("path", {
    d: "M50 51v-1h1v1z",
    fill: "#705d56",
    fillOpacity: 0.89
  })), _path2793 || (_path2793 = /*#__PURE__*/React.createElement("path", {
    d: "M52 50v1h-1v-1z",
    fill: "#675556",
    fillOpacity: 0.973
  })), _path2794 || (_path2794 = /*#__PURE__*/React.createElement("path", {
    d: "M53 51h-1v-1h1z",
    fill: "#776063"
  })), _path2795 || (_path2795 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h-1v-1h1z",
    fill: "#8f797c"
  })), _path2796 || (_path2796 = /*#__PURE__*/React.createElement("path", {
    d: "M54 50h1v1h-1z",
    fill: "#9b8889"
  })), _path2797 || (_path2797 = /*#__PURE__*/React.createElement("path", {
    d: "M56 50v1h-1v-1z",
    fill: "#bcacab"
  })), _path2798 || (_path2798 = /*#__PURE__*/React.createElement("path", {
    d: "M57 50v1h-1v-1z",
    fill: "#b3a09c"
  })), _path2799 || (_path2799 = /*#__PURE__*/React.createElement("path", {
    d: "M58 51h-1v-1h1z",
    fill: "#422421"
  })), _path2800 || (_path2800 = /*#__PURE__*/React.createElement("path", {
    d: "M59 51h-1v-1h1z",
    fill: "#3c1d1c"
  })), _path2801 || (_path2801 = /*#__PURE__*/React.createElement("path", {
    d: "M59 50h1v1h-1z",
    fill: "#402324"
  })), _path2802 || (_path2802 = /*#__PURE__*/React.createElement("path", {
    d: "M61 51h-1v-1h1z",
    fill: "#897276"
  })), _path2803 || (_path2803 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50v1h-1v-1z",
    fill: "#ddcfd3",
    fillOpacity: 0.996
  })), _path2804 || (_path2804 = /*#__PURE__*/React.createElement("path", {
    d: "M62 50h1v1h-1z",
    fill: "#d3cace",
    fillOpacity: 0.933
  })), _path2805 || (_path2805 = /*#__PURE__*/React.createElement("path", {
    d: "M64 50v1h-1v-1z",
    fill: "#cec5ca",
    fillOpacity: 0.804
  })), _path2806 || (_path2806 = /*#__PURE__*/React.createElement("path", {
    d: "M64 51v-1h1v1z",
    fill: "#cdc6cb",
    fillOpacity: 0.584
  })), _path2807 || (_path2807 = /*#__PURE__*/React.createElement("path", {
    d: "M65 50h1v1h-1z",
    fill: "#b6b6b6",
    fillOpacity: 0.302
  })), _path2808 || (_path2808 = /*#__PURE__*/React.createElement("path", {
    d: "M66 50h1v1h-1z",
    fill: "#332",
    fillOpacity: 0.059
  })), _path2809 || (_path2809 = /*#__PURE__*/React.createElement("path", {
    d: "M73 50h1v1h-1z",
    fill: "#e2d5c8",
    fillOpacity: 0.314
  })), _path2810 || (_path2810 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51h-1v-1h1z",
    fill: "#634e4a"
  })), _path2811 || (_path2811 = /*#__PURE__*/React.createElement("path", {
    d: "M75 51v-1h1v1z",
    fill: "#2b1716"
  })), _path2812 || (_path2812 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h-1v-1h1z",
    fill: "#37231c"
  })), _path2813 || (_path2813 = /*#__PURE__*/React.createElement("path", {
    d: "M77 50h1v1h-1z",
    fill: "#46302c"
  })), _path2814 || (_path2814 = /*#__PURE__*/React.createElement("path", {
    d: "M79 50v1h-1v-1z",
    fill: "#644946"
  })), _path2815 || (_path2815 = /*#__PURE__*/React.createElement("path", {
    d: "M80 51h-1v-1h1z",
    fill: "#8b6661"
  })), _path2816 || (_path2816 = /*#__PURE__*/React.createElement("path", {
    d: "M81 50v1h-1v-1z",
    fill: "#b2918c"
  })), _path2817 || (_path2817 = /*#__PURE__*/React.createElement("path", {
    d: "M82 51v-1h1v1z",
    fill: "#b69393"
  })), _path2818 || (_path2818 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v-1h1v1z",
    fill: "#a37577"
  })), _path2819 || (_path2819 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51v-1h1v1z",
    fill: "#b09496"
  })), _path2820 || (_path2820 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50v1h-1v-1z",
    fill: "#ad868b"
  })), _path2821 || (_path2821 = /*#__PURE__*/React.createElement("path", {
    d: "M86 50h1v1h-1z",
    fill: "#8d454e"
  })), _path2822 || (_path2822 = /*#__PURE__*/React.createElement("path", {
    d: "M87 50h1v1h-1z",
    fill: "#9e6e70"
  })), _path2823 || (_path2823 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51v-1h1v1z",
    fill: "#7e4b4d"
  })), _path2824 || (_path2824 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51h-1v-1h1z",
    fill: "#865154"
  })), _path2825 || (_path2825 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50v1h-1v-1z",
    fill: "#704f50"
  })), _path2826 || (_path2826 = /*#__PURE__*/React.createElement("path", {
    d: "M91 50h1v1h-1z",
    fill: "#786865"
  })), _path2827 || (_path2827 = /*#__PURE__*/React.createElement("path", {
    d: "M93 50v1h-1v-1z",
    fill: "#5c4545"
  })), _path2828 || (_path2828 = /*#__PURE__*/React.createElement("path", {
    d: "M94 51h-1v-1h1z",
    fill: "#796d6a"
  })), _path2829 || (_path2829 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51h-1v-1h1z",
    fill: "#543936"
  })), _path2830 || (_path2830 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50v1h-1v-1z",
    fill: "#7b675d"
  })), _path2831 || (_path2831 = /*#__PURE__*/React.createElement("path", {
    d: "M96 50h1v1h-1z",
    fill: "#541b1c"
  })), _path2832 || (_path2832 = /*#__PURE__*/React.createElement("path", {
    d: "M97 50h1v1h-1z",
    fill: "#2e0808"
  })), _path2833 || (_path2833 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51v-1h1v1z",
    fill: "#34100d"
  })), _path2834 || (_path2834 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51h-1v-1h1z",
    fill: "#693231"
  })), _path2835 || (_path2835 = /*#__PURE__*/React.createElement("path", {
    d: "M101 50v1h-1v-1z",
    fill: "#c28c8a"
  })), _path2836 || (_path2836 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h-1v-1h1z",
    fill: "#a5423f"
  })), _path2837 || (_path2837 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50v1h-1v-1z",
    fill: "#a94d40",
    fillOpacity: 0.902
  })), _path2838 || (_path2838 = /*#__PURE__*/React.createElement("path", {
    d: "M103 50h1v1h-1z",
    fill: "#e6dace",
    fillOpacity: 0.082
  })), _path2839 || (_path2839 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52v-1h1v1z",
    fill: "#b3a89f",
    fillOpacity: 0.357
  })), _path2840 || (_path2840 = /*#__PURE__*/React.createElement("path", {
    d: "M23 51v1h-1v-1z",
    fill: "#c3af96"
  })), _path2841 || (_path2841 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h-1v-1h1z",
    fill: "#dccfb8"
  })), _path2842 || (_path2842 = /*#__PURE__*/React.createElement("path", {
    d: "M24 51h1v1h-1z",
    fill: "#d8cfbe"
  })), _path2843 || (_path2843 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52h-1v-1h1z",
    fill: "#ece3d9"
  })), _path2844 || (_path2844 = /*#__PURE__*/React.createElement("path", {
    d: "M27 51v1h-1v-1z",
    fill: "#e6d8c6"
  })), _path2845 || (_path2845 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52h-1v-1h1z",
    fill: "#d0b7a0"
  })), _path2846 || (_path2846 = /*#__PURE__*/React.createElement("path", {
    d: "M28 52v-1h1v1z",
    fill: "#dbc7b0"
  })), _path2847 || (_path2847 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v-1h1v1z",
    fill: "#e5ded2"
  })), _path2848 || (_path2848 = /*#__PURE__*/React.createElement("path", {
    d: "M30 52v-1h1v1z",
    fill: "#f0ebe6"
  })), _path2849 || (_path2849 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h-1v-1h1z",
    fill: "#dfd5cc"
  })), _path2850 || (_path2850 = /*#__PURE__*/React.createElement("path", {
    d: "M33 51v1h-1v-1z",
    fill: "#cec3b8"
  })), _path2851 || (_path2851 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52h-1v-1h1z",
    fill: "#ccc1b9"
  })), _path2852 || (_path2852 = /*#__PURE__*/React.createElement("path", {
    d: "M35 52h-1v-1h1z",
    fill: "#d3cdc7"
  })), _path2853 || (_path2853 = /*#__PURE__*/React.createElement("path", {
    d: "M35 51h1v1h-1z",
    fill: "#bba49e"
  })), _path2854 || (_path2854 = /*#__PURE__*/React.createElement("path", {
    d: "M37 52h-1v-1h1z",
    fill: "#846a5b"
  })), _path2855 || (_path2855 = /*#__PURE__*/React.createElement("path", {
    d: "M38 51v1h-1v-1z",
    fill: "#613a2a"
  })), _path2856 || (_path2856 = /*#__PURE__*/React.createElement("path", {
    d: "M39 51v1h-1v-1z",
    fill: "#633023"
  })), _path2857 || (_path2857 = /*#__PURE__*/React.createElement("path", {
    d: "M39 52v-1h1v1z",
    fill: "#6b3a2f"
  })), _path2858 || (_path2858 = /*#__PURE__*/React.createElement("path", {
    d: "M40 51h1v1h-1z",
    fill: "#461c19"
  })), _path2859 || (_path2859 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52h-1v-1h1z",
    fill: "#493130"
  })), _path2860 || (_path2860 = /*#__PURE__*/React.createElement("path", {
    d: "M42 52v-1h1v1z",
    fill: "#432929"
  })), _path2861 || (_path2861 = /*#__PURE__*/React.createElement("path", {
    d: "M44 51v1h-1v-1z",
    fill: "#695055",
    fillOpacity: 0.4
  })), _path2862 || (_path2862 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51v1h-1v-1z",
    fill: "#6b6b6b",
    fillOpacity: 0.075
  })), _path2863 || (_path2863 = /*#__PURE__*/React.createElement("path", {
    d: "M52 52h-1v-1h1z",
    fill: "#777171",
    fillOpacity: 0.184
  })), _path2864 || (_path2864 = /*#__PURE__*/React.createElement("path", {
    d: "M52 51h1v1h-1z",
    fill: "#847d7d",
    fillOpacity: 0.302
  })), _path2865 || (_path2865 = /*#__PURE__*/React.createElement("path", {
    d: "M54 52h-1v-1h1z",
    fill: "#98908d",
    fillOpacity: 0.38
  })), _path2866 || (_path2866 = /*#__PURE__*/React.createElement("path", {
    d: "M54 51h1v1h-1z",
    fill: "#aaa3a1",
    fillOpacity: 0.447
  })), _path2867 || (_path2867 = /*#__PURE__*/React.createElement("path", {
    d: "M56 52h-1v-1h1z",
    fill: "#bcbab6",
    fillOpacity: 0.467
  })), _path2868 || (_path2868 = /*#__PURE__*/React.createElement("path", {
    d: "M57 52h-1v-1h1z",
    fill: "#b5b3af",
    fillOpacity: 0.478
  })), _path2869 || (_path2869 = /*#__PURE__*/React.createElement("path", {
    d: "M57 51h1v1h-1z",
    fill: "#5b5050",
    fillOpacity: 0.447
  })), _path2870 || (_path2870 = /*#__PURE__*/React.createElement("path", {
    d: "M58 52v-1h1v1z",
    fill: "#42312e",
    fillOpacity: 0.408
  })), _path2871 || (_path2871 = /*#__PURE__*/React.createElement("path", {
    d: "M60 51v1h-1v-1z",
    fill: "#564643",
    fillOpacity: 0.369
  })), _path2872 || (_path2872 = /*#__PURE__*/React.createElement("path", {
    d: "M60 52v-1h1v1z",
    fill: "#81747d",
    fillOpacity: 0.318
  })), _path2873 || (_path2873 = /*#__PURE__*/React.createElement("path", {
    d: "M62 52h-1v-1h1z",
    fill: "#9d949d",
    fillOpacity: 0.235
  })), _path2874 || (_path2874 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51v1h-1v-1z",
    fill: "#7b737b",
    fillOpacity: 0.122
  })), _path2875 || (_path2875 = /*#__PURE__*/React.createElement("path", {
    d: "M63 51h1v1h-1z",
    fillOpacity: 0.024
  })), _path2876 || (_path2876 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52v-1h1v1z",
    fill: "#c3b09d",
    fillOpacity: 0.267
  })), _path2877 || (_path2877 = /*#__PURE__*/React.createElement("path", {
    d: "M75 52h-1v-1h1z",
    fill: "#604036"
  })), _path2878 || (_path2878 = /*#__PURE__*/React.createElement("path", {
    d: "M76 52h-1v-1h1z",
    fill: "#2f1919"
  })), _path2879 || (_path2879 = /*#__PURE__*/React.createElement("path", {
    d: "M76 51h1v1h-1z",
    fill: "#392422"
  })), _path2880 || (_path2880 = /*#__PURE__*/React.createElement("path", {
    d: "M77 51h1v1h-1z",
    fill: "#462f2e"
  })), _path2881 || (_path2881 = /*#__PURE__*/React.createElement("path", {
    d: "M78 52v-1h1v1z",
    fill: "#554041"
  })), _path2882 || (_path2882 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52h-1v-1h1z",
    fill: "#9a827f"
  })), _path2883 || (_path2883 = /*#__PURE__*/React.createElement("path", {
    d: "M80 52v-1h1v1z",
    fill: "#bb9a97"
  })), _path2884 || (_path2884 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52h-1v-1h1z",
    fill: "#b89092"
  })), _path2885 || (_path2885 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51v1h-1v-1z",
    fill: "#b68a8b"
  })), _path2886 || (_path2886 = /*#__PURE__*/React.createElement("path", {
    d: "M83 51h1v1h-1z",
    fill: "#b8a7a4"
  })), _path2887 || (_path2887 = /*#__PURE__*/React.createElement("path", {
    d: "M84 51h1v1h-1z",
    fill: "#a69093"
  })), _path2888 || (_path2888 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52v-1h1v1z",
    fill: "#baa8a7"
  })), _path2889 || (_path2889 = /*#__PURE__*/React.createElement("path", {
    d: "M86 51h1v1h-1z",
    fill: "#9e8c88"
  })), _path2890 || (_path2890 = /*#__PURE__*/React.createElement("path", {
    d: "M88 52h-1v-1h1z",
    fill: "#836261"
  })), _path2891 || (_path2891 = /*#__PURE__*/React.createElement("path", {
    d: "M88 51h1v1h-1z",
    fill: "#9a7e7e"
  })), _path2892 || (_path2892 = /*#__PURE__*/React.createElement("path", {
    d: "M90 51v1h-1v-1z",
    fill: "#715353"
  })), _path2893 || (_path2893 = /*#__PURE__*/React.createElement("path", {
    d: "M90 52v-1h1v1z",
    fill: "#684849"
  })), _path2894 || (_path2894 = /*#__PURE__*/React.createElement("path", {
    d: "M92 51v1h-1v-1z",
    fill: "#807271"
  })), _path2895 || (_path2895 = /*#__PURE__*/React.createElement("path", {
    d: "M92 52v-1h1v1z",
    fill: "#615a58"
  })), _path2896 || (_path2896 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52h-1v-1h1z",
    fill: "#7d7573"
  })), _path2897 || (_path2897 = /*#__PURE__*/React.createElement("path", {
    d: "M95 51v1h-1v-1z",
    fill: "#604c4c"
  })), _path2898 || (_path2898 = /*#__PURE__*/React.createElement("path", {
    d: "M96 52h-1v-1h1z",
    fill: "#4c312d"
  })), _path2899 || (_path2899 = /*#__PURE__*/React.createElement("path", {
    d: "M97 52h-1v-1h1z",
    fill: "#541b1b"
  })), _path2900 || (_path2900 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52h-1v-1h1z",
    fill: "#2b0708"
  })), _path2901 || (_path2901 = /*#__PURE__*/React.createElement("path", {
    d: "M98 51h1v1h-1z",
    fill: "#420f14"
  })), _path2902 || (_path2902 = /*#__PURE__*/React.createElement("path", {
    d: "M100 51v1h-1v-1z",
    fill: "#7c3b3b"
  })), _path2903 || (_path2903 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52h-1v-1h1z",
    fill: "#c38884"
  })), _path2904 || (_path2904 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v-1h1v1z",
    fill: "#a73938"
  })), _path2905 || (_path2905 = /*#__PURE__*/React.createElement("path", {
    d: "M102 51h1v1h-1z",
    fill: "#ac5d4a",
    fillOpacity: 0.824
  })), _path2906 || (_path2906 = /*#__PURE__*/React.createElement("path", {
    d: "M21 52h1v1h-1z",
    fill: "#cac5b6",
    fillOpacity: 0.208
  })), _path2907 || (_path2907 = /*#__PURE__*/React.createElement("path", {
    d: "M22 52h1v1h-1z",
    fill: "#c3b09a",
    fillOpacity: 0.984
  })), _path2908 || (_path2908 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52v1h-1v-1z",
    fill: "#cbb69b"
  })), _path2909 || (_path2909 = /*#__PURE__*/React.createElement("path", {
    d: "M24 52h1v1h-1z",
    fill: "#a27c6c"
  })), _path2910 || (_path2910 = /*#__PURE__*/React.createElement("path", {
    d: "M26 52v1h-1v-1z",
    fill: "#a4726b"
  })), _path2911 || (_path2911 = /*#__PURE__*/React.createElement("path", {
    d: "M27 53h-1v-1h1z",
    fill: "#bd9389"
  })), _path2912 || (_path2912 = /*#__PURE__*/React.createElement("path", {
    d: "M27 52h1v1h-1z",
    fill: "#b4887e"
  })), _path2913 || (_path2913 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52v1h-1v-1z",
    fill: "#b28475"
  })), _path2914 || (_path2914 = /*#__PURE__*/React.createElement("path", {
    d: "M29 52h1v1h-1z",
    fill: "#c6afa2"
  })), _path2915 || (_path2915 = /*#__PURE__*/React.createElement("path", {
    d: "M31 52v1h-1v-1z",
    fill: "#cab8b0"
  })), _path2916 || (_path2916 = /*#__PURE__*/React.createElement("path", {
    d: "M32 53h-1v-1h1z",
    fill: "#bda696"
  })), _path2917 || (_path2917 = /*#__PURE__*/React.createElement("path", {
    d: "M32 52h1v1h-1z",
    fill: "#ad8d78"
  })), _path2918 || (_path2918 = /*#__PURE__*/React.createElement("path", {
    d: "M34 52v1h-1v-1z",
    fill: "#ac8772"
  })), _path2919 || (_path2919 = /*#__PURE__*/React.createElement("path", {
    d: "M35 53h-1v-1h1z",
    fill: "#a3725c"
  })), _path2920 || (_path2920 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h-1v-1h1z",
    fill: "#844d38"
  })), _path2921 || (_path2921 = /*#__PURE__*/React.createElement("path", {
    d: "M36 52h1v1h-1z",
    fill: "#8a5a49"
  })), _path2922 || (_path2922 = /*#__PURE__*/React.createElement("path", {
    d: "M38 52v1h-1v-1z",
    fill: "#844d3d"
  })), _path2923 || (_path2923 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v-1h1v1z",
    fill: "#784835"
  })), _path2924 || (_path2924 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53h-1v-1h1z",
    fill: "#512a22"
  })), _path2925 || (_path2925 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53h-1v-1h1z",
    fill: "#4b3333"
  })), _path2926 || (_path2926 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h-1v-1h1z",
    fill: "#422b2c"
  })), _path2927 || (_path2927 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53v-1h1v1z",
    fill: "#411f20"
  })), _path2928 || (_path2928 = /*#__PURE__*/React.createElement("path", {
    d: "M43 52h1v1h-1z",
    fill: "#7f6a6e",
    fillOpacity: 0.29
  })), _path2929 || (_path2929 = /*#__PURE__*/React.createElement("path", {
    d: "M73 52h1v1h-1z",
    fill: "#8d7168",
    fillOpacity: 0.22
  })), _path2930 || (_path2930 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53v-1h1v1z",
    fill: "#613c2f",
    fillOpacity: 0.992
  })), _path2931 || (_path2931 = /*#__PURE__*/React.createElement("path", {
    d: "M75 53v-1h1v1z",
    fill: "#603d30"
  })), _path2932 || (_path2932 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v-1h1v1z",
    fill: "#492a20"
  })), _path2933 || (_path2933 = /*#__PURE__*/React.createElement("path", {
    d: "M77 52h1v1h-1z",
    fill: "#482b25"
  })), _path2934 || (_path2934 = /*#__PURE__*/React.createElement("path", {
    d: "M79 53v-1h1v1z",
    fill: "#f1ece9"
  })), _path2935 || (_path2935 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h-1v-1h1z",
    fill: "#c4aaa9"
  })), _path2936 || (_path2936 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53h-1v-1h1z",
    fill: "#b99796"
  })), _path2937 || (_path2937 = /*#__PURE__*/React.createElement("path", {
    d: "M82 53v-1h1v1z",
    fill: "#c4a6a8"
  })), _path2938 || (_path2938 = /*#__PURE__*/React.createElement("path", {
    d: "M83 52h1v1h-1z",
    fill: "#c5b3b2"
  })), _path2939 || (_path2939 = /*#__PURE__*/React.createElement("path", {
    d: "M84 53v-1h1v1z",
    fill: "#ac8b8f"
  })), _path2940 || (_path2940 = /*#__PURE__*/React.createElement("path", {
    d: "M85 52h1v1h-1z",
    fill: "#b69998"
  })), _path2941 || (_path2941 = /*#__PURE__*/React.createElement("path", {
    d: "M87 52v1h-1v-1z",
    fill: "#8b5d61"
  })), _path2942 || (_path2942 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h-1v-1h1z",
    fill: "#906165"
  })), _path2943 || (_path2943 = /*#__PURE__*/React.createElement("path", {
    d: "M89 52v1h-1v-1z",
    fill: "#94686b"
  })), _path2944 || (_path2944 = /*#__PURE__*/React.createElement("path", {
    d: "M90 53h-1v-1h1z",
    fill: "#754a4d"
  })), _path2945 || (_path2945 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52v1h-1v-1z",
    fill: "#69383b"
  })), _path2946 || (_path2946 = /*#__PURE__*/React.createElement("path", {
    d: "M91 52h1v1h-1z",
    fill: "#826d6b"
  })), _path2947 || (_path2947 = /*#__PURE__*/React.createElement("path", {
    d: "M92 53v-1h1v1z",
    fill: "#796c69"
  })), _path2948 || (_path2948 = /*#__PURE__*/React.createElement("path", {
    d: "M94 52v1h-1v-1z",
    fill: "#766462"
  })), _path2949 || (_path2949 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h-1v-1h1z",
    fill: "#5b4444"
  })), _path2950 || (_path2950 = /*#__PURE__*/React.createElement("path", {
    d: "M95 52h1v1h-1z",
    fill: "#5a373a"
  })), _path2951 || (_path2951 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53v-1h1v1z",
    fill: "#62272b"
  })), _path2952 || (_path2952 = /*#__PURE__*/React.createElement("path", {
    d: "M98 52v1h-1v-1z",
    fill: "#360b06"
  })), _path2953 || (_path2953 = /*#__PURE__*/React.createElement("path", {
    d: "M99 52v1h-1v-1z",
    fill: "#4a1016"
  })), _path2954 || (_path2954 = /*#__PURE__*/React.createElement("path", {
    d: "M100 53h-1v-1h1z",
    fill: "#8a4649"
  })), _path2955 || (_path2955 = /*#__PURE__*/React.createElement("path", {
    d: "M101 52v1h-1v-1z",
    fill: "#c3837b"
  })), _path2956 || (_path2956 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53h-1v-1h1z",
    fill: "#ab3539"
  })), _path2957 || (_path2957 = /*#__PURE__*/React.createElement("path", {
    d: "M102 52h1v1h-1z",
    fill: "#925747",
    fillOpacity: 0.718
  })), _path2958 || (_path2958 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53v1h-1v-1z",
    fill: "#cdcdc4",
    fillOpacity: 0.102
  })), _path2959 || (_path2959 = /*#__PURE__*/React.createElement("path", {
    d: "M22 53h1v1h-1z",
    fill: "#bcab9b",
    fillOpacity: 0.922
  })), _path2960 || (_path2960 = /*#__PURE__*/React.createElement("path", {
    d: "M23 54v-1h1v1z",
    fill: "#cfbea0"
  })), _path2961 || (_path2961 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54h-1v-1h1z",
    fill: "#c4ac92"
  })), _path2962 || (_path2962 = /*#__PURE__*/React.createElement("path", {
    d: "M25 54v-1h1v1z",
    fill: "#9c766c"
  })), _path2963 || (_path2963 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54h-1v-1h1z",
    fill: "#9e6f6b"
  })), _path2964 || (_path2964 = /*#__PURE__*/React.createElement("path", {
    d: "M28 53v1h-1v-1z",
    fill: "#aa726d"
  })), _path2965 || (_path2965 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54h-1v-1h1z",
    fill: "#98605f"
  })), _path2966 || (_path2966 = /*#__PURE__*/React.createElement("path", {
    d: "M30 53v1h-1v-1z",
    fill: "#956c64"
  })), _path2967 || (_path2967 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54v-1h1v1z",
    fill: "#e7d4b7"
  })), _path2968 || (_path2968 = /*#__PURE__*/React.createElement("path", {
    d: "M31 53h1v1h-1z",
    fill: "#e3b99a"
  })), _path2969 || (_path2969 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v-1h1v1z",
    fill: "#b0614a"
  })), _path2970 || (_path2970 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54v-1h1v1z",
    fill: "#913123"
  })), _path2971 || (_path2971 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h-1v-1h1z",
    fill: "#ac634d"
  })), _path2972 || (_path2972 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53v1h-1v-1z",
    fill: "#9d5f49"
  })), _path2973 || (_path2973 = /*#__PURE__*/React.createElement("path", {
    d: "M36 53h1v1h-1z",
    fill: "#934f3a"
  })), _path2974 || (_path2974 = /*#__PURE__*/React.createElement("path", {
    d: "M38 53v1h-1v-1z",
    fill: "#5d2212"
  })), _path2975 || (_path2975 = /*#__PURE__*/React.createElement("path", {
    d: "M38 54v-1h1v1z",
    fill: "#714a3f"
  })), _path2976 || (_path2976 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53v1h-1v-1z",
    fill: "#664b46"
  })), _path2977 || (_path2977 = /*#__PURE__*/React.createElement("path", {
    d: "M41 54h-1v-1h1z",
    fill: "#3c2325"
  })), _path2978 || (_path2978 = /*#__PURE__*/React.createElement("path", {
    d: "M42 53h1v1h-1z",
    fill: "#492426",
    fillOpacity: 0.969
  })), _path2979 || (_path2979 = /*#__PURE__*/React.createElement("path", {
    d: "M44 53v1h-1v-1z",
    fill: "#917f7f",
    fillOpacity: 0.165
  })), _path2980 || (_path2980 = /*#__PURE__*/React.createElement("path", {
    d: "M73 53h1v1h-1z",
    fill: "#a88d87",
    fillOpacity: 0.184
  })), _path2981 || (_path2981 = /*#__PURE__*/React.createElement("path", {
    d: "M74 53h1v1h-1z",
    fill: "#402b27",
    fillOpacity: 0.98
  })), _path2982 || (_path2982 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53v1h-1v-1z",
    fill: "#43362f"
  })), _path2983 || (_path2983 = /*#__PURE__*/React.createElement("path", {
    d: "M76 53h1v1h-1z",
    fill: "#634938"
  })), _path2984 || (_path2984 = /*#__PURE__*/React.createElement("path", {
    d: "M78 53v1h-1v-1z",
    fill: "#987b6a"
  })), _path2985 || (_path2985 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v-1h1v1z",
    fill: "#e7ddd0"
  })), _path2986 || (_path2986 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54h-1v-1h1z",
    fill: "#fffff8"
  })), _path2987 || (_path2987 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53v1h-1v-1z",
    fill: "#fdf3ee"
  })), _path2988 || (_path2988 = /*#__PURE__*/React.createElement("path", {
    d: "M81 53h1v1h-1z",
    fill: "#bfa9a5"
  })), _path2989 || (_path2989 = /*#__PURE__*/React.createElement("path", {
    d: "M83 53v1h-1v-1z",
    fill: "#ab8486"
  })), _path2990 || (_path2990 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54v-1h1v1z",
    fill: "#a4767a"
  })), _path2991 || (_path2991 = /*#__PURE__*/React.createElement("path", {
    d: "M85 53v1h-1v-1z",
    fill: "#9d7276"
  })), _path2992 || (_path2992 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v-1h1v1z",
    fill: "#8c5e62"
  })), _path2993 || (_path2993 = /*#__PURE__*/React.createElement("path", {
    d: "M86 53h1v1h-1z",
    fill: "#814f53"
  })), _path2994 || (_path2994 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53v1h-1v-1z",
    fill: "#8d5e62"
  })), _path2995 || (_path2995 = /*#__PURE__*/React.createElement("path", {
    d: "M88 53h1v1h-1z",
    fill: "#64242c"
  })), _path2996 || (_path2996 = /*#__PURE__*/React.createElement("path", {
    d: "M89 53h1v1h-1z",
    fill: "#7a5656"
  })), _path2997 || (_path2997 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53v1h-1v-1z",
    fill: "#62383a"
  })), _path2998 || (_path2998 = /*#__PURE__*/React.createElement("path", {
    d: "M91 53h1v1h-1z",
    fill: "#836664"
  })), _path2999 || (_path2999 = /*#__PURE__*/React.createElement("path", {
    d: "M93 53v1h-1v-1z",
    fill: "#472122"
  })), _path3000 || (_path3000 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54h-1v-1h1z",
    fill: "#593f41"
  })), _path3001 || (_path3001 = /*#__PURE__*/React.createElement("path", {
    d: "M94 53h1v1h-1z",
    fill: "#836967"
  })), _path3002 || (_path3002 = /*#__PURE__*/React.createElement("path", {
    d: "M95 53h1v1h-1z",
    fill: "#b3a099"
  })), _path3003 || (_path3003 = /*#__PURE__*/React.createElement("path", {
    d: "M96 53h1v1h-1z",
    fill: "#72443f"
  })), _path3004 || (_path3004 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v-1h1v1z",
    fill: "#681918"
  })), _path3005 || (_path3005 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53v1h-1v-1z",
    fill: "#511215"
  })), _path3006 || (_path3006 = /*#__PURE__*/React.createElement("path", {
    d: "M99 53h1v1h-1z",
    fill: "#965153"
  })), _path3007 || (_path3007 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v-1h1v1z",
    fill: "#c57975"
  })), _path3008 || (_path3008 = /*#__PURE__*/React.createElement("path", {
    d: "M102 53v1h-1v-1z",
    fill: "#8b3739"
  })), _path3009 || (_path3009 = /*#__PURE__*/React.createElement("path", {
    d: "M102 54v-1h1v1z",
    fill: "#70594d",
    fillOpacity: 0.647
  })), _path3010 || (_path3010 = /*#__PURE__*/React.createElement("path", {
    d: "M21 54h1v1h-1z",
    fill: "#d4ffff",
    fillOpacity: 0.024
  })), _path3011 || (_path3011 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55v-1h1v1z",
    fill: "#ccb999",
    fillOpacity: 0.824
  })), _path3012 || (_path3012 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54v1h-1v-1z",
    fill: "#c39c66"
  })), _path3013 || (_path3013 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v-1h1v1z",
    fill: "#c09959"
  })), _path3014 || (_path3014 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55h-1v-1h1z",
    fill: "#b78f6b"
  })), _path3015 || (_path3015 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54v1h-1v-1z",
    fill: "#97716c"
  })), _path3016 || (_path3016 = /*#__PURE__*/React.createElement("path", {
    d: "M27 55v-1h1v1z",
    fill: "#936a63"
  })), _path3017 || (_path3017 = /*#__PURE__*/React.createElement("path", {
    d: "M29 54v1h-1v-1z",
    fill: "#966663"
  })), _path3018 || (_path3018 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55v-1h1v1z",
    fill: "#905e59"
  })), _path3019 || (_path3019 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54v1h-1v-1z",
    fill: "#b16f58"
  })), _path3020 || (_path3020 = /*#__PURE__*/React.createElement("path", {
    d: "M32 54v1h-1v-1z",
    fill: "#b44e37"
  })), _path3021 || (_path3021 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55v-1h1v1z",
    fill: "#981d16"
  })), _path3022 || (_path3022 = /*#__PURE__*/React.createElement("path", {
    d: "M33 54h1v1h-1z",
    fill: "#9f2f1d"
  })), _path3023 || (_path3023 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55h-1v-1h1z",
    fill: "#8f3821"
  })), _path3024 || (_path3024 = /*#__PURE__*/React.createElement("path", {
    d: "M35 54h1v1h-1z",
    fill: "#722215"
  })), _path3025 || (_path3025 = /*#__PURE__*/React.createElement("path", {
    d: "M37 55h-1v-1h1z",
    fill: "#6e2c2a"
  })), _path3026 || (_path3026 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55h-1v-1h1z",
    fill: "#6b403f"
  })), _path3027 || (_path3027 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54v1h-1v-1z",
    fill: "#603d3f"
  })), _path3028 || (_path3028 = /*#__PURE__*/React.createElement("path", {
    d: "M39 54h1v1h-1z",
    fill: "#4e2d2d"
  })), _path3029 || (_path3029 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54h1v1h-1z",
    fill: "#301112"
  })), _path3030 || (_path3030 = /*#__PURE__*/React.createElement("path", {
    d: "M42 54v1h-1v-1z",
    fill: "#2d0b0b"
  })), _path3031 || (_path3031 = /*#__PURE__*/React.createElement("path", {
    d: "M42 55v-1h1v1z",
    fill: "#431c20",
    fillOpacity: 0.863
  })), _path3032 || (_path3032 = /*#__PURE__*/React.createElement("path", {
    d: "M44 54v1h-1v-1z",
    fill: "#6a6a6a",
    fillOpacity: 0.047
  })), _path3033 || (_path3033 = /*#__PURE__*/React.createElement("path", {
    d: "M73 55v-1h1v1z",
    fill: "#c8aa9a",
    fillOpacity: 0.129
  })), _path3034 || (_path3034 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54v1h-1v-1z",
    fill: "#4a362e",
    fillOpacity: 0.949
  })), _path3035 || (_path3035 = /*#__PURE__*/React.createElement("path", {
    d: "M75 54h1v1h-1z",
    fill: "#2a2f2e"
  })), _path3036 || (_path3036 = /*#__PURE__*/React.createElement("path", {
    d: "M76 54h1v1h-1z",
    fill: "#333636"
  })), _path3037 || (_path3037 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54v1h-1v-1z",
    fill: "#413e35"
  })), _path3038 || (_path3038 = /*#__PURE__*/React.createElement("path", {
    d: "M78 54h1v1h-1z",
    fill: "#71685c"
  })), _path3039 || (_path3039 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h-1v-1h1z",
    fill: "#a39a8b"
  })), _path3040 || (_path3040 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55v-1h1v1z",
    fill: "#c7bbaa"
  })), _path3041 || (_path3041 = /*#__PURE__*/React.createElement("path", {
    d: "M81 55v-1h1v1z",
    fill: "#d5c8bd"
  })), _path3042 || (_path3042 = /*#__PURE__*/React.createElement("path", {
    d: "M82 54h1v1h-1z",
    fill: "#e3d7ca"
  })), _path3043 || (_path3043 = /*#__PURE__*/React.createElement("path", {
    d: "M83 54h1v1h-1z",
    fill: "#ead8ce"
  })), _path3044 || (_path3044 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54v1h-1v-1z",
    fill: "#fbf0e2"
  })), _path3045 || (_path3045 = /*#__PURE__*/React.createElement("path", {
    d: "M85 54h1v1h-1z",
    fill: "#fae8db"
  })), _path3046 || (_path3046 = /*#__PURE__*/React.createElement("path", {
    d: "M87 54v1h-1v-1z",
    fill: "#b79b91"
  })), _path3047 || (_path3047 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54v1h-1v-1z",
    fill: "#b08a83"
  })), _path3048 || (_path3048 = /*#__PURE__*/React.createElement("path", {
    d: "M88 54h1v1h-1z",
    fill: "#c7ada4"
  })), _path3049 || (_path3049 = /*#__PURE__*/React.createElement("path", {
    d: "M90 55h-1v-1h1z",
    fill: "#b29083"
  })), _path3050 || (_path3050 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h-1v-1h1z",
    fill: "#a67970"
  })), _path3051 || (_path3051 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54v1h-1v-1z",
    fill: "#8a6659"
  })), _path3052 || (_path3052 = /*#__PURE__*/React.createElement("path", {
    d: "M92 54h1v1h-1z",
    fill: "#ac8b81"
  })), _path3053 || (_path3053 = /*#__PURE__*/React.createElement("path", {
    d: "M94 54v1h-1v-1z",
    fill: "#cbaaa1"
  })), _path3054 || (_path3054 = /*#__PURE__*/React.createElement("path", {
    d: "M94 55v-1h1v1z",
    fill: "#bf9d8f"
  })), _path3055 || (_path3055 = /*#__PURE__*/React.createElement("path", {
    d: "M95 54h1v1h-1z",
    fill: "#aa8576"
  })), _path3056 || (_path3056 = /*#__PURE__*/React.createElement("path", {
    d: "M97 54v1h-1v-1z",
    fill: "#6a493b"
  })), _path3057 || (_path3057 = /*#__PURE__*/React.createElement("path", {
    d: "M97 55v-1h1v1z",
    fill: "#531b19"
  })), _path3058 || (_path3058 = /*#__PURE__*/React.createElement("path", {
    d: "M99 55h-1v-1h1z",
    fill: "#6a2123"
  })), _path3059 || (_path3059 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54v1h-1v-1z",
    fill: "#a6615f"
  })), _path3060 || (_path3060 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h-1v-1h1z",
    fill: "#ae7373"
  })), _path3061 || (_path3061 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55v-1h1v1z",
    fill: "#492725"
  })), _path3062 || (_path3062 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55h-1v-1h1z",
    fill: "#6e6a5b",
    fillOpacity: 0.6
  })), _path3063 || (_path3063 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55h1v1h-1z",
    fill: "#bb9f63",
    fillOpacity: 0.522
  })), _path3064 || (_path3064 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55v1h-1v-1z",
    fill: "#c28638"
  })), _path3065 || (_path3065 = /*#__PURE__*/React.createElement("path", {
    d: "M24 55h1v1h-1z",
    fill: "#bd8740"
  })), _path3066 || (_path3066 = /*#__PURE__*/React.createElement("path", {
    d: "M26 55v1h-1v-1z",
    fill: "#b07d5b"
  })), _path3067 || (_path3067 = /*#__PURE__*/React.createElement("path", {
    d: "M26 56v-1h1v1z",
    fill: "#8b5d5a"
  })), _path3068 || (_path3068 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v-1h1v1z",
    fill: "#92625c"
  })), _path3069 || (_path3069 = /*#__PURE__*/React.createElement("path", {
    d: "M28 55h1v1h-1z",
    fill: "#a15c5c"
  })), _path3070 || (_path3070 = /*#__PURE__*/React.createElement("path", {
    d: "M29 55h1v1h-1z",
    fill: "#a55354"
  })), _path3071 || (_path3071 = /*#__PURE__*/React.createElement("path", {
    d: "M31 55v1h-1v-1z",
    fill: "#b45848"
  })), _path3072 || (_path3072 = /*#__PURE__*/React.createElement("path", {
    d: "M32 56h-1v-1h1z",
    fill: "#ac4c2f"
  })), _path3073 || (_path3073 = /*#__PURE__*/React.createElement("path", {
    d: "M33 55v1h-1v-1z",
    fill: "#a74024"
  })), _path3074 || (_path3074 = /*#__PURE__*/React.createElement("path", {
    d: "M34 56h-1v-1h1z",
    fill: "#aa654f"
  })), _path3075 || (_path3075 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56h-1v-1h1z",
    fill: "#9a7170"
  })), _path3076 || (_path3076 = /*#__PURE__*/React.createElement("path", {
    d: "M35 56v-1h1v1z",
    fill: "#8e585a"
  })), _path3077 || (_path3077 = /*#__PURE__*/React.createElement("path", {
    d: "M37 56h-1v-1h1z",
    fill: "#8d6262"
  })), _path3078 || (_path3078 = /*#__PURE__*/React.createElement("path", {
    d: "M38 55v1h-1v-1z",
    fill: "#613536"
  })), _path3079 || (_path3079 = /*#__PURE__*/React.createElement("path", {
    d: "M38 56v-1h1v1z",
    fill: "#411213"
  })), _path3080 || (_path3080 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h-1v-1h1z",
    fill: "#3e1617"
  })), _path3081 || (_path3081 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56v-1h1v1z",
    fill: "#270808"
  })), _path3082 || (_path3082 = /*#__PURE__*/React.createElement("path", {
    d: "M43 56h-1v-1h1z",
    fill: "#331417",
    fillOpacity: 0.549
  })), _path3083 || (_path3083 = /*#__PURE__*/React.createElement("path", {
    d: "M74 55v1h-1v-1z",
    fill: "#ccb2a5",
    fillOpacity: 0.078
  })), _path3084 || (_path3084 = /*#__PURE__*/React.createElement("path", {
    d: "M74 56v-1h1v1z",
    fill: "#784b3e",
    fillOpacity: 0.906
  })), _path3085 || (_path3085 = /*#__PURE__*/React.createElement("path", {
    d: "M76 55v1h-1v-1z",
    fill: "#5b3f36"
  })), _path3086 || (_path3086 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56v-1h1v1z",
    fill: "#3c3a38"
  })), _path3087 || (_path3087 = /*#__PURE__*/React.createElement("path", {
    d: "M78 55v1h-1v-1z",
    fill: "#323a38"
  })), _path3088 || (_path3088 = /*#__PURE__*/React.createElement("path", {
    d: "M79 55v1h-1v-1z",
    fill: "#434b4f"
  })), _path3089 || (_path3089 = /*#__PURE__*/React.createElement("path", {
    d: "M79 56v-1h1v1z",
    fill: "#626259"
  })), _path3090 || (_path3090 = /*#__PURE__*/React.createElement("path", {
    d: "M80 55h1v1h-1z",
    fill: "#9c997a"
  })), _path3091 || (_path3091 = /*#__PURE__*/React.createElement("path", {
    d: "M82 55v1h-1v-1z",
    fill: "#7a7562"
  })), _path3092 || (_path3092 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56h-1v-1h1z",
    fill: "#837863"
  })), _path3093 || (_path3093 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55v1h-1v-1z",
    fill: "#9a8a68"
  })), _path3094 || (_path3094 = /*#__PURE__*/React.createElement("path", {
    d: "M85 55v1h-1v-1z",
    fill: "#827560"
  })), _path3095 || (_path3095 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55v1h-1v-1z",
    fill: "#7d6b55"
  })), _path3096 || (_path3096 = /*#__PURE__*/React.createElement("path", {
    d: "M86 55h1v1h-1z",
    fill: "#ae906c"
  })), _path3097 || (_path3097 = /*#__PURE__*/React.createElement("path", {
    d: "M87 55h1v1h-1z",
    fill: "#9a8064"
  })), _path3098 || (_path3098 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v-1h1v1z",
    fill: "#9b7c67"
  })), _path3099 || (_path3099 = /*#__PURE__*/React.createElement("path", {
    d: "M90 56h-1v-1h1z",
    fill: "#896954"
  })), _path3100 || (_path3100 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55v1h-1v-1z",
    fill: "#886450"
  })), _path3101 || (_path3101 = /*#__PURE__*/React.createElement("path", {
    d: "M91 55h1v1h-1z",
    fill: "#705343"
  })), _path3102 || (_path3102 = /*#__PURE__*/React.createElement("path", {
    d: "M92 55h1v1h-1z",
    fill: "#624535"
  })), _path3103 || (_path3103 = /*#__PURE__*/React.createElement("path", {
    d: "M93 55h1v1h-1z",
    fill: "#40281e"
  })), _path3104 || (_path3104 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56h-1v-1h1z",
    fill: "#473524"
  })), _path3105 || (_path3105 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55v1h-1v-1z",
    fill: "#403526"
  })), _path3106 || (_path3106 = /*#__PURE__*/React.createElement("path", {
    d: "M96 55h1v1h-1z",
    fill: "#100a0a"
  })), _path3107 || (_path3107 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v-1h1v1z",
    fill: "#121114"
  })), _path3108 || (_path3108 = /*#__PURE__*/React.createElement("path", {
    d: "M98 56v-1h1v1z",
    fill: "#29191a"
  })), _path3109 || (_path3109 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55v1h-1v-1z",
    fill: "#796268"
  })), _path3110 || (_path3110 = /*#__PURE__*/React.createElement("path", {
    d: "M100 55h1v1h-1z",
    fill: "#675c5c"
  })), _path3111 || (_path3111 = /*#__PURE__*/React.createElement("path", {
    d: "M101 55h1v1h-1z",
    fill: "#4d352b"
  })), _path3112 || (_path3112 = /*#__PURE__*/React.createElement("path", {
    d: "M103 55v1h-1v-1z",
    fill: "#937c67",
    fillOpacity: 0.522
  })), _path3113 || (_path3113 = /*#__PURE__*/React.createElement("path", {
    d: "M22 56h1v1h-1z",
    fill: "#a37f5b",
    fillOpacity: 0.055
  })), _path3114 || (_path3114 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h-1v-1h1z",
    fill: "#9d7b4c",
    fillOpacity: 0.576
  })), _path3115 || (_path3115 = /*#__PURE__*/React.createElement("path", {
    d: "M25 57h-1v-1h1z",
    fill: "#844c2d",
    fillOpacity: 0.953
  })), _path3116 || (_path3116 = /*#__PURE__*/React.createElement("path", {
    d: "M25 56h1v1h-1z",
    fill: "#9f4a41"
  })), _path3117 || (_path3117 = /*#__PURE__*/React.createElement("path", {
    d: "M27 56v1h-1v-1z",
    fill: "#bb6460"
  })), _path3118 || (_path3118 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h-1v-1h1z",
    fill: "#b3635c"
  })), _path3119 || (_path3119 = /*#__PURE__*/React.createElement("path", {
    d: "M28 56h1v1h-1z",
    fill: "#af5c58"
  })), _path3120 || (_path3120 = /*#__PURE__*/React.createElement("path", {
    d: "M30 56v1h-1v-1z",
    fill: "#a95452"
  })), _path3121 || (_path3121 = /*#__PURE__*/React.createElement("path", {
    d: "M30 57v-1h1v1z",
    fill: "#b46249"
  })), _path3122 || (_path3122 = /*#__PURE__*/React.createElement("path", {
    d: "M31 56h1v1h-1z",
    fill: "#b25533"
  })), _path3123 || (_path3123 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57v-1h1v1z",
    fill: "#8d2621"
  })), _path3124 || (_path3124 = /*#__PURE__*/React.createElement("path", {
    d: "M33 56h1v1h-1z",
    fill: "#9e5e60"
  })), _path3125 || (_path3125 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v-1h1v1z",
    fill: "#a17375"
  })), _path3126 || (_path3126 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56v1h-1v-1z",
    fill: "#833f41"
  })), _path3127 || (_path3127 = /*#__PURE__*/React.createElement("path", {
    d: "M36 56h1v1h-1z",
    fill: "#5c0f10"
  })), _path3128 || (_path3128 = /*#__PURE__*/React.createElement("path", {
    d: "M39 56v1h-1v-1z",
    fill: "#42090c"
  })), _path3129 || (_path3129 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57v-1h1v1z",
    fill: "#2e080a",
    fillOpacity: 0.992
  })), _path3130 || (_path3130 = /*#__PURE__*/React.createElement("path", {
    d: "M40 56h1v1h-1z",
    fill: "#1e0607",
    fillOpacity: 0.796
  })), _path3131 || (_path3131 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57h-1v-1h1z",
    fill: "#1b0c0c",
    fillOpacity: 0.404
  })), _path3132 || (_path3132 = /*#__PURE__*/React.createElement("path", {
    d: "M42 57v-1h1v1z",
    fillOpacity: 0.035
  })), _path3133 || (_path3133 = /*#__PURE__*/React.createElement("path", {
    d: "M74 57h-1v-1h1z",
    fill: "#e9d4bf",
    fillOpacity: 0.047
  })), _path3134 || (_path3134 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57h-1v-1h1z",
    fill: "#7b3637",
    fillOpacity: 0.867
  })), _path3135 || (_path3135 = /*#__PURE__*/React.createElement("path", {
    d: "M76 57h-1v-1h1z",
    fill: "#783337"
  })), _path3136 || (_path3136 = /*#__PURE__*/React.createElement("path", {
    d: "M76 56h1v1h-1z",
    fill: "#814e4b"
  })), _path3137 || (_path3137 = /*#__PURE__*/React.createElement("path", {
    d: "M78 56v1h-1v-1z",
    fill: "#644a3c"
  })), _path3138 || (_path3138 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57v-1h1v1z",
    fill: "#5c554e"
  })), _path3139 || (_path3139 = /*#__PURE__*/React.createElement("path", {
    d: "M80 56v1h-1v-1z",
    fill: "#676657"
  })), _path3140 || (_path3140 = /*#__PURE__*/React.createElement("path", {
    d: "M81 57h-1v-1h1z",
    fill: "#a3a787"
  })), _path3141 || (_path3141 = /*#__PURE__*/React.createElement("path", {
    d: "M81 56h1v1h-1z",
    fill: "#a8ab8e"
  })), _path3142 || (_path3142 = /*#__PURE__*/React.createElement("path", {
    d: "M83 56v1h-1v-1z",
    fill: "#848463"
  })), _path3143 || (_path3143 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57v-1h1v1z",
    fill: "#c9ca99"
  })), _path3144 || (_path3144 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h-1v-1h1z",
    fill: "#444541"
  })), _path3145 || (_path3145 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57v-1h1v1z",
    fill: "#3f462e"
  })), _path3146 || (_path3146 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57h-1v-1h1z",
    fill: "#a8a66b"
  })), _path3147 || (_path3147 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56v1h-1v-1z",
    fill: "#3b331b"
  })), _path3148 || (_path3148 = /*#__PURE__*/React.createElement("path", {
    d: "M88 56h1v1h-1z",
    fill: "#b4ab5d"
  })), _path3149 || (_path3149 = /*#__PURE__*/React.createElement("path", {
    d: "M89 56h1v1h-1z",
    fill: "#4e4c2b"
  })), _path3150 || (_path3150 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57v-1h1v1z",
    fill: "#92905b"
  })), _path3151 || (_path3151 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57h-1v-1h1z",
    fill: "#393620"
  })), _path3152 || (_path3152 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v-1h1v1z",
    fill: "#9e9a51"
  })), _path3153 || (_path3153 = /*#__PURE__*/React.createElement("path", {
    d: "M93 56h1v1h-1z",
    fill: "#4e4c2a"
  })), _path3154 || (_path3154 = /*#__PURE__*/React.createElement("path", {
    d: "M95 56v1h-1v-1z",
    fill: "#c6bc70"
  })), _path3155 || (_path3155 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57h-1v-1h1z",
    fill: "#888657"
  })), _path3156 || (_path3156 = /*#__PURE__*/React.createElement("path", {
    d: "M97 56v1h-1v-1z",
    fill: "#030c0d"
  })), _path3157 || (_path3157 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57v-1h1v1z",
    fill: "#141212"
  })), _path3158 || (_path3158 = /*#__PURE__*/React.createElement("path", {
    d: "M99 57h-1v-1h1z",
    fill: "#22201b"
  })), _path3159 || (_path3159 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56v1h-1v-1z",
    fill: "#7b7471"
  })), _path3160 || (_path3160 = /*#__PURE__*/React.createElement("path", {
    d: "M100 56h1v1h-1z",
    fill: "#835d5a"
  })), _path3161 || (_path3161 = /*#__PURE__*/React.createElement("path", {
    d: "M102 57h-1v-1h1z",
    fill: "#6c382f"
  })), _path3162 || (_path3162 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57h-1v-1h1z",
    fill: "#8a7864",
    fillOpacity: 0.439
  })), _path3163 || (_path3163 = /*#__PURE__*/React.createElement("path", {
    d: "M24 57h1v1h-1z",
    fill: "#4d2126",
    fillOpacity: 0.18
  })), _path3164 || (_path3164 = /*#__PURE__*/React.createElement("path", {
    d: "M26 58h-1v-1h1z",
    fill: "#8a4444",
    fillOpacity: 0.471
  })), _path3165 || (_path3165 = /*#__PURE__*/React.createElement("path", {
    d: "M27 57v1h-1v-1z",
    fill: "#a15554",
    fillOpacity: 0.698
  })), _path3166 || (_path3166 = /*#__PURE__*/React.createElement("path", {
    d: "M28 58h-1v-1h1z",
    fill: "#a65b5b",
    fillOpacity: 0.855
  })), _path3167 || (_path3167 = /*#__PURE__*/React.createElement("path", {
    d: "M28 57h1v1h-1z",
    fill: "#a55755",
    fillOpacity: 0.933
  })), _path3168 || (_path3168 = /*#__PURE__*/React.createElement("path", {
    d: "M29 57h1v1h-1z",
    fill: "#9f4f4d",
    fillOpacity: 0.965
  })), _path3169 || (_path3169 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v-1h1v1z",
    fill: "#98463e",
    fillOpacity: 0.988
  })), _path3170 || (_path3170 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58v-1h1v1z",
    fill: "#8c2929"
  })), _path3171 || (_path3171 = /*#__PURE__*/React.createElement("path", {
    d: "M33 57v1h-1v-1z",
    fill: "#811a1d"
  })), _path3172 || (_path3172 = /*#__PURE__*/React.createElement("path", {
    d: "M34 57v1h-1v-1z",
    fill: "#7d1e1f",
    fillOpacity: 0.996
  })), _path3173 || (_path3173 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58h-1v-1h1z",
    fill: "#6b0e11",
    fillOpacity: 0.98
  })), _path3174 || (_path3174 = /*#__PURE__*/React.createElement("path", {
    d: "M35 58v-1h1v1z",
    fill: "#5f0709",
    fillOpacity: 0.945
  })), _path3175 || (_path3175 = /*#__PURE__*/React.createElement("path", {
    d: "M36 57h1v1h-1z",
    fill: "#530a0b",
    fillOpacity: 0.867
  })), _path3176 || (_path3176 = /*#__PURE__*/React.createElement("path", {
    d: "M38 58h-1v-1h1z",
    fill: "#41080b",
    fillOpacity: 0.702
  })), _path3177 || (_path3177 = /*#__PURE__*/React.createElement("path", {
    d: "M39 58h-1v-1h1z",
    fill: "#30080a",
    fillOpacity: 0.494
  })), _path3178 || (_path3178 = /*#__PURE__*/React.createElement("path", {
    d: "M39 57h1v1h-1z",
    fill: "#220808",
    fillOpacity: 0.235
  })), _path3179 || (_path3179 = /*#__PURE__*/React.createElement("path", {
    d: "M40 57h1v1h-1z",
    fillOpacity: 0.027
  })), _path3180 || (_path3180 = /*#__PURE__*/React.createElement("path", {
    d: "M75 57v1h-1v-1z",
    fill: "#713037",
    fillOpacity: 0.741
  })), _path3181 || (_path3181 = /*#__PURE__*/React.createElement("path", {
    d: "M75 58v-1h1v1z",
    fill: "#512229"
  })), _path3182 || (_path3182 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v-1h1v1z",
    fill: "#6b2b33"
  })), _path3183 || (_path3183 = /*#__PURE__*/React.createElement("path", {
    d: "M77 58v-1h1v1z",
    fill: "#8b353b"
  })), _path3184 || (_path3184 = /*#__PURE__*/React.createElement("path", {
    d: "M78 57h1v1h-1z",
    fill: "#9b5859"
  })), _path3185 || (_path3185 = /*#__PURE__*/React.createElement("path", {
    d: "M79 58v-1h1v1z",
    fill: "#9b6c63"
  })), _path3186 || (_path3186 = /*#__PURE__*/React.createElement("path", {
    d: "M80 57h1v1h-1z",
    fill: "#9e7d66"
  })), _path3187 || (_path3187 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58v-1h1v1z",
    fill: "#9c876e"
  })), _path3188 || (_path3188 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58h-1v-1h1z",
    fill: "#978971"
  })), _path3189 || (_path3189 = /*#__PURE__*/React.createElement("path", {
    d: "M83 57h1v1h-1z",
    fill: "#bfb88e"
  })), _path3190 || (_path3190 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58v-1h1v1z",
    fill: "#565346"
  })), _path3191 || (_path3191 = /*#__PURE__*/React.createElement("path", {
    d: "M85 57h1v1h-1z",
    fill: "#46402e"
  })), _path3192 || (_path3192 = /*#__PURE__*/React.createElement("path", {
    d: "M87 57v1h-1v-1z",
    fill: "#a6a36b"
  })), _path3193 || (_path3193 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h-1v-1h1z",
    fill: "#464529"
  })), _path3194 || (_path3194 = /*#__PURE__*/React.createElement("path", {
    d: "M89 57v1h-1v-1z",
    fill: "#d6d177"
  })), _path3195 || (_path3195 = /*#__PURE__*/React.createElement("path", {
    d: "M89 58v-1h1v1z",
    fill: "#5d5a33"
  })), _path3196 || (_path3196 = /*#__PURE__*/React.createElement("path", {
    d: "M91 57v1h-1v-1z",
    fill: "#aca469"
  })), _path3197 || (_path3197 = /*#__PURE__*/React.createElement("path", {
    d: "M92 57v1h-1v-1z",
    fill: "#594f35"
  })), _path3198 || (_path3198 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58v-1h1v1z",
    fill: "#b3a85e"
  })), _path3199 || (_path3199 = /*#__PURE__*/React.createElement("path", {
    d: "M94 57v1h-1v-1z",
    fill: "#655b34"
  })), _path3200 || (_path3200 = /*#__PURE__*/React.createElement("path", {
    d: "M95 58h-1v-1h1z",
    fill: "#6f5f3f"
  })), _path3201 || (_path3201 = /*#__PURE__*/React.createElement("path", {
    d: "M96 57v1h-1v-1z",
    fill: "#5e4632"
  })), _path3202 || (_path3202 = /*#__PURE__*/React.createElement("path", {
    d: "M96 58v-1h1v1z",
    fill: "#391e16"
  })), _path3203 || (_path3203 = /*#__PURE__*/React.createElement("path", {
    d: "M97 57h1v1h-1z",
    fill: "#4f261f"
  })), _path3204 || (_path3204 = /*#__PURE__*/React.createElement("path", {
    d: "M99 58h-1v-1h1z",
    fill: "#65302f"
  })), _path3205 || (_path3205 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58h-1v-1h1z",
    fill: "#a3777d"
  })), _path3206 || (_path3206 = /*#__PURE__*/React.createElement("path", {
    d: "M101 57v1h-1v-1z",
    fill: "#72404d"
  })), _path3207 || (_path3207 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58v-1h1v1z",
    fill: "#673938"
  })), _path3208 || (_path3208 = /*#__PURE__*/React.createElement("path", {
    d: "M103 57v1h-1v-1z",
    fill: "#8a7c61",
    fillOpacity: 0.369
  })), _path3209 || (_path3209 = /*#__PURE__*/React.createElement("path", {
    d: "M27 58h1v1h-1z",
    fill: "#3f2a3f",
    fillOpacity: 0.047
  })), _path3210 || (_path3210 = /*#__PURE__*/React.createElement("path", {
    d: "M29 59h-1v-1h1z",
    fill: "#744",
    fillOpacity: 0.118
  })), _path3211 || (_path3211 = /*#__PURE__*/React.createElement("path", {
    d: "M30 58v1h-1v-1z",
    fill: "#794248",
    fillOpacity: 0.165
  })), _path3212 || (_path3212 = /*#__PURE__*/React.createElement("path", {
    d: "M30 59v-1h1v1z",
    fill: "#71333d",
    fillOpacity: 0.212
  })), _path3213 || (_path3213 = /*#__PURE__*/React.createElement("path", {
    d: "M31 58h1v1h-1z",
    fill: "#622029",
    fillOpacity: 0.243
  })), _path3214 || (_path3214 = /*#__PURE__*/React.createElement("path", {
    d: "M33 58v1h-1v-1z",
    fill: "#5a1b1b",
    fillOpacity: 0.255
  })), _path3215 || (_path3215 = /*#__PURE__*/React.createElement("path", {
    d: "M34 59h-1v-1h1z",
    fill: "#560c0c",
    fillOpacity: 0.231
  })), _path3216 || (_path3216 = /*#__PURE__*/React.createElement("path", {
    d: "M35 59h-1v-1h1z",
    fill: "#4e0f0f",
    fillOpacity: 0.192
  })), _path3217 || (_path3217 = /*#__PURE__*/React.createElement("path", {
    d: "M36 59h-1v-1h1z",
    fill: "#430f0f",
    fillOpacity: 0.133
  })), _path3218 || (_path3218 = /*#__PURE__*/React.createElement("path", {
    d: "M36 58h1v1h-1z",
    fill: "#241212",
    fillOpacity: 0.055
  })), _path3219 || (_path3219 = /*#__PURE__*/React.createElement("path", {
    d: "M74 58h1v1h-1z",
    fill: "#602c34",
    fillOpacity: 0.498
  })), _path3220 || (_path3220 = /*#__PURE__*/React.createElement("path", {
    d: "M76 58v1h-1v-1z",
    fill: "#54262b"
  })), _path3221 || (_path3221 = /*#__PURE__*/React.createElement("path", {
    d: "M76 59v-1h1v1z",
    fill: "#56282b"
  })), _path3222 || (_path3222 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59h-1v-1h1z",
    fill: "#792837"
  })), _path3223 || (_path3223 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v-1h1v1z",
    fill: "#89414b"
  })), _path3224 || (_path3224 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h-1v-1h1z",
    fill: "#985461"
  })), _path3225 || (_path3225 = /*#__PURE__*/React.createElement("path", {
    d: "M80 58h1v1h-1z",
    fill: "#9c5b60"
  })), _path3226 || (_path3226 = /*#__PURE__*/React.createElement("path", {
    d: "M81 58h1v1h-1z",
    fill: "#b18071"
  })), _path3227 || (_path3227 = /*#__PURE__*/React.createElement("path", {
    d: "M83 58v1h-1v-1z",
    fill: "#986a5f"
  })), _path3228 || (_path3228 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v-1h1v1z",
    fill: "#95624e"
  })), _path3229 || (_path3229 = /*#__PURE__*/React.createElement("path", {
    d: "M84 58h1v1h-1z",
    fill: "#8b564b"
  })), _path3230 || (_path3230 = /*#__PURE__*/React.createElement("path", {
    d: "M86 59h-1v-1h1z",
    fill: "#763e32"
  })), _path3231 || (_path3231 = /*#__PURE__*/React.createElement("path", {
    d: "M86 58h1v1h-1z",
    fill: "#723f2e"
  })), _path3232 || (_path3232 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58v1h-1v-1z",
    fill: "#66372b"
  })), _path3233 || (_path3233 = /*#__PURE__*/React.createElement("path", {
    d: "M88 58h1v1h-1z",
    fill: "#6c3a2c"
  })), _path3234 || (_path3234 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h-1v-1h1z",
    fill: "#602f21"
  })), _path3235 || (_path3235 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59v-1h1v1z",
    fill: "#633a27"
  })), _path3236 || (_path3236 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59h-1v-1h1z",
    fill: "#563024"
  })), _path3237 || (_path3237 = /*#__PURE__*/React.createElement("path", {
    d: "M92 58h1v1h-1z",
    fill: "#532419"
  })), _path3238 || (_path3238 = /*#__PURE__*/React.createElement("path", {
    d: "M93 59v-1h1v1z",
    fill: "#4b1e0f"
  })), _path3239 || (_path3239 = /*#__PURE__*/React.createElement("path", {
    d: "M94 58h1v1h-1z",
    fill: "#431812"
  })), _path3240 || (_path3240 = /*#__PURE__*/React.createElement("path", {
    d: "M95 59v-1h1v1z",
    fill: "#461418"
  })), _path3241 || (_path3241 = /*#__PURE__*/React.createElement("path", {
    d: "M97 58v1h-1v-1z",
    fill: "#4c141a"
  })), _path3242 || (_path3242 = /*#__PURE__*/React.createElement("path", {
    d: "M97 59v-1h1v1z",
    fill: "#471316"
  })), _path3243 || (_path3243 = /*#__PURE__*/React.createElement("path", {
    d: "M98 58h1v1h-1z",
    fill: "#5b2531"
  })), _path3244 || (_path3244 = /*#__PURE__*/React.createElement("path", {
    d: "M100 58v1h-1v-1z",
    fill: "#9a7179"
  })), _path3245 || (_path3245 = /*#__PURE__*/React.createElement("path", {
    d: "M100 59v-1h1v1z",
    fill: "#5d353c"
  })), _path3246 || (_path3246 = /*#__PURE__*/React.createElement("path", {
    d: "M101 58h1v1h-1z",
    fill: "#502e2f",
    fillOpacity: 0.988
  })), _path3247 || (_path3247 = /*#__PURE__*/React.createElement("path", {
    d: "M102 58h1v1h-1z",
    fill: "#6e6551",
    fillOpacity: 0.208
  })), _path3248 || (_path3248 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60h-1v-1h1z",
    fill: "#603d46",
    fillOpacity: 0.114
  })), _path3249 || (_path3249 = /*#__PURE__*/React.createElement("path", {
    d: "M75 60v-1h1v1z",
    fill: "#51282e",
    fillOpacity: 0.875
  })), _path3250 || (_path3250 = /*#__PURE__*/React.createElement("path", {
    d: "M77 59v1h-1v-1z",
    fill: "#592129"
  })), _path3251 || (_path3251 = /*#__PURE__*/React.createElement("path", {
    d: "M78 59v1h-1v-1z",
    fill: "#722734"
  })), _path3252 || (_path3252 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60h-1v-1h1z",
    fill: "#823c48"
  })), _path3253 || (_path3253 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59v1h-1v-1z",
    fill: "#915462"
  })), _path3254 || (_path3254 = /*#__PURE__*/React.createElement("path", {
    d: "M80 59h1v1h-1z",
    fill: "#9c6e62"
  })), _path3255 || (_path3255 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v-1h1v1z",
    fill: "#ceb48c"
  })), _path3256 || (_path3256 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59v1h-1v-1z",
    fill: "#ceb284"
  })), _path3257 || (_path3257 = /*#__PURE__*/React.createElement("path", {
    d: "M83 59h1v1h-1z",
    fill: "#c9a37c"
  })), _path3258 || (_path3258 = /*#__PURE__*/React.createElement("path", {
    d: "M85 59v1h-1v-1z",
    fill: "#ab8269"
  })), _path3259 || (_path3259 = /*#__PURE__*/React.createElement("path", {
    d: "M85 60v-1h1v1z",
    fill: "#a57850"
  })), _path3260 || (_path3260 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60h-1v-1h1z",
    fill: "#945f42"
  })), _path3261 || (_path3261 = /*#__PURE__*/React.createElement("path", {
    d: "M87 60v-1h1v1z",
    fill: "#7b4332"
  })), _path3262 || (_path3262 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60h-1v-1h1z",
    fill: "#89563d"
  })), _path3263 || (_path3263 = /*#__PURE__*/React.createElement("path", {
    d: "M89 60v-1h1v1z",
    fill: "#7d4c2e"
  })), _path3264 || (_path3264 = /*#__PURE__*/React.createElement("path", {
    d: "M90 59h1v1h-1z",
    fill: "#885b36"
  })), _path3265 || (_path3265 = /*#__PURE__*/React.createElement("path", {
    d: "M92 59v1h-1v-1z",
    fill: "#6b3f2a"
  })), _path3266 || (_path3266 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v-1h1v1z",
    fill: "#785136"
  })), _path3267 || (_path3267 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h-1v-1h1z",
    fill: "#9c7a49"
  })), _path3268 || (_path3268 = /*#__PURE__*/React.createElement("path", {
    d: "M95 60h-1v-1h1z",
    fill: "#7c543d"
  })), _path3269 || (_path3269 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h-1v-1h1z",
    fill: "#33050b"
  })), _path3270 || (_path3270 = /*#__PURE__*/React.createElement("path", {
    d: "M97 60h-1v-1h1z",
    fill: "#3c0d16"
  })), _path3271 || (_path3271 = /*#__PURE__*/React.createElement("path", {
    d: "M98 59v1h-1v-1z",
    fill: "#401114"
  })), _path3272 || (_path3272 = /*#__PURE__*/React.createElement("path", {
    d: "M99 59v1h-1v-1z",
    fill: "#582a31"
  })), _path3273 || (_path3273 = /*#__PURE__*/React.createElement("path", {
    d: "M100 60h-1v-1h1z",
    fill: "#8d7072"
  })), _path3274 || (_path3274 = /*#__PURE__*/React.createElement("path", {
    d: "M101 59v1h-1v-1z",
    fill: "#4a2d31"
  })), _path3275 || (_path3275 = /*#__PURE__*/React.createElement("path", {
    d: "M102 60h-1v-1h1z",
    fill: "#38161f",
    fillOpacity: 0.784
  })), _path3276 || (_path3276 = /*#__PURE__*/React.createElement("path", {
    d: "M103 60h-1v-1h1z",
    fillOpacity: 0.031
  })), _path3277 || (_path3277 = /*#__PURE__*/React.createElement("path", {
    d: "M76 60v1h-1v-1z",
    fill: "#51303b",
    fillOpacity: 0.184
  })), _path3278 || (_path3278 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61v-1h1v1z",
    fill: "#59232f",
    fillOpacity: 0.729
  })), _path3279 || (_path3279 = /*#__PURE__*/React.createElement("path", {
    d: "M78 61h-1v-1h1z",
    fill: "#6c2232"
  })), _path3280 || (_path3280 = /*#__PURE__*/React.createElement("path", {
    d: "M79 60v1h-1v-1z",
    fill: "#8a3b4e"
  })), _path3281 || (_path3281 = /*#__PURE__*/React.createElement("path", {
    d: "M80 60v1h-1v-1z",
    fill: "#91515d"
  })), _path3282 || (_path3282 = /*#__PURE__*/React.createElement("path", {
    d: "M81 60v1h-1v-1z",
    fill: "#be9479"
  })), _path3283 || (_path3283 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v-1h1v1z",
    fill: "#d4b888"
  })), _path3284 || (_path3284 = /*#__PURE__*/React.createElement("path", {
    d: "M83 61h-1v-1h1z",
    fill: "#c9a87b"
  })), _path3285 || (_path3285 = /*#__PURE__*/React.createElement("path", {
    d: "M83 60h1v1h-1z",
    fill: "#c9aa79"
  })), _path3286 || (_path3286 = /*#__PURE__*/React.createElement("path", {
    d: "M84 61v-1h1v1z",
    fill: "#bb9771"
  })), _path3287 || (_path3287 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h-1v-1h1z",
    fill: "#9e7658"
  })), _path3288 || (_path3288 = /*#__PURE__*/React.createElement("path", {
    d: "M86 60h1v1h-1z",
    fill: "#ab8452"
  })), _path3289 || (_path3289 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61h-1v-1h1z",
    fill: "#8d6445"
  })), _path3290 || (_path3290 = /*#__PURE__*/React.createElement("path", {
    d: "M88 60h1v1h-1z",
    fill: "#997746"
  })), _path3291 || (_path3291 = /*#__PURE__*/React.createElement("path", {
    d: "M90 61h-1v-1h1z",
    fill: "#a7864c"
  })), _path3292 || (_path3292 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h-1v-1h1z",
    fill: "#9c7d47"
  })), _path3293 || (_path3293 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60v1h-1v-1z",
    fill: "#7f603d"
  })), _path3294 || (_path3294 = /*#__PURE__*/React.createElement("path", {
    d: "M92 60h1v1h-1z",
    fill: "#90763f"
  })), _path3295 || (_path3295 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61v-1h1v1z",
    fill: "#90733e"
  })), _path3296 || (_path3296 = /*#__PURE__*/React.createElement("path", {
    d: "M94 60h1v1h-1z",
    fill: "#876641"
  })), _path3297 || (_path3297 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v-1h1v1z",
    fill: "#4f261e"
  })), _path3298 || (_path3298 = /*#__PURE__*/React.createElement("path", {
    d: "M96 60h1v1h-1z",
    fill: "#3a0c10"
  })), _path3299 || (_path3299 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h-1v-1h1z",
    fill: "#431117"
  })), _path3300 || (_path3300 = /*#__PURE__*/React.createElement("path", {
    d: "M98 60h1v1h-1z",
    fill: "#572c37"
  })), _path3301 || (_path3301 = /*#__PURE__*/React.createElement("path", {
    d: "M99 60h1v1h-1z",
    fill: "#8f7276"
  })), _path3302 || (_path3302 = /*#__PURE__*/React.createElement("path", {
    d: "M101 61h-1v-1h1z",
    fill: "#4a2b31",
    fillOpacity: 0.847
  })), _path3303 || (_path3303 = /*#__PURE__*/React.createElement("path", {
    d: "M102 61h-1v-1h1z",
    fill: "#35131d",
    fillOpacity: 0.204
  })), _path3304 || (_path3304 = /*#__PURE__*/React.createElement("path", {
    d: "M76 61h1v1h-1z",
    fill: "#050",
    fillOpacity: 0.012
  })), _path3305 || (_path3305 = /*#__PURE__*/React.createElement("path", {
    d: "M77 62v-1h1v1z",
    fill: "#4f202b",
    fillOpacity: 0.278
  })), _path3306 || (_path3306 = /*#__PURE__*/React.createElement("path", {
    d: "M78 62v-1h1v1z",
    fill: "#6b3a45",
    fillOpacity: 0.635
  })), _path3307 || (_path3307 = /*#__PURE__*/React.createElement("path", {
    d: "M80 62h-1v-1h1z",
    fill: "#864e5c",
    fillOpacity: 0.886
  })), _path3308 || (_path3308 = /*#__PURE__*/React.createElement("path", {
    d: "M81 61v1h-1v-1z",
    fill: "#915859"
  })), _path3309 || (_path3309 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62h-1v-1h1z",
    fill: "#a36d67"
  })), _path3310 || (_path3310 = /*#__PURE__*/React.createElement("path", {
    d: "M82 62v-1h1v1z",
    fill: "#ae8175"
  })), _path3311 || (_path3311 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62v-1h1v1z",
    fill: "#ae846a"
  })), _path3312 || (_path3312 = /*#__PURE__*/React.createElement("path", {
    d: "M85 61v1h-1v-1z",
    fill: "#bb956e"
  })), _path3313 || (_path3313 = /*#__PURE__*/React.createElement("path", {
    d: "M86 62h-1v-1h1z",
    fill: "#a47c61"
  })), _path3314 || (_path3314 = /*#__PURE__*/React.createElement("path", {
    d: "M86 61h1v1h-1z",
    fill: "#966e49"
  })), _path3315 || (_path3315 = /*#__PURE__*/React.createElement("path", {
    d: "M88 61v1h-1v-1z",
    fill: "#9f754c"
  })), _path3316 || (_path3316 = /*#__PURE__*/React.createElement("path", {
    d: "M88 62v-1h1v1z",
    fill: "#b5935a"
  })), _path3317 || (_path3317 = /*#__PURE__*/React.createElement("path", {
    d: "M89 61h1v1h-1z",
    fill: "#b89950"
  })), _path3318 || (_path3318 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62v-1h1v1z",
    fill: "#a8844f"
  })), _path3319 || (_path3319 = /*#__PURE__*/React.createElement("path", {
    d: "M91 61h1v1h-1z",
    fill: "#724b33"
  })), _path3320 || (_path3320 = /*#__PURE__*/React.createElement("path", {
    d: "M92 61h1v1h-1z",
    fill: "#8f6d3b"
  })), _path3321 || (_path3321 = /*#__PURE__*/React.createElement("path", {
    d: "M93 61h1v1h-1z",
    fill: "#8b683c"
  })), _path3322 || (_path3322 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61v1h-1v-1z",
    fill: "#775034"
  })), _path3323 || (_path3323 = /*#__PURE__*/React.createElement("path", {
    d: "M95 61h1v1h-1z",
    fill: "#481c17"
  })), _path3324 || (_path3324 = /*#__PURE__*/React.createElement("path", {
    d: "M97 61v1h-1v-1z",
    fill: "#3a0d11"
  })), _path3325 || (_path3325 = /*#__PURE__*/React.createElement("path", {
    d: "M97 62v-1h1v1z",
    fill: "#40121a"
  })), _path3326 || (_path3326 = /*#__PURE__*/React.createElement("path", {
    d: "M98 61h1v1h-1z",
    fill: "#512833",
    fillOpacity: 0.855
  })), _path3327 || (_path3327 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61v1h-1v-1z",
    fill: "#5a4246",
    fillOpacity: 0.498
  })), _path3328 || (_path3328 = /*#__PURE__*/React.createElement("path", {
    d: "M100 61h1v1h-1z",
    fill: "#2c2121",
    fillOpacity: 0.09
  })), _path3329 || (_path3329 = /*#__PURE__*/React.createElement("path", {
    d: "M79 63v-1h1v1z",
    fill: "#3f3333",
    fillOpacity: 0.078
  })), _path3330 || (_path3330 = /*#__PURE__*/React.createElement("path", {
    d: "M80 63v-1h1v1z",
    fill: "#663c43",
    fillOpacity: 0.282
  })), _path3331 || (_path3331 = /*#__PURE__*/React.createElement("path", {
    d: "M81 63v-1h1v1z",
    fill: "#6e464d",
    fillOpacity: 0.514
  })), _path3332 || (_path3332 = /*#__PURE__*/React.createElement("path", {
    d: "M83 63h-1v-1h1z",
    fill: "#744954",
    fillOpacity: 0.71
  })), _path3333 || (_path3333 = /*#__PURE__*/React.createElement("path", {
    d: "M83 62h1v1h-1z",
    fill: "#74434e",
    fillOpacity: 0.831
  })), _path3334 || (_path3334 = /*#__PURE__*/React.createElement("path", {
    d: "M84 63v-1h1v1z",
    fill: "#6d3741",
    fillOpacity: 0.914
  })), _path3335 || (_path3335 = /*#__PURE__*/React.createElement("path", {
    d: "M85 62h1v1h-1z",
    fill: "#723f44",
    fillOpacity: 0.965
  })), _path3336 || (_path3336 = /*#__PURE__*/React.createElement("path", {
    d: "M87 63h-1v-1h1z",
    fill: "#672d36",
    fillOpacity: 0.996
  })), _path3337 || (_path3337 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63h-1v-1h1z",
    fill: "#591a23"
  })), _path3338 || (_path3338 = /*#__PURE__*/React.createElement("path", {
    d: "M89 62v1h-1v-1z",
    fill: "#561d21"
  })), _path3339 || (_path3339 = /*#__PURE__*/React.createElement("path", {
    d: "M90 63h-1v-1h1z",
    fill: "#501918"
  })), _path3340 || (_path3340 = /*#__PURE__*/React.createElement("path", {
    d: "M90 62h1v1h-1z",
    fill: "#451113"
  })), _path3341 || (_path3341 = /*#__PURE__*/React.createElement("path", {
    d: "M92 62v1h-1v-1z",
    fill: "#3a0b12"
  })), _path3342 || (_path3342 = /*#__PURE__*/React.createElement("path", {
    d: "M92 63v-1h1v1z",
    fill: "#31090a",
    fillOpacity: 0.984
  })), _path3343 || (_path3343 = /*#__PURE__*/React.createElement("path", {
    d: "M93 63v-1h1v1z",
    fill: "#2a060a",
    fillOpacity: 0.945
  })), _path3344 || (_path3344 = /*#__PURE__*/React.createElement("path", {
    d: "M94 63v-1h1v1z",
    fill: "#2a060d",
    fillOpacity: 0.878
  })), _path3345 || (_path3345 = /*#__PURE__*/React.createElement("path", {
    d: "M95 62h1v1h-1z",
    fill: "#2c0b0f",
    fillOpacity: 0.757
  })), _path3346 || (_path3346 = /*#__PURE__*/React.createElement("path", {
    d: "M96 63v-1h1v1z",
    fill: "#2c1214",
    fillOpacity: 0.537
  })), _path3347 || (_path3347 = /*#__PURE__*/React.createElement("path", {
    d: "M98 62v1h-1v-1z",
    fill: "#2d181b",
    fillOpacity: 0.286
  })), _path3348 || (_path3348 = /*#__PURE__*/React.createElement("path", {
    d: "M99 62v1h-1v-1z",
    fill: "#2f1f1f",
    fillOpacity: 0.063
  })), _path3349 || (_path3349 = /*#__PURE__*/React.createElement("path", {
    d: "M83 64v-1h1v1z",
    fill: "#383838",
    fillOpacity: 0.035
  })), _path3350 || (_path3350 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64h-1v-1h1z",
    fill: "#51333d",
    fillOpacity: 0.098
  })), _path3351 || (_path3351 = /*#__PURE__*/React.createElement("path", {
    d: "M85 64v-1h1v1z",
    fill: "#4d3541",
    fillOpacity: 0.169
  })), _path3352 || (_path3352 = /*#__PURE__*/React.createElement("path", {
    d: "M86 64v-1h1v1z",
    fill: "#4f323a",
    fillOpacity: 0.239
  })), _path3353 || (_path3353 = /*#__PURE__*/React.createElement("path", {
    d: "M88 63v1h-1v-1z",
    fill: "#3d1b25",
    fillOpacity: 0.294
  })), _path3354 || (_path3354 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64v-1h1v1z",
    fill: "#36151b",
    fillOpacity: 0.329
  })), _path3355 || (_path3355 = /*#__PURE__*/React.createElement("path", {
    d: "M89 63h1v1h-1z",
    fill: "#300f15",
    fillOpacity: 0.333
  })), _path3356 || (_path3356 = /*#__PURE__*/React.createElement("path", {
    d: "M91 64h-1v-1h1z",
    fill: "#2d0d13",
    fillOpacity: 0.306
  })), _path3357 || (_path3357 = /*#__PURE__*/React.createElement("path", {
    d: "M91 63h1v1h-1z",
    fill: "#2d0f16",
    fillOpacity: 0.263
  })), _path3358 || (_path3358 = /*#__PURE__*/React.createElement("path", {
    d: "M93 64h-1v-1h1z",
    fill: "#2b1318",
    fillOpacity: 0.208
  })), _path3359 || (_path3359 = /*#__PURE__*/React.createElement("path", {
    d: "M94 64h-1v-1h1z",
    fill: "#24151d",
    fillOpacity: 0.137
  })), _path3360 || (_path3360 = /*#__PURE__*/React.createElement("path", {
    d: "M95 63v1h-1v-1z",
    fill: "#2d2d2d",
    fillOpacity: 0.067
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCreamContainers);
export default __webpack_public_path__ + "static/media/ice-cream-containers.1bc46f42eb609d213249a72a5b1f93f8.svg";
export { ForwardRef as ReactComponent };